export default {
  common: {
    common_01: '오류가 발생했습니다.',
    all: '전체',
    sold_out: '품절',
    currency: '{{price}}원',
    마플샵: '마플샵',
  },
  crew: {
    authorization: {
      signup_00: '회원가입',
      signup_01: '이메일',
      signup_02: '이름',
      signup_03: '사번',
      signup_04: '이용 약관 동의',
      signup_05: '개인 정보 수집 및 이용 동의',
      signup_06: '개인 정보 제3자 제공 동의',
      signup_07: '만 14세 이상 확인',
      signup_08: '[선택] 이메일 마케팅 수신 동의',
      signup_09: '보기',
      signup_10: '로그인',
      signup_11: '이용약관에 동의해 주세요.',
      signup_12: '개인정보수집 이용에 동의해 주세요.',
      signup_13: '개인정보 제3자 제공에 동의해 주세요.',
      signup_14: '만 14세 이상 가입이 가능합니다.',
      signup_15: '기존 사용자가 존재합니다. 확인바랍니다.',
      signup_17: '인증이 완료되지 않았습니다.',
      signup_18: '소속된 법인은 NBOX 서비스 대상이 아닙니다.',
      signup_18_mobile: '소속된 법인은<br/>NBOX 서비스 대상이 아닙니다.',
    },
    crew_01: '홈으로 가기',
    suspensions: {
      type: {
        copyright: '저작권 침해',
        counterfeit: '위조상품 판매',
        adult_policy_violation: '성인 인증 규정 위반',
        internal_policy_violation: '마플샵 내부 규정 위반',
      },
      user_type: {
        individual: '개인',
        group: '단체',
      },
    },
    solutions: {
      status: {
        answer: '답변 완료',
        not_answer: '답변 대기',
        not_selling: '판매 중지',
        selling: '판매 재개',
        suspension: '샵 운영 중지',
        not_suspension: '샵 정상 운영',
      },
      header: {
        title: '신고 접수',
        description: '내 샵 또는 상품 등에 접수된 신고를 확인할 수 있습니다.',
      },
      table: {
        suspension_reason: {
          copyright: '저작권 침해 {{count}}건',
          counterfeit: '위조상품 판매 {{count}}건',
          adult_policy_violation: '성인 인증 규정 위반 {{count}}건',
          internal_policy_violation: '내부 규정 위반 {{count}}건',
        },
      },
      thread_status: {
        in_progress: '답변 기간이 {{day}}일 남았습니다.',
        re_in_progress: '재요청 기간이 {{day}}일 남았습니다.',
        answer_expiration: '재소 기간 만료 / 스레드 종료',
        end: '스레드 종료',
      },
      form: {
        type: '신고 접수 유형',
        user_type: '권리 침해를 받은 당사자',
        name: '신고 접수자',
        birth: '생년 월일',
        owner: '상표권/디자인권 보유자',
        owner_placeholder: '개인,법인명,단체이름 등을 입력해 주세요.',
        contact: '연락처',
        email: '이메일',
        email_placeholder: '이메일을 입력해주세요',
        email_description:
          '위의 이메일과 연락처로 신고 진행 과정이 전송됩니다. 반드시 정확하게 작성 부탁드립니다.',
        product_url: '신고 상품 URL',
        product_url_placeholder: 'ex) https://marpple.shop/kr/shop_domain/products/12345',
        store_url: '크리에이터샵 URL',
        store_url_placeholder: 'ex) https://marpple.shop/kr/shop_domain',
        product_info: '상품 정보',
        reason: '신고 사유',
        reason_placeholder: '원활한 신고 접수를 위하여 내용을 구체적으로 적어주세요',
        submit: '신고 접수하기',
        thread_submit: '스레드 작성',
        answer: '답변하기',
        file: '첨부파일',
        description: '상세 내용',
        confirm: '신고 접수 후 내용을 수정할 수 없습니다.\n계속 진행하시겠습니까?',
        required_document: '필요 서류',
        required_document_description:
          '상표권/디자인권 및 해당 크리에이터의 침해 사실을 증빙할 수 있는 자료를 첨부 부탁드립니다. (파일크기: 10MB 이하)',
        user_document: '단체 증명 자료',
        user_document_description: '기업/단체인 경우\n접수자가 단체 대표자가 아닌 경우',
      },
      item: {
        report_type: '유형',
        reported_creator: '신고자 대상 크리에이터',
        reported_product_url: '신고 제품 URL',
        report_detail: '신고 상세 내용',
        reportor_email: '신고자 이메일',
      },
    },
  },
  customer_orders: {
    pick_up: '픽업',
    possible_pick_up: '픽업 가능',
    re_purchase: '재구매하기',
    empty_order_desc: '구매하신 상품이 없어요!',
    cannot_purchase: '구매 불가 상품',
    cannot_purchase_desc: '이 상품은 현재 구매할 수 없는 상품입니다.',
  },
  layout: {
    footer1: '(주)마플코퍼레이션',
    footer2: '고객센터',
    footer3: '신고센터',
    footer4: '셀러 신청',
    footer5: '기업 셀러 신청',
    footer6: '개인정보처리방침',
    footer7: '이용약관',
    footer8:
      '크리에이터배송 상품의 경우 (주)마플코퍼레이션은 통신판매중개자로서 통신판매의 당사자가 아니며 상품 거래 및 거래정보에 대하여 책임을 지지 않습니다.',
    footer9: '© 2025 MARPPLE CORP.',
    footer: {
      company_name: '(주)마플코퍼레이션',
      ceo: '대표',
      ceo_name: '박혜윤',
      customer_center: '고객센터',
      customer_center_info: '(평일 10:00 ~ 18:00)',
      company_registration_info: '사업자등록번호',
      company_registration_number: '105-88-13322',
      address: '주소',
      address_info: '서울 금천구 가산디지털1로 75-24 아이에스비즈타워 10층',
      email: '이메일',
      report_center: '신고센터',
      apply_seller: '셀러신청',
      terms_and_conditions: '이용약관',
      privacy_policy: '개인정보처리방침',
      instagram: '인스타그램',
      youtube: '유튜브',
      twitter: '트위터',
      blog: '블로그',
      marpple_corp: '마플코퍼레이션',
      nbox: {
        address: '경기도 성남시 분당구 판교로 256번길 7',
        phone: '전화',
        phone_number: '{{tel}}(평일 10:00 ~ 18:00)',
        company_registration_number: '220-87-17483호',
        ceo_name: '강대현·김정욱',
        footer1: '㈜넥슨코리아',
        footer9: '© NEXON Korea Corporation All Rights Reserved.',
      },
    },
    drawer: {
      menu: {
        review: '리뷰',
        product: '공식 상품',
        home: '홈',
      },
    },
  },
  my_page: {
    my_page_01: '<b>{{name}}</b>님, 반가워요 👋',
    my_account_01: '프로필 이미지',
    my_account_02: '10MB 이내의 이미지 파일을 업로드 해주세요.<br/>(이미지 형식 : JPG, JPEG, PNG)',
    my_account_03: '파일이 없습니다.',
    my_account_04: '로그인이 필요합니다.',
    my_account_05: '파일이 저장되지 않았습니다.',
    my_account_06: '삭제',
    my_account_07: '수정',
    my_account_08: '업로드',
    like_product_01: '좋아요',
    like_product_02: '좋아요한 상품이 없습니다.',
    nick_name: '닉네임',
    save: '변경사항 저장',
    email: '이메일',
    mobile: '휴대폰 번호',
    validation_nickname: '한글, 영문, 숫자만 입력 가능하며, 16bytes까지 등록 가능합니다.',
    agree_email: '광고성 정보 수신 동의',
    view_agree_email: '보기',
    no_email: '등록된 이메일이 없습니다.',
    file_valid_5mb: '5MB 이하의 파일을 업로드해 주세요.',
    file_valid_fail: '파일 업로드가 실패했습니다.',
  },
  order: {
    '배송지 변경': '배송지 변경',
    recipient: '수령인',
  },
  checkout: {
    receipt: {
      receipt_01: '{{nickname}}님! 주문이 완료되었습니다.',
      receipt_01_mobile: '{{nickname}}님!',
      receipt_01_compact: '주문이 완료되었습니다.',
      receipt_02: '지금 바로 다운로드해서 친구들과 공유해 보세요!',
      receipt_02_compact: '특별함을 담아 배송해드려요.<br/>설레는 마음으로 기다려주세요!',
      download_purchase_card: '구매 인증 카드를 다운로드해 보세요.',
    },
  },
  product: {
    sort: {
      최신순: '최신순',
      '리뷰 많은 순': '리뷰 많은 순',
      인기순: '인기순',
      '낮은 가격 순': '낮은 가격 순',
      '높은 가격 순': '높은 가격 순',
    },
    review: {
      count: '상품 리뷰',
      score: '평점',
    },
    n_viewing: {
      normal: '<span>현재</span><span><b>{{n}}</b>명의 팬들이 관심있게 보고 있어요</span><span>👀</span>',
      compact: '{{n}}명이 보는 중',
    },
  },
  plus_admin: {
    plus_admin_01: '테마 선택',
    plus_admin_02: '블랙',
    plus_admin_03: '화이트',
    banner_01: '메인 배너 내용',
    banner_02: '다국어를 지원하며, 입력 시 좌측에서 미리보기가 가능합니다.',
    banner_03: '메인 배너 제목',
    plus_admin_04: '배경 색상 선택',
    popup_store: {
      list_page_title: '팝업스토어 관리',
      detail_page_title: '팝업스토어 관리',
      detail_page_desc:
        '팝업스토어 이미지 권장 사이즈 : 가로 3840px * 세로 2000px / 등록 가능 형식 : JPG, JPEG, PNG, GIF, WEBP / 용량 : 8MB 이하',
    },
  },
  home: {
    plus_home: {
      plus_home_01: '인기 상품',
      plus_home_02: '가장 사랑받는 공식 상품',
      plus_home_03: '늦기 전에 데려가세요!',
      plus_home_04: '바로 지금! 만나야하는 굿즈',
      plus_home_05: '구매한 사람들의 후기가 궁금할 때',
      plus_home_06: '오늘의 리뷰',
      channel_on: 'NBOX 채널 on',
      nbox_hot_item: '지금 주목할 NBOX 핫템',
    },
  },
  community: {
    input: '등록',
    comment_place_holder: '크리에이터를 응원하는 댓글을 남겨주세요.',
    review: '리뷰',
    community_01: '변경사항이 없습니다.',
  },
  cart: {
    title: 'Cart',
  },
  goods_types: {
    mps: '마플샵제작배송',
    pbg: '크리에이터배송',
    tpl: '마플샵배송',
    mps_delivery: '마플샵제작배송',
    pbg_delivery: '크리에이터배송',
    tpl_delivery: '마플샵배송',
    dtg: '디지털/전자책',
    tooltip: {
      mps_title: '마플샵제작배송상품',
      mps_description:
        '마플샵에서 직접 제작하고 배송하는 상품입니다.<br />결제 금액에 상관없이 기본 배송비는 동일하게 청구되며, 도서<br />산간 지역은 추가금액이 발생할 수 있습니다.',
      pbg_title: '크리에이터배송상품',
      pbg_description:
        '크리에이터가 배송하는 상품입니다.<br />크리에이터에 따라 배송비나 소요 기간이 다를 수 있습니다.',
      tpl_title: '마플샵배송상품',
      tpl_description:
        '마플샵에서 직접 배송하는 상품입니다.<br />결제 금액에 상관없이 기본 배송비는 동일하게 청구되며, 도서<br />산간 지역은 추가금액이 발생할 수 있습니다.',
    },
  },
  product_types: {
    custom: '커스텀 주문',
    handmade: '핸드메이드',
    pod: '주문제작',
  },
  shipping_guide: {
    departure_date_info: '배송 출발일 안내',
    departure_date_info_marpple_desc1:
      '마플샵배송 상품과 마플샵제작배송 상품을 함께 주문하면 배송비가 한 번만 부과됩니다.',
    departure_date_info_marpple_desc2:
      '함께 주문한 상품들의 배송출발일이 다를 경우, 가장 늦은 일자에 맞춰 발송됩니다.',
    departure_date_info_marpple_desc3:
      '예약판매(pre-order) 상품은 배송이 지연될 수 있으므로, 다른 상품과 별도로 주문하는 것을 권장합니다.',
  },
  product_detail: {
    tab01: '스토리',
    tab02: '상품 상세',
    tab03: '구매 안내',
    tab04: '리뷰',
    tab05: '팬레터',
    unfold_btn: '상품 상세 더보기',
    fold_btn: '상품 상세 접기',
    left_count: '{{count}}개 남았어요!',
    left_time: '{{time}} 남았어요!',
    coming_soon: '{{time}} 출시예정',
    total_price: '총 상품 금액',
    badges: {
      sold_out: 'Sold out',
      limited: 'Limited',
    },
    recommend_and_fan_letter: {
      recommend_title: '연관 상품',
    },
    purchase_info: {
      th_1: '상호명',
      th_2: '크리에이터명',
      th_3: '사업자 번호',
      th_4: '이메일',
      th_5: '연락처',
      th_6: '환불 배송비(편도)',
      th_7: '보내실 곳',
      th_8: '문의 연락처',
      th_9: '배송 방법',
      th_10: '배송 지역',
      th_11: '배송 기간',
      th_12: '고객 센터',
      th_13: '교환 배송비(왕복)',
      delivery_info: '배송 정보',
      delivery_company: '일반택배({{company}})',
      delivery_desc_mps:
        '모든 상품은 고객님의 주문에 맞춰 새 상품으로 제작하여 배송됩니다.<br/>지금 주문하시면 <span style="color:{{color}};">{{start}}</span>부터 <span style="color:{{color}};">{{end}}</span> 사이에 출고될 예정입니다.',
      delivery_desc_tpl:
        '지금 주문하시면 <span style="color:{{color}};">{{start}}</span>부터 <span style="color:{{color}};">{{end}}</span> 사이에 출고될 예정입니다.<br/>마플샵의 주문 제작 상품과 함께 주문하실 경우, 주문 제작 상품의 출고일에 맞춰 함께 배송됩니다.',
      delivery_period_mps:
        '상품 출고 후 영업일 기준 1~3일 이내 수령이 가능하며 도서 산간 지역이거나<br/>택배사의 물량이 많은 경우 기간이 조금 더 소요될 수 있습니다.',
      delivery_period_tpl:
        '상품 출고 후 영업일 기준 1~3일 이내 수령이 가능하며 도서 산간 지역이거나 택배사의 물량이 많은 경우 기간이 조금 더 소요될 수 있습니다.',
      all_country: '전국',
      delivery_faq_btn: '배송 FAQ 보러가기',
      exchange_info: '교환/환불 정보',
      exchange_desc_mps:
        '모든 마플샵제작배송 상품은 <span style="color:{{color}};">주문 제작 방식</span>으로 제작되어 단순 변심으로 인한 교환/환불이 불가합니다.<br/>단, 수령하신 상품이 불량이거나 오배송된 경우에는 7일 이내 고객센터 또는 이메일, 1:1 문의하기로 연락 주시면 교환 및 반품 환불이 가능합니다',
      exchange_tel: '<a href="tel:{{tel}}">{{tel}}</a>',
      exchange_email: '<a href="mailto:{{email}}">{{email}}</a>',
      exchange_widerrufsrecht_btn: '청약 철회 제한 요건 안내',
      exchange_guarantee_btn: '품질 보증 기준 안내',
      mps_qna_btn: '마플샵에 문의하기',
      qna_btn: '1:1 문의하기',
      exchange_faq_btn: '교환/환불 FAQ',
      report_info: '신고 안내',
      report_desc:
        '마플샵은 크리에이터와 소비자, 저작권 보호를 위해 신고센터를 운영하고 있습니다.<br/>마플샵 내부 규정을 위반하는 크리에이터와 제3자 저작물의 무단 도용 또는 초상권을 침해했다고 판단되는 상품을 신고할 수 있습니다.',
      report_btn: '신고하기',
      creator_info: '크리에이터 정보',
      dtg_info_title: '디지털/전자책 구매 전, 꼭 확인해 주세요!',
      dtg_info_item_1: '모든 상품은 실물 제품이 아닌, 디지털 파일 형식의 제품입니다.',
      dtg_info_item_2: '결제 완료 후, 구매내역에서 7일 간 다운로드 받으실 수 있습니다.',
      dtg_info_item_3:
        '크리에이터가 설정한 라이센스 범위를 넘어서 활용할 경우, 민형사상 처벌을 받을 수 있습니다.',
      dtg_info_item_4:
        '디지털/전자책 특성 상 전자상거래법 제 17조에 의거하여 구매 이후에는 어떠한 사유로도 교환 및 환불이 불가합니다.',
    },
    review: {
      empty_title: 'Review is empty',
      empty_title_mps: '첫 번째 리뷰의 주인공이 되어보세요!',
      empty_text: '아직 작성된 리뷰가 없어요.',
      empty_text_mps:
        '정성 가득한 리뷰는 크리에이터에게 큰 힘이 됩니다.<br/>리뷰를 등록하고 포인트를 받아가세요!',
      show_more: '{{count}}개 리뷰 보기',
      option: '옵션 : {{option_name}}',
      sns_review: 'SNS 리뷰',
    },
    nbox: {
      pick_title: '넥슨 픽업',
      pick_desc1: '무료',
      pick_desc2: '넥슨 픽업 가능',
    },
    max_purchase_per_user: '1인당 {{count}}개 구매 가능한 상품이에요!',
    possible_quantity: '총 {{count}}개 까지 담을 수 있어요!',
    already_possible_quantity_title: '1인당 구매 가능 수량 초과',
    already_possible_quantity: '이미 구매한 상품이거나 장바구니에 담겨있어요.',
    cta: {
      coming_soon: '두둥! 곧 구매 가능',
      not_approve: '판매 승인 후 구매 가능합니다.',
      sold_out: '상품이 매진되었어요',
      end_sale: '판매가 종료되었어요!',
      only_pc: '디지털 굿즈는 PC에서만 구매가능',
      purchased_dtg: '이미 구매한 상품이에요!',
      cart: '장바구니',
      buy_now: '바로 구매하기',
      buy: '구매하기',
    },
    errors: {
      option_required: '옵션을 선택하지 않았습니다.<br/>상품의 옵션을 선택해 주세요.',
      option_required_mo: '상품 옵션을 선택해 주세요.',
    },
    purchase_delivery: {
      title: '배송 정보',
      pd01: '지금 주문하시면 <span style="color: {{color}};">{{start}}</span>부터 제작 프로세스가 시작되어 <span style="color: {{color}};">{{end}}</span> 이전에 출고될 예정입니다.',
      pd02: '해당 상품은 고객님의 주문에 맞춰 새 상품으로 제작하여 배송됩니다.',
      pd03: '결제 확인 후 평균 3일 이내에 출고 됩니다.<br>예약 상품의 경우 별도 일정에 따라 출고되오니, 상품 상세 정보를 참고 부탁드립니다.',
      info: {
        '01': '단, 수령하신 상품이 불량이거나 오배송된 경우에는 30일 이내 고객센터 또는 이메일, 1:1 문의로 연락주시면 교환 및 반품 환불이 가능합니다.',
        '02': '교환/반품 신청은 고객센터 또는 이메일로 접수해주시면 택배사 반품 접수를 도와드립니다.',
        '03': '반품 양식서를 작성하셔서 상품과 함께 포장해주세요. (반품양식서 누락시 환불이 지연될 수 있습니다.)',
        '04': '타 택배사 또는 임의로 택배를 보내시면 반송될 수 있으며 분실 및 접수 누락으로 환불이 지연되거나 불가할 수 있습니다.',
        a_01: '교환/반품 요청 기간은 상품 개봉 및 훼손 없이, 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.',
        a_02: '예외로 맞춤형 주문제작 상품의 경우 단숨 변심으로 인한 주문취소/교환/반품이 어렵습니다.',
        b_01: '본 상품은 <strong>맞춤형 주문제작 상품</strong>으로, 단순 변심으로 인한 주문취소/교환/반품이 어렵습니다.',
        c_01: '본 상품은 일반 주문제작 상품으로, 교환/반품 요청 기간은 상품 개봉 및 훼손 없이 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.',
      },
      case: {
        title: '반품/교환 불가능한 경우',
        '01': '맞춤형 주문 제작 상품의 경우',
        '02': '반품요청 기간이 지난 경우',
        '03': '구매자의 책임 있는 사유로 상품 등이 훼손 또는 멸실된 경우',
        '04': '구매자의 책임 있는 사유로 포장이 훼손되어 상품 가치가 현저히 상실된 경우 (예 : 식품, 화장품, 향수류, 음반, 전장류 등)',
        '05': '구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우 (라벨 제거, 태그 제거 등)',
        '06': '상품 고지 내역과 상이, 계약 내용과 다르게 이행된 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내 둘 중 하나 경과 시 반품/교환 불가',
        '07': '복제가 가능한 상품 등의 포장을 훼손한 경우 (예 : CD/DVD/GAME/도서의 경우 포장 개봉 시)',
      },
    },
    dtg: {
      file_type: '파일 유형',
      hyper_link: '링크',
      license: '라이센스 범위',
    },
    options: {
      color: '색상',
      preview_by_device: '내 스마트폰에 적용하기',
      size: '사이즈',
      quantity: '수량',
      device: '기종',
      custom: 'Custom Option',
      preview: '미리 듣기',
      type: 'Type',
      hyper_link: 'Hyper Link',
      license: 'License',
      size_guide: 'Size Guide',
    },
    brand_delivery: '브랜드 배송 상품',
    brand_delivery_desc: '해당 상품은 브랜드에서 직접 배송하는 상품입니다.<br/>구매 안내를 확인해주세요!',
    creator_delivery: '크리에이터배송 상품',
    creator_delivery_desc:
      '크리에이터가 배송하는 상품입니다.<br />크리에이터에 따라 배송비나 소요 기간이 다를 수 있습니다.',
    mps_delivery: '마플샵제작배송 상품',
    mps_delivery_desc:
      '마플샵에서 직접 제작하고 배송하는 상품입니다. 결제 금액에 상관없이 기본 배송비는 동일하게 청구되며, 도서 산간 지역은 추가금액이 발생할 수 있습니다.',
    tpl_delivery: '마플샵배송 상품',
    tpl_delivery_desc:
      '마플샵에서 직접 배송하는 상품입니다. 결제 금액에 상관없이 기본 배송비는 동일하게 청구되며, 도서 산간 지역은 추가금액이 발생할 수 있습니다.',
    total_label: 'Total <span class="dynamic-value">{{count}}</span>',
    not_approve: '판매 승인 후 구매 가능합니다.',
    sold_out_products: 'Sold Out',
    end_sale: 'Sold Out',
    only_pc: 'Only PC',
    purchased_dtg: 'Already Bought it!',
    cart: 'Add to Cart',
    buy: 'Buy',
    noti: {
      left: '남은수량 {{left}}',
      end_of_sale: '{{start_at}} ~ {{end_at}}',
      until_close:
        '마감까지&nbsp;<span class="remain_time" data-start_at="{{start_at}}" data-end_at="{{end_at}}">{{remain_time}}</span>',
      until_open:
        '오픈까지&nbsp;<span class="remain_time" data-start_at="{{start_at}}" data-end_at="{{end_at}}">{{remain_time}}</span>',
    },
    delivery_info: {
      info_label: '배송 정보',
      start_date_label: '배송출발일',
      expect:
        '지금 주문하면&nbsp;<span class="pd-guide__start-end-strong" style="color: {{color}};">{{start}} ~ {{end}}&nbsp;</span>사이에 출발해요!',
      parcel: '{{company}}',
      message1:
        '공휴일에 따라 일정이 변동될 수 있어 문자로도 재안내를 드립니다.{{- br}}구매 시 연락처가 올바른지 확인해주세요.',
      message2:
        '주문이 급증해 제작이 지연될 경우 배송 일정이 변동될 수 있습니다.{{- br}}예정된 일정보다 늦어질 경우 문자 메시지로 안내 드리겠습니다.',
      free_ship: '무료 배송',
      base_price: '기본 배송비 {{price}}원',
      addi_price: '도서 산간비 {{price}}원',
      label_1: '배송 방법',
      label_2: '배송 지역',
      label_3: '배송비',
      label_4: '배송 기간',
      label_5: '기본 배송비',
      label_6: '도서산간비 추가',
      desc_1:
        '상품 출고 후 영업일 기준 1~3일 이내\n수령이 가능하며 도서 산간 지역이거나\n택배사의 물량이 많은 경우 기간이 조금 더\n소요될 수 있습니다.',
    },
    best_seller_title: 'Best Seller',
    best_seller_subtitle: '인기상품',
    link_delivery: '배송 FAQ',
    link_chat: '1:1 문의하기',
    link_change: '교환/환불 FAQ',
    option_modal_title: 'Option',
    quality_modal: {
      p1: '본 상품은 철저한 품질 관리와 공정 관리를 거쳐 제작되었으며, 외관, 규격, 물성 검사에서 모두 합격한 상품입니다.',
      p2: '상품의 수명을 연장하기 위해, 상품에 부착된 취급 주의사항과 세탁 방법을 반드시 확인해 주시기 바랍니다. 또한, 상품의 품질에 문제가 있을 경우 고객센터로 연락해 주시기 바랍니다.',
      cs_title: '고객센터',
      email_title: '이메일',
    },
    retraction_modal: {
      p1: '착용 흔적, 세탁 흔적, 냄새, 오염, 임의 수선 흔적 등<br/>상품이 훼손되었거나 불량상품 임에도 착용 또는 사용한 경우,<br/>교환/반품이 불가합니다.',
      p2: '청약철회 제한 요건<br />(제17조 제2항 제6호 및 동법 시행령 제21조)',
      li1: '상세 사이즈는 측정 방법과 위치에 따라 1~3cm 오차가 발생할 수 있습니다. 기재된 상세 사이즈와 실측 오차(1~3cm)에 대한 불량처리는 어려우며 교환 및 환불 사유가 될 수 없습니다.',
      li2: '판매되는 상품은 각 브랜드, 도매처에서 각각의 샘플링을 거쳐 공급되는 제품이므로, 특정 브랜드 또는 가지고 계신 상품과 상세 사이즈가 다를 수 있습니다. 실측구매 시 상세 사이즈를 반드시 확인 부탁드립니다.',
      li3: '사이즈 측정은 상품을 바닥에 펼친 후 끝 선과 끝 선까지 측정해야 하며, 신축성 있는 소재일 경우, 잡아당기지 않고 바닥에 펼쳐진 상태 그대로 측정해야 합니다. 오차범위 이외 잘못된 측정으로 인한 반품 및 교환은 어려운 점 양해 부탁드립니다.',
    },
    private: {
      title: '판매가 종료되거나 중지된 상품입니다.',
      description: '해당 상품은 현재 판매가 종료되거나,<br/>삭제되어 확인할 수 없습니다.',
      btn: '다른 상품 보러가기',
    },
    tab02_ness: '상품 정보',
    tab03_ness: '구매/배송',
    ness: {
      not_available_description:
        '선택하신 상품은 현재 판매가 종료되거나,<br />삭제되어 확인하실 수 없습니다.',
    },
  },
  cta: {
    coming_soon: '출시 예정',
    limited: '한정판 구매',
    limited_not_show_count: '한정판 구매하기',
    quantity: '{{quantity}}개 남음',
    membership: '멤버십 가입하고 구매하기',
    membership_app: '먼저 PC에서 멤버십에 가입해 주세요.',
    limited_sold_out: '판매가 종료되었어요!',
    sold_out: '상품이 매진되었어요!',
    dtg: 'PC에서 구매할 수 있어요!',
    remain_days: '{{days}}일',
    remain_time: '<span>{{days}}</span><span>{{hours}}:{{minutes}}:{{seconds}}</span><span>남았어요!</span>',
    remain_time_coming_soon: '<span>{{days}}</span><span>{{hours}}:{{minutes}}:{{seconds}} 후</span>',
  },
  review: {
    comment_header: '상품에 대한 리뷰를 남겨주세요.',
    write_review: '리뷰 작성하기',
    comment_title: '리뷰 내용',
    placeholder: '최소 15자 이상 작성해 주세요.',
    desc1: '모든 리뷰는 이미지를 1개 이상 포함되어야 합니다.',
    desc2:
      '상품과 무관하거나 비속어가 포함된 리뷰, 그 외 리뷰 운영정책에 위배되는 리뷰는 고지 없이 블라인드 후 경고 조치될 수 있습니다.',
    sns_share: 'SNS 공유',
    agree: '작성한 리뷰는 넥슨에센셜 홍보 콘텐츠로 활용될 수 있음을 인지하고 동의합니다.',
    remove: '리뷰 삭제하기',
    remove_desc: '작성한 리뷰를 삭제하시겠어요?',
    remove_comment: '댓글 삭제하기',
    remove_comment_desc: '작성한 댓글을 삭제하시겠어요?',
    more: 'More',
    desc3: '이미지 파일 형식 : jpeg, png, gif / 용량 5MB',
    thankyou_title: 'Review Completed',
    thankyou_desc: '리뷰를 작성해 주셔서 감사합니다.',
  },
  creator: {
    sub_title: '크리에이터',
    sort: {
      최신순: '최신순',
      인기순: '인기순',
    },
    header_title: '크리에이터',
    rank: {
      top_10_ranking: '{{interval}} \nranking',
      top_10_text: 'top 10',
    },
  },
  limit_product: {
    limit_product_01: '한정판 상품',
  },
  ness: {
    mypage: {
      main_01: '주문・배송중인 상품',
      main_02: '내가 작성한 리뷰',
      main_03: '내가 좋아요 한 상품',
      main_01_mobile: '주문・배송',
      main_02_mobile: '리뷰',
      main_03_mobile: '좋아요',
      main_04: '나의 스토어',
      main_05: '셀러스튜디오',
      main_06: '플러스 어드민',
      main_07: '계정 설정',
      main_08: '로그아웃',
      main_09: '구매내역',
      main_10: '나의 리뷰',
      main_11: '좋아요',
      main_12: '1:1문의',
      main_13: '신고 접수 서비스',
      main_14: '사이트 이용 시 유의사항',
      like_01: '<span>내가 좋아요 한 상품 <span class="count">{{count}}</span></span>',
      like_02: '<span>내가 좋아요 한 스토어 <span class="count">{{count}}</span></span>',
      like_01_mobile: '<span>좋아요 한 상품 <span class="count">{{count}}</span></span>',
      like_02_mobile: '<span>좋아요 한 스토어 <span class="count">{{count}}</span></span>',
      like_03: '마음에 드는 상품을 찾는다면 좋아요를 눌러주세요.',
      like_04: '마음에 드는 스토어를 찾는다면 좋아요를 눌러주세요.',
      review_01: '아직 작성된 리뷰가 없어요',
      nexon_account_info: '넥슨 계정 정보',
      nexon_account_modify: '넥슨 정보 변경하러 가기',
      nexon_account_modify_mo: '넥슨 정보 변경',
      nexon_agree_info: '* 수신 설정 상태는 [넥슨닷컴 > 내 정보]에서 확인할 수 있습니다.',
    },
    order: {
      order_01: '공식상품 배송',
      order_01_add: '공식상품 배송 도서산간',
      order_02: '판매자 직접 배송',
      order_02_add: '판매자 배송 도서산간',
      revise_shipping: '배송지 변경',
      order_custom: '개인화상품 배송',
      order_custom_add: '개인화상품 배송 도서산간',
    },
    home: {
      home_01: '신상품',
      home_02: '인기 상품',
      home_03: '{{-count}}개 특별판매 상품 더보기',
      home_04: '{{brand}} 브랜디드 콘텐츠',
      home_05: '리뷰',
    },
    product: {
      only_limited: '특별판매만 보기',
      only_limited_mo: '특별판매만',
      only_stock_available: '품절상품 제외',
      only_stock_available_mo: '품절 제외',
      product_03: '신상품',
      product_04: 'New Arrivals',
      product_05: '특별판매 상품',
      product_06: 'Special Offer',
      product_07: '인기 상품',
      product_08: 'Best Seller',
      product_09: 'Empty Product List',
      product_10: '원하는 조건에 맞는 상품이 없어요.',
      product_11: 'Coming Soon',
      custom: '주문제작 상품',
    },
    product_sort: {
      default: '기본순',
      popular: '인기순',
      recent: '최근 등록순',
      most_liked: '좋아요 순',
      price_high_to_low: '높은 가격순',
      price_low_to_high: '낮은 가격순',
    },
    product_badge: {
      sale: '할인',
      new: '신상품',
      collection: '컬렉션',
      ranking: '인기상품',
      quantity_limited: '{{count}} Left',
      limited: '',
      edition: '',
      left: '',
      day_one: '',
      hour: '',
      minute: '',
    },
    review: {
      count_one: '',
      count_other: '',
    },
    footer: {
      company_name: '㈜넥슨코리아',
      customer_center: '고객센터',
      ceo: '대표이사',
      ceo_name: '강대현·김정욱',
      address: '주소',
      address_info: '경기도 성남시 분당구 판교로 256번길 7',
      company_registration_info: '사업자등록번호',
      company_registration_number: '220-87-17483',
      footer1: '이용약관',
      footer2: '개인정보처리방침',
      footer3: '서비스 이용안내',
      footer4: '전화번호',
      footer5: '평일',
      footer6: '점심시간',
      footer7: '공휴일, 주말 휴무',
      footer8: '사업자 정보 확인',
      footer9: '운영시간',
      footer10: '이메일',
      footer11:
        'NEXON ESSENTIAL 내 판매되는 일부 상품의 경우 ㈜넥슨코리아는 통신판매중개자로서 통신판매 당사자가 아니며, 판매자가 등록한 상품, 상품 정보 및 거래에 관한 책임을 지지 않습니다.',
      footer12: '호스팅 서비스 제공자',
      footer13: '(주)마플코퍼레이션',
      address_info_part1: '경기도 성남시 분당구&nbsp;',
      address_info_part2: '판교로 256번길 7',
      footer14: '서울 금천구 가산디지털1로 75-24 10F',
      footer15:
        '고객님의 안전거래를 위해 현금 등으로 결제하실 때 저희 몰에서 가입한 KG이니시스의 구매안전서비스를 이용하실 수 있습니다.',
      company: '상호명',
    },
    plus_admin: {
      pa_001: '스토어 관리',
      pa_002: '색상, 로고 등 브랜드 아이덴티티를 반영하여 사이트를 적용해 보세요.',
      pa_003: '스토어 정보',
      pa_004: '스토어 색상',
      pa_005: '사이트의 로고 배경 걸러 등에 반영됩니다.',
      pa_006: '레드',
      pa_007: '오렌지',
      pa_008: '옐로우',
      pa_009: '딥그린',
      pa_009_01: '그린',
      pa_010: '스카이',
      pa_011: '마젠타',
      pa_012: '골드',
      pa_013: '화이트',
      pa_014: '블랙',
      pa_015: '게임명',
      pa_016: '스토어명',
      pa_017: '스토어 소개',
      pa_018: '스토어 로고',
      pa_019: '정사각형 비율의 이미지 파일을 업로드 해주세요.<br/>(이미지 업로드 : PNG 가능 / 최대 3MB)',
      pa_020: '등록하기',
      pa_021: '삭제하기',
      pa_022: '스토어 커버',
      pa_023: 'PC 이미지',
      pa_024: '사이즈 3840 x 1280px',
      pa_025: '확장자 JPG, PNG 가능',
      pa_026: '최대 8MB',
      pa_027: 'PC 스토어 커버 이미지를<br/>등록해 주세요.',
      pa_028: '모바일 이미지',
      pa_029: '모바일 스토어 커버 이미지를<br/>등록해 주세요.',
      pa_030: '사이즈 1050 x 1960px',
      pa_031: '바로 확인하기',
      pa_032: '등록하기',
      pa_033: '프로모션 배너를 등록해 보세요.',
      pa_034: '메인 배너 수정',
      pa_035: '기본 설정',
      pa_036: '이미지 배너 URL 주소',
      pa_037: '동영상 썸네일 이미지',
      pa_038: '동영상 썸네일을 올려주세요.',
      pa_039: '썸네일 이미지 : 사이즈 1920 x 1080px / JPG, PNG 가능 / 최대 3MB',
      pa_040: '업로드',
      pa_041: '등록하기',
      pa_042: '유튜브 URL을 입력해 주세요.',
      pa_043: '프로모션 배너로 등록할 이미지 또는<br/>동영상 파일을 업로드하거나 유튜브 URL을 등록해 주세요.',
      pa_044: '이미지',
      pa_045: '사이즈 1920px x 1080px<span></span>JPG, PNG 가능<span></span>최대 3MB',
      pa_046: '동영상',
      pa_047: '최소 사이즈 710px x 400px<span></span>60초 이하<span></span> ',
      pa_047_1: 'MP4 또는 유튜브 URL 등록 가능<span></span>최대 15MB',
      pa_048: '공개 기간 설정',
      pa_049: '파일 형식이 맞지 않습니다.',
      pa_050: '동영상 해상도 크기가 최소 사이즈보다 작습니다.',
      pa_051: '동영상 시간의 최대 길이를 벗어났습니다.',
      pa_052: '동영상 파일의 크기가 최대 크기보다 큽니다.',
      pa_054: '동영상 업로드 오류',
      pa_055: '프로모션 배너 등록 실패',
      pa_056: '동영상 배너는 썸네일이 필수입니다.',
      pa_057: '배너 공개 개수 초과',
      pa_057_01: '동영상 공개 개수 초과',
      pa_058: '공개 개수가 초과되었습니다.<br/>최대 5개까지 공개할 수 있습니다.',
      pa_058_01: '공개 개수가 초과되었습니다.<br/>최대 1개까지 공개할 수 있습니다.',
      pa_059: '공개 개수가 초과되었습니다.<br/>배너의 공개 상태가 비공개로 등록됩니다.',
      pa_059_01: '공개 개수가 초과되었습니다.<br/>동영상의 공개 상태가 비공개로 등록됩니다.',
      pa_060: '드래그 앤 드롭으로 순서를 변경할 수 있습니다.',
      pa_061: '동영상 배너 제목',
      pa_062: '기본 설정',
      pa_063: '동영상 URL 주소',
      pa_064: '동영상 배너 관리',
      pa_065: '전체 동영상 배너',
      pa_066: '게임 스토어 메인에 노출할 동영상 배너를 만들고 관리해 보세요. 최대 1개까지 공개 가능합니다.',
      pa_067: '홈 화면에 노출될<br/>동영상 배너를 등록해 보세요.',
      pa_068: '동영상 배너 관리',
      pa_069: '동영상 배너 등록',
      pa_061_01: '최대 37자까지 입력 가능합니다.',
      pa_070: '동영상 배너 수정',
      pa_071:
        '프로모션 배너는 메인에 최대 5개까지 공개 가능합니다.<br/>정렬 순서는 프로모션 배너 관리 > 메인 정렬 변경 탭에서 변경해 주세요.',
      pa_071_01:
        '동영상 배너는 메인에 최대 5개까지 공개 가능합니다.<br/>정렬 순서는 동영상 배너 관리 > 메인 정렬 변경 탭에서 변경해 주세요.',
      pa_072: '메타 태그 설정',
      pa_073: 'OpenGraph 제목',
      pa_074: 'OpenGraph 내용',
      pa_075: 'OpenGraph 이미지',
      pa_076: '권장 사이즈 (가로 1200px * 세로 600px)',
      pa_077: '등록하기',
      pa_078: '기업 공식 홈페이지 URL',
      pa_079: '페이스북 URL',
      pa_080: '인스타그램 URL',
      pa_081: '유튜브 URL',
      pa_082: '트위터 URL',
      pa_016_01: '카테고리 스토어명',
    },
    checkout: {
      receipt: {
        receipt_01: '계좌번호를 클립보드에 복사했습니다.',
      },
    },
    confirm: {
      ok: '네',
      cancel: '아니요',
    },
    login: {
      login_01: '넥슨에센셜 회원가입',
      login_02: '넥슨에센셜 가입을 위해<br/>넥슨 계정 이메일을 등록해 주세요.',
      login_02_01: '넥슨 계정 이메일 정보 확인이 어렵습니다.<br/>이메일 등록 후 가입이 가능합니다.',
      login_03: '이메일 등록',
      login_04: '넥슨 계정에 이메일 주소를 등록해 주세요.',
      login_05: '본인 인증',
      login_06: '넥슨 계정에 본인 인증을 완료해 주세요.',
      login_07: '14세 이상 확인',
      login_08: '14세 미만은 후견인 인증이 필요합니다.',
      login_09: '바로가기',
      login_10: '이메일',
      login_11: '닉네임',
      login_12: '휴대폰 번호',
      login_13: '약관 전체동의',
      login_14: '넥슨에센셜 이용 약관 동의 (필수)',
      login_15: '개인정보처리방침 동의 (필수)',
      login_16: '게임 및 서비스의 유용한 소식 받기 (선택)',
      login_17: '보기',
      login_18: '넥슨 로그인 세션이 만료되었습니다.<br/>다시 시도해 주세요.',
      login_19: '로그인이 정상적으로 이뤄지지 않았습니다.<br/>다시 시도해 주세요.',
      login_20: '넥슨 로그인',
      require: {
        title: '로그인 후 상품을 구매해보세요.',
        body: '상품은 넥슨에센셜 회원만 구매가 가능합니다.',
      },
      login_21: '만 14세 미만 아동의 개인정보 수집',
      login_22: '법정대리인 휴대폰 인증',
      login_23:
        '㈜넥슨코리아는 다음과 같이 14세 미만 아동의 개인정보를 수집하기 위해 보호자의 동의를 받고 있습니다.<br/>보호자께서는 아동의 개인정보 처리에 대한 내용을 충분히 인지한 후 동의해 주시기 바랍니다.',
      login_24: '아동의 개인정보 수집 및 이용 동의',
      login_25: '보호자의 개인정보 수집 및 이용 동의',
      login_26: '상품 구매를 위해서는<br/>넥슨 계정에 이메일 등록이 필요합니다.',
      login_27:
        '넥슨 계정에 등록된 이메일 정보가 없습니다.<br/>아래의 [바로가기] - [개인정보변경]에서 이메일 등록 후 재시도 부탁 드립니다.',
      login_28: '다른 계정으로 다시 시도하기',
      login_29:
        '㈜넥슨코리아가 제공하는 모든 게임 및 서비스의 업데이트, 사전등록, 이벤트 참가 등 도움되는 정보를 받을 수 있습니다.<div style="padding-top: 4px">수신 설정 상태는 [넥슨닷컴 > 내 정보]에서 확인할 수 있습니다.</div>',
      login_30: '이제부터 게임 및 서비스의<br/>유용한 소식을 받습니다.',
      login_31: '{{date}} ㈜넥슨코리아 제공',
      login_32:
        "휴대폰 인증 과정에서 '마플코퍼레이션'으로부터 인증 요청이 올 수 있습니다.<br/>'마플코퍼레이션'은 넥슨에센셜의 공식 운영 파트너이므로 안심하셔도 됩니다.",
      login_32_mobile:
        "휴대폰 인증 과정에서 '마플코퍼레이션'으로부터 인증 요청이 올 수 있습니다. '마플코퍼레이션'은 넥슨에센셜의 공식 운영 파트너이므로 안심하셔도 됩니다.",
    },
    my_page: {
      is_hidden_user: '넥슨에센셜 탈퇴하기',
      change_profile: '프로필 이미지가 변경되었습니다.',
      delete_profile: '프로필 이미지가 삭제되었습니다.',
      marketing_agree_title: '광고성 정보 수신 동의',
      marketing_agree_body: '{{date_time}}<br>광고성 정보 수신에 동의하셨습니다.',
      marketing_disagree_title: '광고성 정보 수신 동의 해제',
      marketing_disagree_body: '{{date_time}}<br>광고성 정보 수신이 해제되었습니다.',
    },
    editorial: {
      related: '관련 에디토리얼',
    },
    common: {
      see_more: '더보기',
      close: '닫기',
    },
    privacy: {
      privacy_child: '아동의 개인정보 수집 및 이용 동의',
      privacy_guardian: '보호자의 개인정보 수집 및 이용 동의',
    },
    studio: {
      product_guide: {
        title: '마플샵제작배송 상품과 크리에이터배송 상품이란?',
        about_pod: '마플샵제작배송 상품이란?',
      },
    },
  },
  '로그인 후 이용해 주세요.': '로그인 후 이용해 주세요.',
  collection_category: {
    ALL: 'All',
    EXCLUSIVE: 'Exclusive',
    FUNDING: 'Funding',
  },
  collection: {
    coll_1_1: 'Description',
    mo_header: 'Collection',
  },
  '개인 정보 수집 및 이용 동의': '개인 정보 수집 및 이용 동의',
  customer_order: {
    receipt_info: '영수증 조회',
    receipt: {
      card: '카드영수증',
      cash: '현금영수증',
      purchase: '구매 영수증',
      id: '구매번호',
      paid_at: '거래일시',
      provider: '결제대행사',
      orderer: '구매자명',
      products: '상품명',
      price: '금액',
      pdf: 'PDF로 저장',
      print: '인쇄하기',
      total_price_t: '승인금액',
      cancel_price_t: '취소금액',
      up_c_id: '상품번호',
      supply_price_t: '공급가액',
      vat_price_t: '부가세액',
      result_price_t: '합계',
      'change-warn': '결제 정보가 수정되었습니다.<br> 확인을 위해서는 고객센터로 연락주세요.',
      detail: {
        card_title: '카드 영수증 (매출전표)',
        cash_title: '현금 영수증',
        card_name: '카드사',
        apply_num: '승인번호',
        paid_at: '결제일자',
        card_num: '카드번호',
        card_info: '카드사 정보',
        seller_info: '판매자 정보',
        seller_name: '상호',
        seller_ceo: '대표자명',
        seller_num: '사업자등록번호',
        seller_tel: '전화번호',
        seller_address: '사업장주소',
        provider_info: '가맹점 정보',
        provider_name: '가맹점명',
        provider_tel: '가맹점번호',
        provider_address: '주소',
        cancel_info: '취소된 결제입니다.',
        card_quota: '거래종류/할부',
        product_classification: '구분',
      },
      canceled: '취소 영수증',
      header_title: '영수증 발급 내역',
      paid_at_title: '주문일자',
      purchase_info: '구매 정보',
      cannot_print_mo: '영수증 인쇄는 PC에서 가능합니다',
    },
    contents: {
      list_description: '관심 있을 만한 걸 가져왔어요 💘',
    },
  },
  error: {
    desc404:
      '요청하신 페이지가 존재하지 않거나, 사용할 수 없습니다.<br />입력하신 주소가 정확한지 다시 한번 확인해 주세요.',
    desc500: '서비스와 연결할 수 없습니다.<br />잠시 후 다시 시도해 주세요.',
  },
  tpl_faq: {
    group_1_label: '주문/배송',
    group_1_q1: '주문 후 상품 수령까지 얼마나 걸리나요?',
    group_1_a1:
      '결제 확인 후 평균 3일 이내에 출고 됩니다.<br>예약 상품의 경우 별도 일정에 따라 출고되오니, 상품 상세 정보를 참고 부탁드립니다.',
    group_1_q2: '주문 상태는 어떻게 알 수 있나요?',
    group_1_a2:
      '로그인 > 마이페이지 > 구매내역에서 내 주문과 관련된 진행 상태 및 배송일정을 확인하실 수 있습니다.<br/><br/>주문하신 상품의 진행 과정은 다음과 같습니다.<br/>[제작 준비중/상품 준비중] : 결제가 완료되어 상품을 준비하는 단계입니다.<br/>[제작 중] : 주문하신 상품의 제작되고 있는 단계입니다.<br/>[배송 준비중] : 제작이 완료되어 상품의 검수 및 포장을 진행합니다.<br/>[배송 중] : 주문하신 상품이 출고되어 택배사로 전달된 상태이며 운송장 번호는 문자로 발송됩니다. 출고된 다음날부터 송장번호 조회를 통한 배송 현황 확인이 가능합니다.<br/>[배송 완료]: 배송이 완료된 상태 입니다.',
    group_1_q3: '비회원도 주문할 수 있나요?',
    group_1_a3:
      '넥슨에센셜은 넥슨 회원일 경우에만 주문하실 수 있습니다.<br/>넥슨 회원으로 가입하신 후에 서비스를 이용해 주세요. 넥슨 회원이 되시면 넥슨에센셜에서 주문은 물론, 다양한 이벤트와 혜택도 받으실 수 있습니다.',
    group_2_label: '교환/환불',
    group_2_q1: '주문 취소가 가능한가요?',
    group_2_a1:
      '특정 단계까지는 마이페이지 > 구매내역 > 상세보기에서 회원의 직접 주문취소가 가능합니다.<br/>ㆍ <b>[주문 접수 / 제작 준비중]</b> 단계까지는 회원의 직접 주문취소가 가능합니다.<br/>ㆍ <b>[제작 중 / 상품 준비중]</b> 단계부터는 회원의 직접 주문취소가 불가합니다. 고객센터 또는 이메일 일대일 문의로 요청바랍니다.<br/>ㆍ 예외로 주문제작 상품의 경우 단순 변심으로 인한 주문취소 교환 반품이 어렵습니다.<br/>ㆍ 주문 취소에 관한 내용은 FAQ의 취소/환불에서 확인하실 수 있습니다.<br/>※ 넥슨에센셜은 사용하는 상품만 생산함으로써 낭비없는 생산으로 자원의 낭비를 막고 환경을 생각합니다. 신중한 구매 부탁드립니다.',
    group_2_q2: '상품을 받았는데 교환이나 환불이 가능한가요?',
    group_2_a2:
      '교환/반품 요청 가능 기간은 상품 개봉 및 훼손 없이, 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.<br />\n     예외로 맞춤형 주문제작 상품의 경우 단순 변심으로 인한 주문취소/교환/반품이 어렵습니다.<br />\n     단, 수령하신 상품이 불량이거나 오배송된 경우에는 30일 이내 고객센터 또는 이메일, 1:1 문의로 연락주시면 교환 및 반품 환불이 가능합니다.<br />\n     교환/반품 신청은 고객센터 또는 이메일로 접수해주시면 택배사 반품 접수 도와드립니다.<br />\n     반품양식서 작성하셔서 상품과 함께 포장해주세요. (반품양식서 누락시 환불이 지연 될 수 있습니다.) 타 택배사 또는 임의로 택배를 보내시면 반송될 수 있으며 분실 및 접수 누락으로 환불이 지연되거나 불가할 수 있습니다.<br /><br />\n     \n     반품/교환 불가능한 경우<br />\n     ㆍ 맞춤형 주문 제작 상품의 경우<br />\n     ㆍ 반품요청 기간이 지난 경우<br />\n     ㆍ 구매자의 책임 있는 사유로 상품 등이 훼손 또는 멸실된 경우<br />\n     ㆍ 구매자의 책임 있는 사유로 포장이 훼손되어 상품 가치가 현저히 상실된 경우(예: 식품, 화장품, 향수류, 음반, 전장류 등)<br />\n     ㆍ 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우(라벨 제거, 태그 제거 등)<br />\n     ㆍ 상품 고지 내역과 상이, 계약 내용과 다르게 이행된 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내 둘 중 하나 경과 시 반품/교환 불가<br />\n     ㆍ 복제가 가능한 상품 등의 포장을 훼손한 경우(예: CD/DVD/GAME/도서의 경우 포장 개봉 시)',
  },
  faq: {
    group_1_label: '주문/배송',
    group_1_q1: '주문 후 상품 수령까지 얼마나 걸리나요?',
    group_1_a1:
      '해당 상품은 주문 제작 상품입니다. 주문 제작 상품은 일주일 동안의 주문을 모아 그 다음주에 생산 및 배송하는 방식으로 운영되고 있습니다. 이로 인해, 주문 후 상품이 발송되기까지 일정 기간이 필요하며, 배송 상태에 따라 고객님께 개별적으로 안내를 드리고 있습니다. 주문 후 상품 수령까지 최소 일주일 이상이 소요될 수 있음을 양해 부탁드립니다.',
    group_1_q2: '주문 상태는 어떻게 알 수 있나요?',
    group_1_a2:
      '로그인 > 마이페이지 > 구매내역에서 내 주문과 관련된 진행 상태 및 배송일정을 확인하실 수 있습니다.<br/><br/>주문하신 상품의 진행 과정은 다음과 같습니다.<br/>[제작 준비중/상품 준비중] : 결제가 완료되어 상품을 준비하는 단계입니다.<br/>[제작 중] : 주문하신 상품의 제작되고 있는 단계입니다.<br/>[배송 준비중] : 제작이 완료되어 상품의 검수 및 포장을 진행합니다.<br/>[배송 중] : 주문하신 상품이 출고되어 택배사로 전달된 상태이며 운송장 번호는 문자로 발송됩니다. 출고된 다음날부터 송장번호 조회를 통한 배송 현황 확인이 가능합니다.<br/>[배송 완료]: 배송이 완료된 상태 입니다.',
    group_1_q3: '비회원도 주문할 수 있나요?',
    group_1_a3:
      '넥슨에센셜은 넥슨 회원일 경우에만 주문하실 수 있습니다<br/>넥슨 회원으로 가입하신 후에 서비스를 이용해 주세요. 넥슨 회원이 되시면 넥슨에센셜에서 주문은 물론, 다양한 이벤트와 혜택도 받으실 수 있습니다.',
    group_2_label: '교환/환불',
    group_2_q1: '주문 취소가 가능한가요?',
    group_2_a1:
      '특정 단계까지는 마이페이지 > 구매내역 > 상세보기에서 회원의 직접 주문취소가 가능합니다.<br/>ㆍ [주문 접수 / 제작 준비중]단계까지는 회원의 직접 주문취소가 가능합니다<br/>ㆍ [제작 중 / 상품 준비중] 단계부터는 회원의 직접 주문취소가 불가합니다. 고객센터 또는 이메일 일대일 문의로 요청 바랍니다.<br/>ㆍ 예외로 주문제작 상품의 경우 단순 변심으로 인한 주문취소 교환 반품이 어렵습니다.<br/>ㆍ 주문 취소에 관한 내용은 FAQ의 취소/환불에서 확인하실 수 있습니다.<br/>※ 넥슨에센셜은 사용하는 상품만 생산함으로써 낭비없는 생산으로 자원의 낭비를 막고 환경을 생각합니다. 신중한 구매 부탁드립니다.',
    group_2_q2: '상품을 받았는데 교환이나 환불이 가능한가요?',
    group_2_a2:
      '교환/반품 요청 가능 기간은 상품 개봉 및 훼손 없이, 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.<br />\n      예외로 맞춤형 주문제작 상품의 경우 단순 변심으로 인한 주문취소/교환/반품이 어렵습니다.<br />\n      단, 수령하신 상품이 불량이거나 오배송된 경우에는 30일 이내 고객센터 또는 이메일, 1:1 문의로 연락주시면 교환 및 반품 환불이 가능합니다.<br />\n      교환/반품 신청은 고객센터 또는 이메일로 접수해주시면 택배사 반품 접수 도와드립니다.<br />\n      반품양식서 작성하셔서 상품과 함께 포장해주세요. (반품양식서 누락시 환불이 지연 될 수 있습니다.) 타 택배사 또는 임의로 택배를 보내시면 반송될 수 있으며 분실 및 접수 누락으로 환불이 지연되거나 불가할 수 있습니다.<br /><br />\n      \n      반품/교환 불가능한 경우<br />\n      ㆍ 맞춤형 주문 제작 상품의 경우<br />\n      ㆍ 반품요청 기간이 지난 경우<br />\n      ㆍ 구매자의 책임 있는 사유로 상품 등이 훼손 또는 멸실된 경우<br />\n      ㆍ 구매자의 책임 있는 사유로 포장이 훼손되어 상품 가치가 현저히 상실된 경우(예: 식품, 화장품, 향수류, 음반, 전장류 등)<br />\n      ㆍ 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우(라벨 제거, 태그 제거 등)<br />\n      ㆍ 상품 고지 내역과 상이, 계약 내용과 다르게 이행된 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내 둘 중 하나 경과 시 반품/교환 불가<br />\n      ㆍ 복제가 가능한 상품 등의 포장을 훼손한 경우(예: CD/DVD/GAME/도서의 경우 포장 개봉 시)',
  },
  mps2: {
    common: {
      price: '{{price}}원',
      word_length: '{{length}}자',
      reset: '초기화',
      remove_all: '전체 삭제',
      error_title: '오류 발생',
      error_message: '오류가 발생했습니다.<br/>잠시 후 시도해주시기 바랍니다.',
      agree: '동의',
      disagree: '비동의',
      confirm: '확인',
      cancel: '취소',
      leave: '나가기',
      delete: '삭제하기',
      start: '시작하기',
      close: '닫기',
      update: '업데이트',
      see_more: '보기',
      go_marppleshop: '마플샵으로 이동하기',
      example: '예',
      category: {
        level_1: {
          goods: '굿즈',
          ebook: '전자책',
          brand_deal: '브랜드딜',
          handmade: '핸드메이드',
        },
      },
    },
    ranking: {
      realtime: '실시간',
      realtime_best: '실시간 베스트',
      weekly: '주간',
      weekly_best: '주간 베스트',
      monthly: '월간',
      monthly_best: '월간 베스트',
      cate_roots: {
        ranking: '랭킹',
        goods: '굿즈 랭킹',
        handmade: '핸드메이드 랭킹',
        brand_deal: '브랜드딜 랭킹',
        ebook: '전자책 랭킹',
      },
    },
    product_ranking: {
      title: '인기 상품 랭킹',
      description: '지금 가장 인기 있는\n상품을 만나보세요!',
    },
    footer: {
      마플코퍼레이션: '마플코퍼레이션',
      '마플샵 크리에이터': '마플샵 크리에이터',
      '마플샵 플러스': '마플샵 플러스',
      '마플샵 팝업스토어': '마플샵 팝업스토어',
      '오프라인 팝업스토어': '오프라인 팝업스토어',
      '온라인 팝업스토어': '온라인 팝업스토어',
      '브랜드 커머스': '브랜드 커머스',
      '유튜브 쇼핑': '유튜브 쇼핑',
      '핸드메이드 크리에이터': '핸드메이드 크리에이터',
      '커머스 크리에이터': '커머스 크리에이터',
      '굿즈 파트너스': '굿즈 파트너스',
      고객센터: '고객센터',
      신고센터: '신고센터',
      이용약관: '이용약관',
      개인정보처리방침: '개인정보처리방침',
      privacy_charge: '개인정보호책임자',
      privacy_charge_name: '유인동',
      customer_center_info: '평일 10:00 ~ 18:00 (토・일・공휴일 휴무)',
      inicis_info: 'KG이니시스를 통해 현금 결제 시 당사에서 가입한 구매안전서비스를 이용할 수 있습니다.',
      inicis_button: 'KG이니시스 가입 확인',
      notice:
        '크리에이터배송 상품, 디지털/전자책 상품 등에 대해 (주)마플코퍼레이션은 통신판매중개업자로서 통신판매의 당사자가 아니며 상품의 주문, 배송 및 환불 등과 관련한 의무와 책임은 각 판매자에게 있습니다.',
      business_info: '사업자정보',
      '마플샵 오프라인 팝업스토어': '마플샵 오프라인 팝업스토어',
      '마플샵 브랜드 커머스': '마플샵 브랜드 커머스',
      '마플샵 X 유튜브 쇼핑': '마플샵 X 유튜브 쇼핑',
      terms_paid_service: '통합 유료서비스 이용약관',
      customer_support: '고객지원',
      faq: '자주 묻는 질문',
      inquiry: '1:1 문의하기',
    },
    product: {
      title: 'Products',
      sub_title: '마플샵의 상품들을 소개할게요!',
      limited: '한정판',
      best: '베스트',
      all_products: '전체 상품',
      all: '전체',
      only_stock_available: '품절 상품 제외',
      product_01: '{{count}}개의 특별함을 구매할 시간!',
      product_02: '당신의 취향을 저격할 인기 상품 😎',
      total: '총',
      count: '개의 상품',
      price: '가격',
      badge: {
        sold_out: '품절',
        limited: '한정',
        closed: '종료',
        nft: 'NFT',
        stock_left: '{{stock}}개 남음',
        upcoming: '출시예정',
        period_limited_second: '{{second}}초 남음',
        period_limited_minute: '{{minute}}분 남음',
        period_limited_hour: '{{hour}}시간 남음',
        period_limited_day: '{{day}}일 남음',
        membership: '멤버십',
        trending: '급상승',
        popular: '인기',
        brand_deal: '브랜드딜',
        funding: '펀딩',
      },
      tag: {
        sold_out: '다 팔렸어요!',
        period_limited_day: '{{day}}일 남았어요!',
        period_limited: '{{time}} 남았어요!',
        quantity_limited: '{{stock}}개 남았어요!',
        upcoming_soon: '곧 출시해요!',
        upcoming_min: '출시 {{minute}}분 전이에요!',
        upcoming_hour: '출시 {{hour}}시간 전이에요!',
        upcoming_day: '출시 {{day}}일 전이에요!',
        upcoming: '출시 예정이에요!',
        realtime: '{{time}}전 판매되었어요!',
        realtime_compact: '{{time}}전 판매',
      },
      sort: {
        popular: '인기순',
        newest: '최신순',
        price_high_to_low: '높은 가격순',
        price_low_to_high: '낮은 가격순',
        many_reviews: '리뷰순',
        featured: '추천순',
      },
      filter: {
        title: '상품 필터',
        is_limited: '한정판만 보기',
        is_limited_short: '한정판만',
        without_sold_out: '품절 상품 제외',
        without_sold_out_short: '품절 제외',
        confirm: '상품 보기',
        info: '상품 정보',
        style: '스타일',
      },
      empty: {
        shop_title: '원하는 조건에 맞는 상품이 없습니다.',
        shop_body: '다른 조건으로 상품을 찾아보세요!',
        plus_shop_body: '{{name}}에서 상품을 준비하고 있어요!',
        creator_title: '상품 준비 중입니다.',
        creator_body: '크리에이터가 상품을 준비하는 동안<br />마플샵에서 내 취향의 상품을 찾아볼까요?',
        creator_footer: '마플샵 둘러보기',
      },
      recommend: '추천 상품',
      weekly_banner_title: '주간 베스트 TOP 100',
      weekly_banner_desc: '이번 주에 가장 인기 많은 상품을 만나 보세요!',
      monthly_banner_title: '월간 베스트 TOP 100',
      monthly_banner_desc: '이번 달에 가장 인기 많은 상품을 만나 보세요!',
    },
    recently_sold: {
      sold_now: '실시간 상품',
      title: '실시간 판매',
      sub_title: '따끈따끈 실시간으로 판매된 인기 급상승 상품!',
      desc: '지금 막 판매된\n실시간 인기 급상승\n상품들을 만나보세요!',
    },
    creator: {
      creator_01: '크리에이터',
      creator_02: '당신의 마음을 훔치러 온',
      plus: {
        description: '팬심으로 보고, 사심으로 사는 공식 굿즈',
        tooltip:
          '마플샵 플러스는 다양한 크리에이터를 보유한 기업과 브랜드를 위한 <b><u>통합 IP 커머스 솔루션</u></b>입니다.\n플랫폼 구축부터 상품 제작, 주문, 생산, 배송까지 손쉽게 IP 커머스 플랫폼을 구축해 보세요!',
        tooltip_link: '마플샵 플러스 신청하기',
        see_more: '마플샵 플러스 전체보기',
        filter: {
          recommendation: '추천순',
          new: '최신순',
          popular: '인기순',
          like: '좋아요순',
          review: '리뷰순',
        },
      },
      ranking: {
        header_title: 'Creator Ranking',
        page_title: '크리에이터 인기 랭킹',
        month: 'yy년 MM월',
        week: '{{year_month}} {{week}}주차',
        period: '{{date}} 집계',
        empty_title: '크리에이터배송 상품이 모두 판매되었어요!',
        empty_desc: '좋아하는 크리에이터를 응원하고<br />새롭게 출시할 상품을 노려보세요!',
        empty_btn: '응원하러 가기',
      },
      txt1: '크리에이터 소개',
      description_empty: '아직 크리에이터가 소개글을 준비하고 있어요.',
      view: {
        description: '크리에이터가 직접 들려주는 이야기',
      },
      all: {
        description: '세상 모든 크리에이터가 여기에!',
        see_more: '더보기',
      },
      empty_title: '크리에이터들이 오픈 준비 중이에요!',
      see_more: '더보기',
      share: '마플샵에서 {{name}}만의 굿즈를 만나보세요.',
    },
    modal: {
      취소: '취소',
      확인: '확인',
      저장: '저장',
    },
    review: {
      title: '리뷰',
      thanktyou_title: '리뷰가 성공적으로 등록되었습니다.',
      thanktyou_desc: '작성하신 리뷰는 마이페이지 > 나의 리뷰에서 확인하실 수 있습니다.',
      page_title: '포토 리뷰',
      page_sub_title: '마플샵 내돈내산 리뷰',
      page_sub_title__plus: '팬들의 이야기가 궁금할 때',
      option: '옵션',
      write_place_holder:
        '크리에이터를 응원하는 리뷰를 등록하시면 심사 후 최대 300P를 적립해드립니다. \n크리에이터에게도 최대 {{order_point}}P의 작품 활동 지원금을 드립니다.',
      delete: '삭제하기',
      sns_review: 'SNS 리뷰',
      comment_count: '댓글&nbsp;<span class="article-detail-comments__count">{{count}}</span>개',
      empty_title: '첫 번째 리뷰의 주인공이 되어보세요!',
      empty_title_desc:
        '정성 가득한 리뷰는 크리에이터에게 큰 힘이 됩니다.<br />리뷰를 등록하고 포인트를 받아가세요!',
    },
    breadcrumbs: {
      home: '홈',
      creator_ranking: '크리에이터 랭킹',
      product_ranking: '상품 랭킹',
      detail: '상세',
    },
    main: {
      quick_menus: {
        creator_apply: '크리에이터 신청',
        goods_partner: '굿즈 파트너스 신청하기',
        fee_0: '핸드메이드 수수료 0%',
        weekly_ranking: '주간 크리에이터 랭킹',
        realtime_review: '실시간 상품 리뷰',
        //
        fall_base_ball: '가을야구 준비 갈 완료?',
        domiworld: '멋진 미소녀의 도미월드',
        how_to_record: '기록은 이렇게 하세요',
        september_hot: '9월도 더운 사람들 협회',
        book_season: '책 읽기 좋은 계절',
        attention_graduate_student: '대학원생 주목',

        treasure_shop: '보물상 들어올 사람?',

        order_now_cool: '지금 시켜서 선선할때 입자',
        chuseok_nagging: '추석 잔소리, 유쾌한 반란템',

        trust_tshirt: '이 티셔츠, 믿기십니까?',
        love_potery: '시의 매력에 빠져봐',
        shampoo_picture: '그림에서 샴푸향이 느껴진거야',

        say_nothing: '아무 말 하고 돈 벌기',
        room_change: '방 분위기 바꿔봐',
        dajai_yusanmu: '인간 실격 굿즈 합격, 다자이 유상무',

        help_marppleshop: '내 샵 매출, 마플샵이 도와줄게',
        //
        popup_store: '마플샵 팝업스토어',
        popular: '인기 크리에이터 랭킹',
        best_ranking: '실시간 인기 상품',
        photo_review: '포토 리뷰',
        plus_apply: '마플샵 플러스',
        youtube: '유튜브 쇼핑 X 마플샵',
        CCC: '크리에이터스 클럽',
        popup_store_mo: '온라인 팝업',
        popular_mo: '인기 크리에이터',
        best_ranking_mo: '인기 상품',
        photo_review_mo: '포토 리뷰',
        plus_apply_mo: '마플샵 플러스',
        youtube_mo: '유튜브 쇼핑',
        CCC_mo: '크리에이터 클럽',
        curation: '큐레이션',
        realtime: '실시간 상품',
        product_ranking: '인기 급상승 상품 랭킹',
        limited: '한정판 상품',
        funding_apply: '마플샵 펀딩 신청하기',
        product_curation: '상품 큐레이션',
        handmade_creator: '핸드메이드 크리에이터',
        online_popup_store: '온라인 팝업스토어',
      },
      creator_ranking: {
        title: '실시간 크리에이터 랭킹',
        title_mobile: '실시간 크리에이터 랭킹',
        description: '다양한 크리에이터의 매력 폭발!',
        updated_at: '{{minute}}분 전 업데이트',
        statistics_date: '{{date}} 집계',
        see_more: '더보기',
        item: {
          title: '크리에이터의 상품이 모두 판매되었어요!',
          sub_title: '좋아하는 크리에이터를 응원하고\n새롭게 출시할 상품을 노려보세요!',
          fan_letter: '팬레터 쓰러 가기',
        },
      },
      limited_edition: {
        title: '마플샵 한정 상품 랭킹',
        sub_title: '지금 아니면 못 만나는 {{count_text}}개 특별함',
      },
      weekly_best_product: {
        description: '가장 인기있는 상품을 만나보세요!',
      },
      top_100: {
        title: '인기 랭킹 TOP 100',
        title_mo: '인기 랭킹',
        sub_title: '어떤 상품이 가장 많이 팔렸을까요?',
        see_more: '<span>굿즈 TOP 100</span>&nbsp;더보기',
      },
      category_product_ranking: {
        title: '굿즈 카테고리별 랭킹',
        sub_title: '지금 반응이 뜨거운 상품을 만나보세요!',
        tooltip:
          '카테고리 별 상품 랭킹은 마플샵에서\n일주일간 가장 인기 있는 상품을 카테고리별로\n구분하여 제공합니다.',
        empty_title: '랭킹 집계 중이에요!',
        empty_description_pc: '다른 카테고리를 선택하거나 검색으로 상품을 찾아보세요!',
        empty_description_mo: '다른 카테고리를 선택하거나\n검색으로 상품을 찾아보세요!',
      },
      cast_on_air: {
        description: '최애는 지금 영업 중',
      },
      photo_review: {
        description: '마플샵 내돈내산 리뷰',
      },
      new_creator: {
        description: '마플샵 데뷔! 떠오르는 라인업',
      },
      lifestyle_curation: {
        description: '이 세상에 다양한 취향을 위해',
      },
      store_direct: '{{name}} 샵 바로가기',
      popup: {
        description: '오직 마플샵에서만 만나볼 수 있는',
        title: 'MARPPLESHOP POP-UP STORE',
        percent: '달성',
        button: '마플샵 팝업스토어 전체보기',
      },
      creators: {
        description: '당신의 마음을 훔치러 온',
      },
      contents: {
        description: '관심 있을 만한 걸 가져왔어요 💘',
      },
      best_product: {
        description: '당신의 취향을 저격할 인기 상품 😎',
      },
      realtime: {
        title: '방금, 막 판매된 실시간 판매 상품',
        title_mo: '방금 판매된 인기 상품!',
        sub_title: '다른 사람들은 어떤 걸 구매할까?',
      },
      brand_commerce: {
        title: '크리에이터 X 브랜드 상품',
        sub_title: '함께 모여서 만드는 더 큰 행복!',
        tooltip:
          '크리에이터 X 브랜드 상품은 크리에이터와 브랜드가 협업하여 효율적으로 상품을 홍보하고, 합리적인 가격으로 제공하는 상품이에요!',
      },
      new_creator_ranking: {
        title: '이달의 신규 크리에이터 랭킹',
        sub_title: '새로운 감각, 신선한 아이디어!',
        tooltip:
          '이달의 신규 크리에이터 랭킹은\n일주일간 마플샵에 새롭게 등장한 크리에이터 중 가장\n빛나는 인기 크리에이터를 소개합니다.',
      },
      funding_title: '주목할 만한 펀딩 프로젝트',
    },
    mypage: {
      question: {
        '문의 내용': '문의 내용',
        제목: '제목',
        내용: '내용',
        첨부파일: '첨부파일',
        '답변 내용': '답변 내용',
        before_answer_content: '크리에이터의 답변이 등록되지 않았습니다.',
        '답변 대기': '답변 대기',
        '답변 완료': '답변 완료',
        '추가 문의 내용': '추가 문의 내용',
        '추가 답변 완료': '추가 답변 완료',
        add_question: '추가 문의 접수',
        add_answer: '추가 답변 완료',
        shop_name: '샵 이름',
        product_name: '상품명',
        empty_title: '크리에이터 문의 내역이 없습니다.',
        empty_desc:
          '크리에이터 문의는 상품 상세 페이지 &gt; 구매 안내 또는 구매 내역 상세 페이지를 통해 가능합니다.',
        '최근 1년간 문의 내역만 확인 가능합니다.': '최근 1년간 문의 내역만 확인 가능합니다.',
        product_num: '상품 번호',
        do_add_question: '추가 문의하기',
        do_end_question: '문의 종료하기',
        'JPG, JPEG, PNG, ZIP, PDF 가능 | 최대 10MB': 'JPG, JPEG, PNG, ZIP, PDF 가능 | 최대 10MB',
      },
      no_like_creator_title: '좋아요한 크리에이터가 없어요.',
      no_like_creator_title_desc: '좋아하는 크리에이터에 좋아요를 눌러보세요.',
      no_like_product_title: '좋아요한 상품이 없어요.',
      no_like_product_title_desc: '내 취향의 상품에 좋아요를 눌러보세요.',
      order_deliver: '최근 주문・배송중',
      written_review: '작성한 리뷰',
      liked_products: '좋아요 한 상품',
      '이름을 입력해 주세요': '이름을 입력해 주세요.',
      '앱 설정': '앱 설정',
      app_setting: '앱 설정',
      creator_apply: '크리에이티브만 있다면 </br>당신도 마플샵 크리에이터!</br>',
      creator_apply_mo: '크리에이터 신청하기',
      creator_apply_mobile: '나만의 크리에이티브로',
      logout: '로그아웃',
      marppleshop: '상상하는 모든 것이 현실이 되는 마플샵',
      order: {
        title: '구매내역',
      },
      review: {
        title: '내가 쓴 글',
        empty_title: '작성한 리뷰가 없어요.',
        empty_desc: '좋아하는 크리에이터의 상품을 구매하고<br />첫 리뷰를 남겨 보세요!',
      },
      like: {
        title: '좋아요',
        empty_product_title: '좋아요한 상품이 없어요.',
        empty_creator_title: '좋아요한 크리에이터가 없어요.',
        empty_product_desc: '내 취향의 상품에 좋아요를 눌러보세요.',
        empty_creator_desc: '좋아하는 크리에이터에 좋아요를 눌러보세요.',
      },
      recent: {
        title: '최근 본',
        empty_product_title: '최근 본 상품이 없어요.',
        empty_creator_title: '최근 본 크리에이터가 없어요.',
        empty_product_desc: '마플샵에서 새로운 취향을 찾아보세요!',
        empty_creator_desc: '마플샵에서 마음에 드는 크리에이터를 찾아보세요!',
        empty_product_find: '마플샵 둘러보기',
        empty_creator_find: '크리에이터 찾아보기',
        product: ' 상품 <span class="count">{{count}}</span>',
        creator: ' 크리에이터 <span class="count">{{count}}</span>',
      },
      creator_question: {
        title: '크리에이터 문의 내역 확인',
      },
      creator_apply_prefix: '크리에이티브만 있다면',
      creator_apply_suffix: '당신도 마플샵 크리에이터!',
      funding_apply_prefix: '펀딩 목표 달성하면',
      funding_apply_suffix: '성수 오프라인 팝업 열어드려요',
    },
    popup_store: {
      rate: '{{rate}} 목표 달성',
      total: '총 판매금액 {{price}}원',
      status: {
        closed: '종료',
      },
      tooltip:
        '마플샵 팝업스토어는 마플샵과 크리에이터가<br /><b><u>함께 상품을 기획하고 제작</u></b>하여<br />고객들에게 선보이는 서비스입니다.',
      tooltip_link: '마플샵 팝업스토어 신청하기',
      archived: {
        sub_title: '마플샵 팝업스토어 아카이브',
        group_label: '{{year}}년 {{month}}월',
        title: '마플샵 팝업스토어 아카이브',
      },
      now: {
        sub_title: '현재 진행중인 마플샵 팝업스토어',
        go_upcoming: '진행 예정인 팝업스토어 구경하기',
        title: '현재 진행중인 마플샵 팝업스토어',
      },
      upcoming: {
        sub_title: '진행 예정인 마플샵 팝업스토어',
        openrun_btn: '오픈런 신청',
        go_now: '진행중인 팝업스토어 구경하기',
        title: '진행 예정인 마플샵 팝업스토어',
      },
      openrun_modal: {
        title: '팝업스토어 오픈런 신청',
        name_label: '팝업스토어명',
        alarm_label: '알림 선택',
        email_label: '이메일',
        email_holder: '이메일 주소를 입력해주세요',
        valid_email: '이메일 주소를 입력해주세요',
        valid_email2: '올바른 이메일 주소를 입력해주세요',
        alert_title: '오픈런 신청 완료!',
        alert_msg:
          '신청하신 팝업스토어가 오픈 24시간 전과\n30분 전에 메일이 발송됩니다.\n설레는 마음으로 기다려 주세요!',
        notice_li_1: '오픈 알림은 해당 팝업스토어 오픈일의 1일 전, 당일 오전 9시(총 2회)에 발송됩니다.',
        notice_li_2: '광고성 정보 수신 설정에 동의해야 알림 신청이 가능합니다.',
        notice_li_3: '일부 팝업스토어는 출시 연기 및 상황에 따라 오픈이 늦어질 수 있습니다.',
        cancel_btn: '취소',
        confirm_btn: '오픈런 알림 신청',
      },
      empty: {
        upcoming_title: '설레는 팝업스토어를 준비중이에요!',
        now_title: '진행중인 팝업스토어가 없어요!',
        archived_title: '진행중인 팝업스토어가 없어요!',
        desc: '더욱 다양한 취향을 위해\n팝업스토어를 준비하고 있어요.',
        last_popups: '지난 팝업스토어',
        see_more: 'See More',
      },
    },
    login: {
      email_placeholder: '이메일 입력',
      password_placeholder: '비밀번호 입력',
      login: '로그인',
      find_id: '아이디 찾기',
      reset_password: '비밀번호 재설정',
      invalid: '로그인 실패',
      invalid_description: '이메일 또는 비밀번호가 맞지 않습니다.<br>입력하신 정보를 다시 확인해 주세요.',
      need_login: {
        title: '로그인 안내',
        message: '로그인이 필요합니다.<br/>마플샵에 로그인하고 내 취향을 찾아보세요!',
      },
      email_verify_sent: '가입 시 작성된 이메일 주소로 인증 이메일을 발송해드렸습니다.',
      check_email: '메일함을 다시 확인해 주세요.',
      resend_email: '인증 이메일 재전송',
      change_email: '이메일 변경',
      email_send_ing: '이메일 전송 중',
      email_error: '이메일 오류',
      loading_title: '잠시만 기다려 주세요!',
      loading_guide: '요청하신 페이지로 이동중입니다.',
      error_title: '로그인 중 오류가 발생했어요.',
      error_guide: '잠시 후 다시 시도하거나,<br/>고객 지원팀에 문의해 주세요.',
      cs: '고객 센터',
      go_main: '메인으로 가기',
      try_later: '나중에 하기',
      go_retry: '다시 시도하기',
      creator_login_error_title: '다른 아이디로 로그인 후 메일 내 링크를 다시 눌러주세요.',
    },
    contents: {
      list_description: '관심 있을 만한 걸 가져왔어요 💘',
    },
    purchase_card: {
      title: '구매 인증 카드',
      creator_purchase_info_description: '<span><b>{{order}}번째</b>로</span><span>구매한 팬이에요!</span>',
      creator_purchase_card_info_description_1: '특별한 순간을 담은',
      creator_purchase_card_info_description_2: '인증 카드가 준비되어 있어요!',
      download_medium: '카드 다운로드',
      download_small: '다운로드',
      download_success: '구매 인증 카드가 저장되었습니다.',
      download: '{{store}}_마플샵_구매인증카드',
      konva: {
        purchased_at: '구매 날짜',
        count: '구매 수량',
      },
      status: {
        purchase: '구매 완료',
        before_purchase: '입금 대기',
      },
    },
    signup: {
      name_placeholder: '이름을 입력해 주세요.',
      email_placeholder: '이메일을 입력해 주세요.',
      password_placeholder: '로그인 시 사용할 비밀번호를 입력해 주세요.',
      email_invalid_message: '올바른 이메일 형식으로 작성해 주세요.',
      password_short_message: '10자 이상',
      password_invalid_message: '영문, 숫자, 특수문자 포함',
      signup: '회원가입',
      all_check_label: '전체 동의',
      terms_check_label: '이용약관 동의',
      privacy_check_label: '개인 정보 수집 및 이용 동의',
      age_check_label: '만 14세 이상입니다.',
      ad_check_label: '광고성 정보 수신 동의 (선택)',
      more: '보기',
      data_error: '검증되지 않은 데이터',
      data_error_message:
        '예기치 못한 오류로 인해 가입할 수 없습니다.<br>동일한 문제가 반복적으로 발생할 경우<br><a href="malito:cs@marppleshop.com" style="text-decoration-line: underline">cs@marppleshop.com</a>로 문의해주세요.',
      data_valid_error: '입력 정보 오류',
      data_valid_error_message:
        '유효한 이메일 주소 및 형식이 아닙니다.<br/>혹은 이름을 작성하지 않았거나, 특수 문자가 포함되어 있는지 확인해주세요.',
      check_error: '약관 동의 확인',
      check_error_message: '마플샵 가입을 위해 약관에 동의해 주세요.',
      email_duplicated: '이메일 중복',
      email_duplicated_message: '이미 가입된 이메일입니다.<br>기존 이메일로 로그인해 주세요.',
      resend: '재발송',
      email_verify: '이메일 인증하기',
      email_verify_message:
        '인증 이메일을 발송하였습니다.<br>이메일 확인 후 인증하기 버튼을 클릭하면<br>회원가입 인증이 완료됩니다.',
      email_verify_resend: '인증 이메일 재발송',
      email_verify_resend_message:
        '인증 이메일을 발송하였습니다.<br>몇 분 동안 도착하지 않으면<br>스팸메일함을 확인해 주세요.',
      email_verify_resend_fail: '인증 이메일 재발송 실패',
      email_verify_resend_fail_message: '요청 실패 다시 시도해 주세요.',
      welcome: '만나서 반가워요!',
      welcome_message:
        'MCO 통합 계정 가입이 완료되었어요.<br/>상상하는 모든 것이 현실이 되는 마플샵에서<br>나만의 취향을 찾아 떠나볼까요?',
      welcome_message_sns_connect:
        'MCO 통합 계정 연결이 완료되었어요.<br/>상상하는 모든 것이 현실이 되는 마플샵에서<br>나만의 취향을 찾아 떠나볼까요?',
      welcome_label: '마플샵 시작하기',
      consecutive_char_error: '비밀번호 사용 불가',
      consecutive_char_error_message: '비밀번호에 연속된 글자 혹은 숫자를<br>사용할 수 없습니다.',
      email_password_error: '비밀번호 사용 불가',
      email_password_error_message: '비밀번호를 입력된 이메일과<br>동일한 문자를 사용할 수 없습니다.',
      invalid_password_error: '비밀번호 사용 불가',
      invalid_password_error_message:
        '비밀번호는 10자 이상으로, 영문, 숫자, 특수문자를 모두 포함해야 합니다.',
      to_login: '로그인 하기',
      close: '닫기',
    },
    curation: {
      page_description: '마플샵의 상품들을 소개할게요!',
      page_sub_title: '이 세상의 다양한 취향을 위해',
    },
    creator_view: {
      page_sub_title: '크리에이터가 직접 들려주는 이야기',
    },
    reset_password: {
      title: '비밀번호 재설정',
      email: '이메일',
      email_placeholder: '이메일을 입력해 주세요.',
      request_change_email: '비밀번호 변경 이메일 받기',
      send_title: '비밀번호 변경 메일 전송',
      send_message:
        '비밀번호 재설정을 위한 메일을 전송했습니다.<br/>몇 분 내에 메일을 받지 못했다면,<br/>스팸메일함을 확인하세요.',
      error_title: '비밀번호 재설정 불가',
      error_no_email: '비밀번호 재설정 메일을 보낼 수 없습니다.<br/>메일 주소를 확인해주세요.',
      change: '비밀번호 변경',
      new_password: '새 비밀번호',
      new_password_placeholder: '새로운 비밀번호를 입력해 주세요.',
      error_new_password_length: '10자 이상',
      error_new_password_valid: '영문, 숫자 특수문자 포함',
      new_password_check: '새 비밀번호 확인',
      new_password_check_placeholder: '새로운 비밀번호를 한번 더 입력해 주세요.',
      new_password_check_valid: '비밀번호 일치',
      error_no_password: '비밀번호가 비어있습니다.',
      error_no_password_check: '비밀번호 확인이 비어있습니다.',
      error_password_no_equal: '비밀번호가 일치하지 않습니다.',
      error_code_invalid: '인증코드가 유효하지 않습니다.',
      error_no_user: '입력하신 정보와 일치하는 계정이 없습니다.',
      error_current_password_same: '예전 비밀번호와 동일한 비밀번호는<br/>사용할 수 없습니다.',
      success_title: '비밀번호 재설정 완료',
      success_message: '비밀번호가 변경되었습니다.',
    },
    cart: {
      title: '장바구니',
      check_cart: '장바구니 확인',
      change: '변경',
      option_changed: '상품을 장바구니에 다시 담아주세요. (옵션 구매불가)',
      no_stock: '상품을 다시 확인 해주세요. (상품 또는 옵션 품절)',
      not_enough_stock: '상품을 장바구니에 다시 담아주세요. (재고 부족)',
      discontinued: '상품이 구매 불가능한 상태에요. (상품 또는 옵션 품절)',
      empty_title: '장바구니가 비어있어요!',
      empty_desc: '다양한 상품을 구경하고<br />나에게 맞는 상품을 담아보세요!',
    },
    search: {
      all: '전체',
      product: '상품',
      goods: '굿즈',
      handmade: '핸드메이드',
      brand_deal: '브랜드딜',
      ebook: '전자책',
      review: '리뷰',
      plus_shop: '플러스샵',
      creator: '크리에이터',
      popup_store: '팝업스토어',
      curation: '큐레이션',
      recommend: '추천 상품',
      title1: '의',
      title2: '개',
      title3: '의',
      title4: '검색 결과',
      recent_search: '최근 검색어',
      recent_empty: '최근 검색어 내역이 없습니다.',
      popular_search: '인기 키워드',
      empty_title: '검색 결과가 없어요.',
      empty_body: '다른 검색어를 입력하거나<br />철자와 띄어쓰기를 확인해 보세요.',
    },
    checkout: {
      temp_user_info:
        '입력한 주문자 정보로 자동 회원가입이 진행되며,{{- br}} 주문 이후 로그인하여 구매내역 확인이 가능합니다.',
      check_pass_title: '비밀번호 재입력 요청',
      input_user_info: '주문자 정보 입력',
      input_shipping_info: '배송지 정보 입력',
      duplicate_email: '중복 이메일',
      profile_change: '계정 설정',
      header: '주문서 완료',
    },
    plus: {
      content: '콘텐츠',
      limited: '한정 상품',
      best_product: '베스트 상품',
      ready_for_contents: '콘텐츠를 준비 중입니다.',
      see_products_waiting_contents: '콘텐츠가 준비되는 동안<br/>다양한 상품들을 만나볼까요?',
      see_products: '마플샵 둘러보기',
    },
    plus_studio: {
      upload: '업로드',
      file: {
        image_size: '{{width}}px * {{height}}px',
        accepts: 'JPG, JPEG, PNG, GIF',
        accepts_without_gif: 'JPG, JPEG, PNG',
        max_file_volume: '최대 {{max_file_volume}}MB',
      },
      brand: {
        title: '브랜드 관리',
        description: '색상, 로고 등의 브랜드 아이덴티티를 반영하여 사이트에 적용해 보세요.',
        button: '저장하기',
        information_title: '기업 정보',
        plus_cover_title: '플러스샵 커버',
        meta_tag_title: '메타 태그 설정',
        logo_title: '플러스샵 로고',
        name_title: '플러스샵 이름',
        description_title: '플러스샵 소개',
        official_title: '공식 홈페이지 URL',
        youtube_title: '유튜브 URL',
        instagram_title: '인스타그램 URL',
        x_title: 'X URL',
        naver_blog_title: '네이버 블로그 URL',
        tiktok_title: '틱톡 URL',
        facebook_title: '페이스북 URL',
        afreeca_title: 'SOOP URL',
        chzzk_title: '치지직 URL',
        pc_cover_title: 'PC 이미지',
        pc_cover_description:
          'PC 커버 이미지는 중앙 기준 1440px * 640px을 벗어날 경우 일부 디바이스에서 보이지 않을 수 있습니다.',
        mo_cover_title: '모바일 이미지',
        og_image_title: 'OpenGraph 이미지',
        og_image_description: '권장 사이즈 (가로 1200px, 세로 600px)',
        og_title_title: 'OpenGraph 제목',
        og_description_title: 'OpenGraph 내용',
        logo_description:
          '정사각형 비율의 이미지 파일을 업로드 해주세요.<br/>(최소 사이즈 400px / 배경 없는 PNG 가능 / 1MB 이하)',
        logo_upload: '업로드',
        pc_cover_size: '사이즈 2560px * 640px',
        pc_cover_type: 'PNG, JPG, JPEG 가능',
        pc_cover_volume: '최대 3MB',
        pc_cover_upload: 'PC 플러스샵 커버 이미지를<br/>등록해 주세요.',
        mo_cover_size: '사이즈 750px * 1276px',
        mo_cover_type: 'PNG, JPG, JPEG 가능',
        mo_cover_volume: '최대 3MB',
        mo_cover_upload: '모바일 플러스샵 커버 이미지를<br/>등록해 주세요.',
        title_placeholder: '플러스샵 {{name}} 이름을 입력해 주세요.',
        description_placeholder: '홈에 소개될 플러스샵 {{name}} 소개 내용을 입력해 주세요.',
        og_title_placeholder: 'OpenGraph {{name}} 제목을 입력해 주세요.',
        og_description_placeholder: 'OpenGraph {{name}} 내용을 입력해 주세요.',
      },
      upload_placeholder: '첨부된 파일이 없습니다.',
      live: {
        live_01: '게시 예약',
        live_02: '예약 공개',
        live_03: '예약 종료',
        live_04: '플러스샵 홈 화면에 노출할 동영상 콘텐츠를 만들고 관리해 보세요.',
        live_05: '동영상 배너 관리',
        live_06: '상품의 URL을 입력해 주세요.',
        live_07: '공개 개수가 초과되었습니다.<br/>배너의 공개 상태가 비공개로 등록됩니다.',
        live_08: '공개 개수가 초과되었습니다.<br/>최대 5개까지 공개할 수 있습니다.',
        live_09: '동영상 배너를 삭제하시겠습니까?',
      },
      banner: {
        editor_title: '프로모션 배너 등록',
        editor_title_2: '프로모션 배너 수정',
        title: '프로모션 배너 관리',
        description: '플러스샵 홈 화면 배너에 노출될 콘텐츠를 추가하고 관리해 보세요.',
        tab_01: '전체 콘텐츠 관리',
      },
      ga_service: {
        menu: '외부 서비스 연동',
        title: '외부 서비스 연동',
      },
      popup: {
        enroll: {
          title: '팝업 등록',
          plus_description: '플러스샵 홈에 노출할 팝업을 새로 등록합니다.',
          all_description: '마플샵 홈과 스튜디오에 노출할 팝업을 새로 등록합니다.',
          cancel_button: '취소',
          submit_button: '등록',
          submit_success_modal_title: '팝업 등록 완료',
          submit_success_home_modal_title: '마플샵 홈 등록 완료',
          submit_success_studio_modal_title: '스튜디오 전체 등록 완료',
          submit_success_modal_message:
            '팝업이 정상 등록되었습니다.\n등록된 위치는 각 설정 화면에서 확인해 주세요.',
          delete_modal_title: '팝업 입력 취소',
          delete_modal_message: '입력 중인 내용은 저장되지 않습니다.\n이전 페이지로 돌아가시겠습니까?',
        },
        modify: {
          title: '팝업 수정',
          plus_description: '플러스샵 홈에 노출되는 팝업을 수정합니다.',
          all_description: '마플샵 홈과 스튜디오에 노출되는 팝업을 수정합니다.',
          cancel_button: '삭제',
          submit_button: '수정',
          submit_success_modal_title: '팝업 수정 완료',
          submit_success_home_modal_title: '마플샵 홈 수정 완료',
          submit_success_studio_modal_title: '스튜디오 전체 수정 완료',
          submit_success_modal_message:
            '팝업이 정상 수정되었습니다.\n 등록된 위치는 각 설정 화면에서 확인해 주세요.',
          delete_modal_title: '팝업 삭제',
          delete_modal_message: '팝업 삭제 시 복구할 수 없습니다.\n해당 팝업을 삭제하시겠습니까?',
          delete_success_modal_title: '팝업 삭제 완료',
          delete_success_modal_message: '해당 팝업의 삭제가 완료되었습니다.',
        },
        image_description: '팝업 이미지를 등록해 주세요.',
        popup_title: '팝업 타이틀',
        popup_title_placeholder: '팝업 타이틀을 입력해 주세요.',
        popup_title_description: '팝업 관리를 위한 타이틀로 외부에는 노출되지 않습니다.',
        exposure_duration: '노출 기간',
        exposure_duration_description: '비공개 등록을 원할 경우 현재의 날짜보다 이전의 날짜로 설정해 주세요.',
        popup_image: '팝업 이미지',
        close_icon_color: '닫기 아이콘 컬러',
        button_bg_color: '버튼 배경 컬러',
        button_text_color: '버튼 텍스트 컬러',
        link_url: 'URL 주소',
        link_url_placeholder: '팝업 이미지 클릭 시 이동할 URL을 입력해 주세요.',
        link_url_description: 'URL을 입력하지 않을 경우 클릭이 되지 않습니다.',
        link_url_studio_description:
          'URL을 입력하지 않을 경우 클릭이 되지 않습니다. http~ 로 시작하는 주소 입력시 외부링크로 이동, /~ 로 시작하는 주소 입력시 외부 링크로 이동합니다.',
        exposure_location: '노출 화면',
        exposure_home: '마플샵 홈',
        exposure_studio: '스튜디오 전체',
        preview_title: '미리보기',
        sort_success_title: '팝업 정렬 완료',
        sort_success_message: '팝업 정렬이 완료되었습니다.\n각 설정 화면에서 확인해 주세요.',
      },
      creator: {
        sort: {
          title: '크리에이터 정렬',
          desc: '홈과 크리에이터 페이지에서 추천순으로 보여주고 싶은 크리에이터의 순서를 변경해 보세요.',
          sort_title: '정렬 순서',
          sort_desc: '드래그 앤 드롭으로 순서를 변경해 보세요.',
          clipboard_title: '클립 보드',
          clipboard_desc: '정렬 중인 크리에이터를 잠시 보관할 수 있습니다.',
          empty_box_desc:
            '크리에이터를 드래그하여 보관했다가<br/>다시 왼쪽의 정렬 영역에 옮겨 이동하면<br/>정렬을 변경할 수 있습니다.',
          success_title: '크리에이터 정렬 완료',
          success_message: '크리에이터 정렬이 변경되었습니다.<br/>플러스샵 홈에서 확인해 주세요.',
          check_clipboard_title: '클립보드 확인',
          check_clipboard_desc:
            '클립보드에 정렬되지 않은 크리에이터가 있습니다.<br/>모든 정렬을 완료 후 저장 버튼을 눌러주세요.',
          button: '저장하기',
        },
      },
    },
    seller_studio: {
      shop_management: {
        shop_info: {
          save: '저장',
          ciety: {
            label: '사이어티 커뮤니티 연동',
            button: '사이어티 커뮤니티 만들기',
            prefix: 'ciety.xyz/@',
            placeholder: '사이어티 커뮤니티 도메인을 입력해 주세요.',
            connecting: '연동 요청중',
            disconnect: '연동 해제',
            disconnect_confirm_message_title:
              '마플샵 크리에이터 샵과 커뮤니티의 연동이 해제됩니다.\n아래 내용을 꼭 확인해 주세요.',
            disconnect_confirm_message_1:
              '연동을 해제하면, 멤버십 플랜의 커뮤니티 혜택과 커뮤니티의 멤버십\n그룹이 모두 삭제됩니다.',
            disconnect_confirm_message_2: '멤버십 회원에게 커뮤니티 혜택 삭제 안내 메일이 자동 발송됩니다.',
            disconnect_confirm_message_3: '이 작업은 되돌릴 수 없으니 신중히 진행해 주세요.',
            is_mobile: 'PC에서 진행해 주세요.',
          },
          category: {
            label: '카테고리',
            select: '선택',
          },
          style: {
            label: '스타일',
            add: '추가',
            edit: '수정',
            title: '크리에이터 스타일',
            cancel_button: '취소',
            save_button: '저장하기',
          },
          phone: {
            label: '고객센터 번호',
          },
        },
      },
      membership_setting: {
        title: '멤버십 설정',
        tooltip_content:
          '· 선택한 멤버십에 가입한 회원만 구매할 수 있는 상품으로 적용됩니다.\n· 멤버십 플랜이 공개 상태일 때, 멤버십 상품 판매가 시작됩니다.',
        private: '비공개',
      },
      navigation: {
        welcome: '마플샵 시작하기',
        product_sales_analytics: '상품별 누적판매량',
        mps_product: '마플샵제작배송 상품',
        make_product: '상품 등록',
        orders: '주문 내역',
        creator_product: '크리에이터배송 상품',
        shipping: '배송 관리',
        digital_product: '디지털/전자책 상품',
        creator_design: '크리에이터 디자인',
        creator_design_guide: '크리에이터 디자인 소개',
        question: '고객 문의',
        customer_management: '고객 관리',
        adjustments: '정산 관리',
        creator_support: '지원센터',
        youtube_connect: '유튜브 쇼핑 연동',
        product_adjustments: '정산 내역',
        open_api: '외부서비스 연동 (API)',
        orders_management: '주문 관리',
        membership_commission_support: '멤버십/커미션/후원',
        membership: '멤버십 만들기',
        commission: '커미션 만들기',
        support: '후원 만들기',
        membership_commission_support_management: '멤버십/커미션/후원 관리',
        membership_guide: '서비스 소개',
        membership_adjustments_share: '수익 비율 설정',
        product_inquiry: '상품 문의',
        product_management: '상품 관리',
        sales_management: '판매 관리',
        integrated_order_search: '주문통합검색',
      },
      editor: {
        pbg: {
          new: {
            title: '상품 등록하기',
          },
          modify: {
            title: '상품 수정하기',
          },
        },
        tpl: {
          modify: {
            title: '입고 상품 수정하기',
          },
        },
        oversea: {
          modify: {
            title: '입고 상품 수정하기',
          },
        },
      },
      creator_design: {
        new_creator_design_title: '새로운 크리에이터 디자인 테마 등록',
        edit_creator_design_title: '테마 관리',
        creator_design_guide_desc: '새로운 수익 만드는 방법 확인하기',
        enroll: {
          title: '크리에이터 디자인',
          description: '디자인 파일만 등록하면, 마플 플랫폼에서 사용될 때마다 수익을 드려요.',
          description_mo: '디자인 파일만 등록하면,<br />마플 플랫폼에서 사용될 때마다 수익을 드려요.',
          add_card_description: '나만의 디자인을 테마로\n등록하고 판매해 볼까요?',
        },
        button: {
          tmp_save: '임시저장',
          register: '심사 등록하기',
          add_design: '디자인 추가',
          active_end_date: '판매 종료일',
          add_tag: '태그 설정',
          cancel: '취소',
          save: '저장하기',
          next: '다음으로',
          save_2: '저장',
        },
        status: {
          editing: '작성중',
          open: '공개',
          closed: '비공개',
          pending: '심사중',
          rejected: '심사반려',
          discontinued: '판매중지',
          scheduled: '예약 게시',
        },
        price_types: {
          light: '라이트',
          standard: '스탠다드',
          premium: '프리미엄',
          standard_desc: '더 많은 판매와 관심을 기대할 수 있습니다.',
          premium_desc: '나만의 팬을 위한 차별화된 옵션입니다.',
        },
        custom_permission_types: {
          normal: '자유',
          restricted: '제한',
          normal_desc:
            '다른 크리에이터의 테마, 유저 콘텐츠(텍스트, 이미지)를\n함께 사용하여 자유롭게 커스텀 하는 것을 허용합니다.',
          restricted_desc:
            '크리에이터님의 디자인만 사용하여 커스텀 할 수 있으며\n다른 콘텐츠와 동시에 사용할 수 없도록 제한합니다.',
        },
        applicable: '해당',
        not_applicable: '해당하지 않음',
        not_sure: '확실하지 않음',
        used: '사용함',
        unused: '사용하지 않음',
        edit_mode: '테마 수정',
        discontinued: '테마 비공개',
        continued: '테마 공개',
        is_public: '테마 공개 여부',
        copy_theme: '새로운 테마로 복제',
        delete_theme: '테마 삭제',
        discontinue_theme: '강제 판매 중단',
        reopen_theme: '판매 재개',
        dark_mode: '어두운 배경색 보기',
        select_tag: '태그 선택',
        theme_name: '테마 명',
        theme_desc: '테마를 잘 표현하면서 부르기 쉬운 이름을 입력해주세요.',
        no_theme_list:
          'PC에서 테마를 등록하고<br />더 많은 사람들에게 디자인을 알리면서<br />수익을 만들어보세요!',
        category: '카테고리',
        tag: '태그',
        topic_tag_setting: '주제 태그',
        usage_tag_setting: '상황 태그',
        topic_tag_message: '디자인을 잘 표현하는 태그를 선택해주세요. (최대 6개)',
        usage_tag_message: '사용 용도나 상황에 어울리는 태그를 1개 선택해 주세요.',
        topic_no_items: '이 테마에 포함된 디자인의 주제를 선택해 주세요.',
        usage_no_items: '이 테마에 어울리는 상황을 표현할 태그를 선택해주세요.',
        sale_start_date: '판매 시작일 (선택)',
        sale_end_date: '판매 종료일 (선택)',
        sale_date_desc: '심사 통과 즉시 혹은 설정한 판매 시작일 0시부터 마플에 공개됩니다.',
        sale_end_date_desc: '설정한 판매 종료일 23:59:59까지만 마플에 공개됩니다.',
        sale_date_err: '판매 종료일은 시작일보다 이후로 설정해 주세요.',
        sale_date_label: '판매 기간 설정',
        ai_label: 'AI 사용 여부',
        age_limit_label: '연령제한 콘텐츠 여부',
        ai_info: 'AI를 사용한 이미지일 경우 선택',
        age_info: '연령제한(주류, 담배, 성인물, 도박, 마약, 폭력, 자해, 무기) 이미지 등록 불가',
        select_license: '라이선스',
        select_sale_price: '로열티 비율',
        license_field: '크리에이터님의 디자인으로 만든 커스텀 상품의 사용 가능 범위를 설정해주세요.',
        license_info: '라이선스 안내',
        agreement_label: '이용약관 동의',
        thumbnail_label: '대표 이미지',
        thumbnail_info: '대표 이미지를 설정하지 않으면 가장 먼저 추가한 파일이 대표 이미지가 됩니다.',
        thumbnail_info_2: '정방형 비율이 아닐 경우 대표 이미지의 상하좌우가 잘려 보일 수 있습니다.',
        thumbnail_desc: '매력적인 대표 이미지는 더 많은 관심과 높은 판매로 이어집니다.',
        thumbnail_guide_01: '이미지 비율 : 정방형',
        thumbnail_guide_02: '최대 사이즈 : 1,440 x 1,440px',
        thumbnail_guide_03: '파일 형식 : PNG, JPG',
        thumbnail_guide_04: '용량 : 1MB 이하',
        price_type_desc: '제품이 판매될 때마다 설정한 로열티 비율에 따라 수익을 받습니다.',
        detail_info_btn: '자세히 보기',
        custom_permission_desc:
          '크리에이터님의 디자인을 다른 콘텐츠와 함께 혼합 사용하는 것을 허용할지 설정해 주세요.',
        custom_permission: '디자인 혼합 사용',
        agree_info: '이용약관을 확인했으며 이에 동의합니다.',
        theme_upload_info: '파일명은 크리에이터님의 마플샵 스튜디오, 테마 관리 화면에서만 보입니다.',
        theme_upload_info_2: '여백이 없는 이미지를 등록해 주세요.',
        no_theme: '등록된 디자인이 없습니다.',
        upload_theme_msg: '테마에 포함시킬 디자인을 업로드해 주세요.',
        file_upload_guide_01: '이미지 권장 비율 : 정사각형(정방형)',
        file_upload_guide_02: '파일 형식 : PNG (투명 배경 권장), JPG',
        file_upload_guide_03: '이미지 사이즈 : 긴 변 크기 3,000px 이상 8,000px 미만',
        file_upload_guide_04: '최대 이미지 사이즈 : 가장 긴 변 기준 8,000px',
        file_upload_guide_05: '용량 : 4MB 이하',
        file_upload_guide_06: '컬러 모드 : RGB 컬러 필수',
        file_upload_guide_07: '업로드 가능 개수 : 최소 8개 / 최대 24개',
        agreements: {
          title_01: '크리에이터 디자인 서비스에 관한 특칙',
        },
        license: {
          commercial: '상업용',
          non_commercial: '개인용',
          commercial_desc:
            '2차 판매, 단체 판촉, 광고 마케팅 등에 사용될 수 있어\n대량 주문 등으로 인한 높은 수익도 기대할 수 있습니다.',
          non_commercial_desc:
            '영리적 목적이 아닌 친목 활동, 개인적인 사용이나\n선물 용도로만 사용될 수 있습니다.',
        },
        notify: {
          title_01: '이 테마의 디자인 전체를\nAI 생성 이미지로 간주합니다',
          message_01: 'AI 사용 이미지 판매로 인해 발생하는\n모든 책임은 크리에이터님에게 있습니다.',
          title_02: '업로드한 이미지가\n양식에 맞지 않습니다',
          message_02: '디자인 파일 양식을 확인한 후\n다시 업로드해주세요.',
          title_03: '디자인 삭제하기',
          message_03: '삭제한 디자인은 복구할 수 없습니다.\n디자인을 삭제하시겠습니까?',
          title_04: '라이선스/가격대를 변경하시겠어요?',
          message_04:
            '라이선스/가격대 변경은 테마 재등록이 필요합니다.\n원하시는 라이선스를 선택 후 심사를 요청해주세요.',
          title_05: '테마 삭제하기',
          message_05: '테마를 삭제하더라도 이미 판매된 디자인은\n회수가 불가능합니다.',
          message_05_2: '삭제한 테마는 복구할 수 없습니다.\n테마를 삭제하시겠습니까?',
          title_06: '판매를 중단하시겠어요?',
          message_06: '다시 판매를 재개할 때까지 \n이 테마는 마플에 보여지지 않습니다.',
          title_07: '상업용 사용을 허락합니다',
          title_07_2: '개인용 사용만 허락합니다',
          message_07: '심사등록 후 라이선스를 변경할 수 없습니다.\n라이선스 옵션을 신중히 선택해주세요.',
          title_08: '업로드한 이미지가\n양식에 맞지 않습니다',
          message_08: '대표 이미지 등록 양식을 확인한 후\n다시 업로드해주세요.',
          title_09: '디자인 삭제 불가 안내',
          message_09: '판매 가능한 테마에는\n최소 8개의 디자인이 있어야 합니다.',
          title_10: '이미지 여백 정리 완료',
          message_10: 'PNG 이미지의 여백을 크롭하여\n보기 좋게 다듬어 드렸습니다.',
          title_11: '지금 테마를 수정하면\n다시 심사 등록을 해야 합니다',
          message_11: '아직 심사가 완료되지 않은 테마입니다.\n수정 후 다시 심사를 등록해주세요.',
          title_12: '선택 가능한 개수 초과',
          message_12: '주제 태그는 최대 6개까지 설정할 수 있습니다.\n테마에 가장 알맞는 태그를 선택해주세요.',
          title_13: '테마 판매 중지 안내',
          message_13:
            '저작권 침해 신고, 운영정책 위반 등으로 인해\n판매가 중지되었습니다.\n신고내역, 1대1 문의 등을 통해 확인해주세요.',
          title_14: '선택한 옵션을 확인해주세요',
          message_14:
            '로열티, 라이선스, 디자인 혼합 사용 옵션은\n심사 등록 후 수정이 불가능합니다.\n원하는 옵션을 정확히 선택하셨는지 확인해 주세요.',
          title_15: '크리에이터 정보 입력 안내',
          message_15:
            '테마를 등록하려면 본인/사업자 인증이 필요합니다.\n샵관리 → 크리에이터 정보에서 입력해주세요.',
          title_16: '연령제한 콘텐츠는\n판매할 수 없습니다',
          message_16:
            '「정보통신망 이용촉진 및 정보보호 등에 관한 법률」에\n의거 만 19세 미만에게 제공이 제한되는 콘텐츠는\n크리에이터 디자인으로 등록할 수 없습니다.',
          title_17: 'PC에서 등록, 관리해 주세요',
          message_17: '크리에이터 디자인은\n데스크탑 환경에서 등록, 관리할 수 있습니다.',
          title_18: '승인된 크리에이터만\n등록할 수 있습니다',
          message_18: '크리에이터 승인이 완료된 후\n테마를 등록해주세요.',
          title_19: '해당 디자인 {{is_public}}',
          message_19: '선택한 디자인을\n마플에서 {{is_public}} 처리합니다.',
          title_20: '테마 판매중지',
          message_20:
            '선택한 디자인을 비공개하면\n테마 디자인 최소 수량(8개)을 충족하지 못하여\n테마가 판매중지됩니다.',
          title_21: '디자인 업로드 개수 초과',
          message_21: '디자인 파일은 한 번에\n24개까지만 업로드 할 수 있어요.',
          title_22: '디자인 업로드 결과',
        },
        guide: {
          title: '디자인 파일을 등록하고<br />자동 판매 수익을 만들어보세요!',
          description:
            '매달 20개 이상 신규 출시되는 마플샵제작상품을 매번 디자인하기 힘드셨다면,<br />크리에이터 디자인 상품을 등록해보세요.<br />커스텀 플랫폼 마플에서 크리에이터님의 디자인이<br />제작에 사용될 때마다 판매 수익을 지급해드립니다.',
          description_mo:
            '매달 20개 이상 신규 출시되는 마플샵제작상품을<br />매번 디자인하기 힘드셨다면,<br />크리에이터 디자인 상품을 등록해보세요.<br />커스텀 플랫폼 마플에서 크리에이터님의 디자인이<br />제작에 사용될 때마다 판매 수익을 지급해드립니다.',
          section_title_01: '디자인 파일만 등록하면 <br />상품 판매는 마플에서 알아서 척척!',
          section_tag: '마플샵제작상품을 매번 만들고 등록하지 않아도 되는 간편함!',
          section_tag_mo: '마플샵제작상품을 매번 만들고<br />등록하지 않아도 되는 간편함!',
          section_title_02: '크리에이터 디자인을 등록하고<br />200만 명이 넘는 마플 고객에게 판매해 보세요',
          section_title_02_mo:
            '크리에이터 디자인을 등록하고<br />200만이 넘는 마플 고객에게<br />판매해 보세요',
          section_desc_02:
            '더 특별한 나만의 커스텀 상품을 갖고 싶은 200만 마플 고객이<br />크리에이터님의 디자인을 이용해 상품을 제작 합니다.<br />커스텀 및 굿즈에 관심 많은 200만 마플 고객에게 크리에이터를 홍보할 수 있습니다.',
          section_desc_02_mo:
            '더 특별한 나만의 커스텀 상품을 갖고 싶은<br />200만 마플 고객이<br />크리에이터님의 디자인을 이용해 상품을 제작 합니다.<br />커스텀 및 굿즈에 관심 많은 200만 마플 고객에게<br />크리에이터를 홍보할 수 있습니다.',
          section_title_03: '오직 마플샵만 가능한<br />크리에이터 디자인 판매 수수료 0원!',
          section_desc_03:
            '결제대행서비스(PG) 수수료를 제외한 크리에이터 디자인 판매 수익은 온전히 크리에이터님의 수익이 됩니다.<br />더 많은 사람들에게 크리에이터님의 디자인을 알리고, 판매해 보세요.',
          section_desc_03_mo:
            '결제대행서비스(PG) 수수료를 제외한<br />크리에이터 디자인 판매 수익은<br />온전히 크리에이터님의 수익이 됩니다.<br />더 많은 사람들에게 크리에이터님의 디자인을<br />알리고, 판매해 보세요.',
          section_title_04: '13만개 이상의 누적 리뷰와<br />15년 업력이 검증하는 마플의 제작 퀄리티',
          section_title_04_mo: '13만개 이상의 누적 리뷰와<br />15년 업력이 검증하는<br />마플의 제작 퀄리티',
          section_desc_04:
            '크리에이터님의 디자인은 소중하니까 —<br />평균 별점 ★4.86, 재주문율 65.3% — 마플의 믿을 수 있는 퀄리티로 안심하고 판매해 보세요.',
          section_desc_04_mo:
            '크리에이터님의 디자인은 소중하니까 —<br />평균 별점 ★4.86, 재주문율 65.3% —<br />믿을 수 있는 퀄리티로 안심하고 판매해 보세요.',
          section_faq_title: '크리에이터 디자인 FAQ',
          support: '크리에이터 디자인을 등록하고 싶은데<br />도움이 필요하신가요?',
          step: {
            title_01: '테마 등록',
            desc_01: '여러 개의 파일을 테마로 묶어<br />심사 등록 합니다.',
            title_02: '심사 진행',
            desc_02: '심사 등록 후 14일 이내로<br />심사결과를 전달해드립니다.',
            title_03: '마플 판매',
            desc_03: '심사 통과 시 자동으로<br />마플에서 판매가 시작됩니다.',
            title_04: '정산',
            desc_04: '구매확정 7일 후 정산내역이<br />자동으로 업데이트됩니다.',
          },
          button: {
            inquire: '마플샵에 문의하기',
            creator_info: '크리에이터 디자인 소개',
            go_to_register: '지금 바로 크리에이터 디자인 등록하기',
          },
          faq: {
            q_01: '크리에이터 디자인은 어떻게 판매하나요?',
            q_02: '판매 수익은 어떻게 계산되나요?',
            q_03: '로열티 비율은 무엇이고 어떻게 설정하나요?',
            q_04: '상업적으로 사용이 가능/불가능 하도록 라이선스를 설정할 수 있나요?',
            q_05: '특정 기간만 판매할 수 있나요?',
            q_06: 'AI로 생성한 이미지도 등록할 수 있나요?',
            q_07: '크리에이터 디자인 등록 전에 꼭 알아야 할 점이 있나요?',
            a_011:
              '크리에이터 디자인은 최대 24개의 이미지를 묶은 “테마” 형태로 등록, 관리합니다.<br />테마 등록 후 심사를 신청하면, 약 2주의 판매 심사 후 판매가 가능 상태가 됩니다.<br />테마 개수는 제한이 없으나 동일한 이미지 또는 판매할 수 없는 이미지를 반복 등록하는 등 마플 서비스의 품질을 저해하는 시도가 발견되면 테마 등록을 제한할 수 있습니다.',
            a_021:
              '크리에이터 디자인을 사용해 구매한 제품의 기준 가격에 로열티 비율, 구매 수량을 곱하여 계산됩니다.<br />자세한 내용은 <a href="https://www.marppleshop.help/ko/articles/%ED%81%AC%EB%A6%AC%EC%97%90%EC%9D%B4%ED%84%B0-%EB%94%94%EC%9E%90%EC%9D%B8-%EC%95%8C%EC%95%84%EB%B3%B4%EA%B8%B0-097954ea#%ED%81%AC%EB%A6%AC%EC%97%90%EC%9D%B4%ED%84%B0-%EB%94%94%EC%9E%90%EC%9D%B8-%EA%B0%80%EA%B2%A9-%EC%82%B0%EC%A0%95-%EB%B0%A9%EC%8B%9D" target="_blank" style="text-decoration: underline;">크리에이터 디자인 산정 방식</a>에서 확인하실 수 있습니다.',
            a_031:
              '크리에이터 수익 시 산정 시 곱해지는 요율(%)입니다. 테마 등록 시 2종류의 로열티 비율 중 선택할 수 있습니다.',
            a_032:
              '<span style="display: block; margin-left: 1em;">• 스탠다드 1%</span><span style="display: block; margin-left: 1em;">• 프리미엄 3%</span>',
            a_033: '심사가 통과된 후 로열티 비율은 수정할 수 없습니다. ',
            a_041:
              '네, 가능합니다. 테마 등록 화면에서 상업용 / 개인용(비상업용) 라이선스 설정 옵션을 제공하고 있습니다.',
            a_042:
              '설정한 라이선스의 적법성 및 정확성은 크리에이터님이 스스로 확인하셔야 하며, 설정된 라이선스를 초과하거나 위반하여 판매 시 발생하는 문제에 대한 책임은 크리에이터께 있습니다.',
            a_051:
              '네, 가능합니다. 테마 등록 화면에서 제공되는 판매 시작일 / 종료일 설정 기능으로 크리에이터님께서 원하시는 기간만 판매할 수 있습니다.',
            a_052:
              '설정한 판매 기간 이후에는 마플에서 “비노출” 처리가 되며, 원하는 경우 다시 판매를 재개하실 수 있습니다.',
            a_061:
              '네, 가능합니다. 다만 테마 등록 화면에서 반드시 AI 생성 여부를 체크해 주셔야 하며 AI 생성 이미지 판매로 인한 문제 발생 시 모든 책임은 크리에이터님에게 있습니다.',
            a_062:
              '구체적으로, AI 생성 이미지 사용으로 인한 저작권, 초상권, 기타 제3자의 권리 침해에 대한 모든 법적 책임은 크리에이터께 있으니 등록 시 세심한 주의가 필요합니다.',
            a_071:
              '테마가 등록된 후 디자인이 마플에서 1번이라도 판매된 경우 테마/디자인을 삭제해도 이미 제작된 상품은 회수할 수 없습니다.',
            a_072:
              '등록된 테마, 디자인에 대해 도용/라이선스 문제가 제기될 경우 등록된 테마는 즉시 판매 중지 처리될 수 있으며, 경우에 따라 크리에이터에게 손해배상이 청구될 수 있습니다.',
          },
        },
      },
      popup: {
        sort_option: {
          all: '전체',
          public: '공개',
          private: '비공개',
          reservation: '공개 예정',
        },
        tab: {
          all: '전체 팝업',
          sort: '팝업 정렬 변경',
        },
        list: {
          title: '팝업 관리',
          description: '크리에이터샵 메인에 노출할 팝업을 관리합니다.',
          submit_button: '등록하기',
          save_button: '저장하기',
          add_card_description: '크리에이터샵 메인에 노출될\n팝업을 추가하고 관리해 보세요.',
          mo_add_card_description: '크리에이터샵 메인에\n노출될 팝업을 추가하고\n관리해 보세요.',
        },
        enroll: {
          title: '팝업 등록',
          description: '크리에이터샵 메인에 노출할 팝업을 새로 등록합니다.',
          cancel_button: '취소',
          submit_button: '등록',
        },
        modify: {
          title: '팝업 수정',
          description: '크리에이터샵 메인에 노출되는 팝업을 수정합니다.',
          cancel_button: '삭제',
          submit_button: '수정',
        },
        image_description: '팝업 이미지를 등록해 주세요.',
        popup_title: '팝업 타이틀',
        popup_title_placeholder: '팝업 타이틀을 입력해 주세요.',
        popup_title_description: '팝업 관리를 위한 타이틀로 외부에는 노출되지 않습니다.',
        exposure_duration: '노출 기간',
        exposure_duration_description: '비공개 등록을 원할 경우 현재의 날짜보다 이전의 날짜로 설정해 주세요.',
        popup_image: '팝업 이미지',
        close_icon_color: '닫기 아이콘 컬러',
        button_bg_color: '버튼 배경 컬러',
        button_text_color: '버튼 텍스트 컬러',
        link_url: 'URL 주소',
        link_url_placeholder: '팝업 이미지 클릭 시 이동할 URL을 입력해 주세요.',
        link_url_description: 'URL을 입력하지 않을 경우 클릭이 되지 않습니다.',
        exposure_location: '노출 화면',
        exposure_home: '홈 화면',
        exposure_product_detail: '상품 상세 화면',
        exposure_home_and_product_detail: '홈 + 상품 상세 화면',
        exposure_all: '전체 상품',
        exposure_mps: '마플샵제작배송 상품',
        exposure_tpl: '마플샵배송 상품',
        exposure_pbg: '크리에이터배송 상품',
        exposure_dtg: '디지털/전자책',
        exposure_custom: '직접 입력',
        preview_title: '미리보기',
        home_and_product_detail_description: '크리에이터샵의 홈과 모든 상품 상세 페이지에 팝업이 노출됩니다.',
        home_description: '크리에이터샵의 홈에 팝업이 노출됩니다.',
        product_input_placeholder: '팝업을 노출할 상품 URL을 입력해 주세요.',
        product_input_description: 'URL을 입력한 상품 상세 페이지에 팝업이 노출됩니다.',
        sort_success_title: '팝업 정렬 완료',
        sort_success_message: '팝업 정렬이 완료되었습니다.\n각 설정 화면에서 확인해 주세요.',
      },
      onBoarding: {
        title: '님, 환영합니다!',
        title_finish: '님, 축하합니다!',
        desc: '스튜디오 온보딩 완료 시 마플샵에서 사용할 수 있는 3,000포인트를 지급해 드려요.',
        desc_finish:
          '마플샵에서 사용할 수 있는 3,000포인트 지급이 완료되었어요!<br/>마플샵 데뷔를 축하합니다!',
        count_desc: '개 남음',
        complete: '완료',
        start: {
          cate_title: '마플샵 시작하기',
          shop_info_setting: {
            item_title: '샵 정보 설정하기',
            item_desc: '고객에게 보여질 샵의 이름, 소개, 도메인 등 기본 정보를 설정해 보세요.',
            item_full_desc:
              '고객에게 보여질 샵의 이름, 소개, 도메인 등 기본 정보를 설정해 보세요.<br/>정확한 정보는 신뢰를 주어 샵 방문자가 10% 이상 증가할 수 있습니다.',
            button_text: '설정하기',
          },
          shop_deco_setting: {
            item_title: '샵 꾸미기',
            item_desc: '나만의 샵을 꾸며 나만의 개성을 자유롭게 표현해 보세요.',
            item_full_desc:
              '나만의 샵을 꾸며 나만의 개성을 자유롭게 표현해 보세요.<br/>샵을 꾸미면 고객의 체류 시간이 평균 25% 증가할 수 있습니다.',
            button_text: '꾸미기',
          },
          creator_info_setting: {
            item_title: '크리에이터 정보 입력하기',
            item_desc: '크리에이터배송 상품 판매를 위한 필수 정보를 입력해 주세요.',
            item_full_desc:
              '크리에이터배송 상품 판매를 위한 필수 정보를 입력해 주세요.<br/>정보가 명확한 샵은 좋아요 수가 10% 증가할 수 있습니다.',
            button_text: '입력하기',
          },
          bank_info_setting: {
            item_title: '정산 정보 등록하기',
            item_desc: '정산을 받을 계좌 정보를 등록하세요.',
            item_full_desc:
              '정산을 받을 계좌 정보를 등록하세요.<br/>수익금을 안전하게 출금할 수 있어 운영의 안정성을 높일 수 있습니다.',
            button_text: '등록하기',
          },
          title: '스튜디오 시작하기',
          desc: '나만의 샵을 만들어 보세요!',
        },
        sales: {
          cate_title: '판매 시작하기',
          mps_product_sales: {
            item_title: '마플샵제작배송 상품 등록하기',
            item_desc: '디자인만 있다면 만들 수 있는 마플샵제작배송 상품을 등록해 보세요.',
            item_full_desc:
              '디자인만 있다면 만들 수 있는 마플샵제작배송 상품을 등록해 보세요.<br/>상품 제작부터 배송, CS, 재고 관리까지 모두 마플샵이 해드립니다.',
            button_text: '바로가기',
          },
          creator_product_sales: {
            item_title: '크리에이터배송 상품 등록하기',
            item_desc: '이미 내가 만들었거나 재고를 가지고 있는 상품을 판매해 보세요.',
            item_full_desc:
              '내가 직접 만들었거나 재고를 가지고 있는 상품을 판매해 보세요.<br/>나만의 독창적인 상품을 등록해 팬들과 소통하며 수익을 창출하세요.',
            button_text: '바로가기',
          },
          digital_product_sales: {
            item_title: '디지털/전자책 등록하기',
            item_desc: '배경화면, 굿노트, 전차잭 등 디지털 형태의 상품을 판매해 보세요.',
            item_full_desc:
              '배경화면, 굿노트, 전차잭 등 디지털 형태의 상품을 판매해 보세요.<br/>디지털 형태로 수익을 창출해 보세요.',
            button_text: '바로가기',
          },
        },
        debut: {
          cate_title: '마플샵 데뷔하기',
          sns_setting: {
            item_title: '대표 SNS 설정하기',
            item_desc: '팬들에게 쉽고 빠르게 소통할 수 있는 나의 SNS를 알려주세요.',
            item_full_desc:
              '팬들에게 쉽고 빠르게 소통할 수 있는 나의 SNS를 알려주세요.<br/>SNS를 통해 팬층을 더 쉽게 확보할 수 있으며, 트래픽 유입을 증대시킵니다.',
            button_text: '바로가기',
          },
          chat_cheer: {
            item_title: '팬레터로 소통하기',
            item_desc: '팬레터 게시판을 통해 팬들과 따뜻한 소통을 나누세요.',
            item_full_desc:
              '팬레터 게시판을 통해 팬들과 따뜻한 소통을 나누세요.<br/>팬들과의 소통이 강화되어 브랜드 충성도를 높일 수 있습니다.',
            button_text: '바로가기',
          },
          creator_guide: {
            item_title: '크리에이터 가이드 확인하기',
            item_desc: '성공적인 샵 운영을 위한 필수 가이드를 확인하세요.',
            item_full_desc:
              '성공적인 샵 운영을 위한 필수 가이드를 확인하세요.<br/>성공적인 운영 방법을 습득하여 더 나은 수익 모델을 구축할 수 있습니다.',
            button_text: '바로가기',
          },
        },
        quick: {
          menu_title: '상품 판매하기',
          menu_mps_product: '마플샵제작배송 상품 만들기',
          menu_creator_product: '크리에이터배송 상품 등록하기',
          menu_digital_product: '디지털/전자책 등록하기',
          online_popup_link: '온라인 <br />팝업스토어',
          offline_popup_link: '오프라인 <br />팝업스토어',
          youtube_link: '유튜브 쇼핑 연동',
          youtube_link_desc: '유튜브 채널에서 마플샵 상품을<br />판매해 보세요!',
          commerce_creator_title: '커머스 크리에이터 2기 모집',
          commerce_creator_desc: '내 채널과 딱 맞는 <br/>브랜드를 매칭해드립니다.',
          purchase_analyze_title: '신규기능, 상품별 누적판매량',
          purchase_analyze_desc: '각 상품이 얼마나 잘 팔렸을까요?<br/>판매 전략에 참고해 보세요.',
          sales_trend_title: '신규 기능, 기간별 판매추이',
          sales_trend_desc: '내 샵의 매출은 성장세인가요?<br />특정 기간의 판매 성과를 살펴보세요.',
          creator_design_title: '크리에이터 디자인 오픈',
          creator_design_desc: '직접 만든 나만의 디자인을 등록하고 <br/>판매 수익을 만들어보세요!',
          goods_partner_title: '굿즈 파트너스 신청하기',
          goods_partner_desc: '버튜버라면 신청하세요!<br/>굿즈제작 A-Z 책임집니다',
          category_renewal_title: '상품 카테고리 변경 안내',
          category_renewal_desc: '모든 상품이 새로운 상품 카테고리 체계에 맞춰 변경됩니다(2025.07.28 예정)',
        },
        continue: '온보딩 이어서 하기',
        completed: {
          title: '마플샵 온보딩 완료!',
          desc: '이제 나만의 샵을 시작하세요.',
        },
        caution: '포인트 지급은 최대 1분이 소요될 수 있습니다.',
      },
      question_list: {
        tab: {
          all: '전체',
          product: '상품 문의',
          membership: '멤버십 문의',
          support: '후원 문의',
          commission: '커미션 문의',
        },
        filter: {
          create_at: '등록일자',
          search_key: '검색조건',
          status: '진행상태',
          reset: '초기화',
          search: '검색',
        },
        table: {
          status: '진행상태',
          create_at: '등록일시',
          user_name: '이름',
          nickname: '닉네임',
          title: '제목',
          product_name: '상품명',
          order_id: '주문번호',
          product_id: '상품번호',
          phone_number: '전화번호',
          email: '이메일',
          plan_name: '플랜명',
          product_or_plan_name: '상품명/플랜명',
        },
        status: {
          question: '문의 접수',
          answer: '답변 완료',
          add_question: '추가 문의 접수',
          add_answer: '추가 답변 완료',
        },
      },
      adjustment: {
        marppleshop_product: '마플샵제작배송 상품',
        creator_product: '크리에이터배송 상품',
        tpl_product: '마플샵배송 상품',
        digital_product: '디지털/전자책',
        amount: '{{product}} 정산 금액',
      },
      product_guide: {
        title: '마플샵제작배송 상품과 크리에이터배송 상품이란?',
        about_pod: '마플샵제작배송 상품이란?',
        pod_guide_001: '상품을 직접 만들지 않아도 내가 디자인한 굿즈를 판매할 수 있습니다.',
        pod_guide_002: '상품 제작, 배송, CS, 재고 관리까지 모-두 다 마플샵이 해드리는 상품을 의미합니다.',
        about_pb: '크리에이터배송 상품이란?',
        pb_guide_001: '내가 직접 만들고 배송하는 상품을 복잡한 승인 절차 없이 3분이면 등록할 수 있습니다.',
        pb_guide_002: '나만의 샵 혹은 링크를 통해 바로 판매 시작이 가능한 상품을 의미합니다.',
      },
      inspect_stores_products: {
        header: {
          title: '상품 검수',
          description: '신규로 등록된 크리에이터배송 상품을 검수 하는 페이지입니다.',
          list_title: '검수 관리',
          list_description: '크리에이터 전체 상품들의 검수 상태를 확인하고 관리할 수 있는 페이지 입니다.',
        },
        filter: {
          create_at: '등록일자',
          search_key: '검색조건',
          status: '진행상태',
          reset: '초기화',
          search: '검색',
        },
        table: {
          product_name: '상품명',
          creator_name: '크리에이터명',
          store_name: '샵 이름',
          product_id: '상품등록번호',
          product_type: '상품타입',
          category: '대분류/중분류',
          delivery_type: '배송형태',
          delivery_way: '배송방법',
          product_price: '판매가',
          delivery_price: '배송비 \n (기본/도서산간)',
          kc_certificate: 'KC인증서 및 기타인증',
        },
        status: {
          approved: '검수완료',
          rejected: '판매보류',
          not_started: '검수미완료',
        },
      },
      integrated_order_search: {
        description: '한 곳에서 모든 주문을 검색해보세요.',
      },
    },
    file: {
      volume_error_title: '업로드 용량 초과',
      volume_error_message:
        '업로드 가능한 용량을 초과하였습니다.<br/>{{volume}} 이하의 파일로 업로드해 주세요.',
      volume_under_error_title: '업로드 용량 초과',
      volume_under_error_message:
        '업로드 가능한 용량을 충족하지 못했습니다.<br/>{{volume}} 이상의 파일로 업로드해 주세요.',
      extension_error_title: '파일 첨부 불가능',
      extension_error_message: '선택한 파일은 첨부가 불가능한 파일입니다.\n확장자를 다시 확인해 주세요.',
      extension_forbidden_title: '',
      extension_forbidden_message: '',
      mime_type_not_allowed_title: '',
      mime_type_not_allowed_message: '',
      filename_invalid_title: '',
      filename_invalid_message: '',
      custom_validation_failed_message: '파일 검증에 실패했습니다.',
      image_size_error_title: '이미지 사이즈 확인',
      image_size_error_message: '올바르지 않은 이미지 사이즈입니다.<br/>{{size}} 사이즈로 업로드해 주세요.',
      image_size_over_error_message:
        '올바르지 않은 이미지 사이즈입니다.<br/>{{size}} 이하로 업로드해 주세요.',
      image_aspect_ratio_error_title: '이미지 비율 확인',
      image_aspect_ratio_error_message:
        '올바르지 않은 이미지 비율입니다.<br/>{{aspect_ratio}} 비율로 업로드해 주세요.',
    },
    admin: {
      menu: {
        menu_01: '메인 배너 관리',
      },
      cast_on_air: {
        coa_01: 'Cast On-Air 관리',
        coa_02: '마플샵 홈 화면에 노출할 동영상 콘텐츠를 만들고 관리해 보세요.',
        coa_03: '전체 콘텐츠 관리',
        coa_04: '바로가기 URL',
        coa_05: 'Cast On-Air 콘텐츠 만들기',
        coa_06: 'Cast On-Air 콘텐츠 관리',
        coa_07: '콘텐츠 제목',
        coa_08: '콘텐츠 설명',
        coa_09: 'iframe',
        coa_10: '상품 추가',
        coa_11: '상품의 URL을 입력해 주세요.',
        coa_12: 'Youtube, SOOP, 치지직 등의 동영상을 노출할 수 있습니다.',
        coa_13: 'iframe URL 주소를 입력해 주세요.',
        coa_14: '바로가기 버튼의 URL을 입력해 주세요.',
        coa_15: '배너 공개 개수 초과',
      },
      banner: {
        banner_01: '배너 이미지를 등록해 주세요.',
        banner_02: '권장 사이즈 : 896px X 1120px 이상 / 3MB 이하',
        banner_03: 'PC 배너 설정',
        banner_04: '권장 사이즈 : 750px X 562px 이상 / 1MB 이하',
        banner_05: '모바일 배너 설정',
        banner_06: '공통 설정',
        banner_07: '모바일 배너 이미지',
        banner_08: 'PC 배너 이미지',
        banner_09: '배너 카테고리',
        banner_10: '영문 배너 카테고리를 입력해 주세요.',
        banner_11: '배너에 삽입될 버튼 내용을 입력해 주세요.',
        banner_12: '버튼 내용',
      },
      site_manage: {
        integrating_external_services: {
          title1: '외부 서비스 연동',
          txt1: '외부 서비스와의 연동을 관리하는 페이지 입니다.',
          sub_title1: '구글 애널리틱스 설정',
          head1: '구글 애널리틱스 측정 ID',
          txt2: '구글 애널리틱스를 설정하면 마플샵 플러스의 방문자 유입과 이탈 등의 데이터를 실시간으로 확인하고 분석할 수 있습니다.',
          txt3: '크리에이터 가이드',
          txt3_2: '에 따라 구글 애널리틱스를 설정해 보세요!',
          txt4: "G-000000000'와 같은 형식의 측정 ID를 입력해 주세요.",
          btn1: '저장하기',
          save_txt1: '저장 완료!',
          save_txt2: '측정 ID를 저장했어요.\n이제 구글 애널리틱스에서 데이터를 확인해 보세요!',
          save_fail_txt1: '저장 실패',
          save_fail_txt2: '고객센터로 문의해 주세요.',
          btn2: '변경하기',
          btn3: '연동 해제',
          update_txt1: '변경 완료!',
          update_txt2: '측정 ID를 변경했어요.\n이제 구글 애널리틱스에서 데이터를 확인해 보세요!',
          cancel_txt1: '연동 해제 완료!',
          cancel_txt2: '구글 애널리틱스 연동을 해제했어요.',
          cancel_fail_txt1: '연동 해제 실패',
          cancel_fail_txt2: '고객센터로 문의해 주세요.',
        },
      },
    },
    cheerup: {
      txt1: '크리에이터를 위한 응원의 한 마디를 남겨주세요!',
      txt2: '웹 페이지 링크, 유튜브 등을 텍스트 형태의 바로가기로 삽입할 수 있습니다.',
      txt3: '최대 6장까지 첨부 가능합니다.',
      btn_txt1: '팬레터',
      title1: '팬레터',
      sub_title1: '크리에이터를 응원하는 한 마디',
      btn_txt2: '수정하기',
      profile_txt1: '수정',
      profile_txt2: '10MB 이내의 이미지 파일을 업로드 해주세요.<br />(이미지 형식 : JPG, JPEG, PNG)',
      profile_txt3: '크리에이터를 소개할 수 있는 문구를 작성해 주세요.',
      empty_title: '응원의 메시지를 남겨주세요!',
      empty_body: '크리에이터에게 응원의 한 마디를 남겨주세요!<br />따뜻한 응원의 메시지는 큰 힘이 됩니다!',
      my_page_empty_body: '좋아하는 크리에이터 샵을 방문하고<br/>크리에이터를 응원하는 글을 작성해 보세요.',
      my_page_empty_title: '작성한 팬레터가 없어요.',
      my_page_empty_button: '크리에이터 찾아보기',
    },
    article: {
      sns_txt1: 'SNS',
      remove: '팬레터 삭제하기',
      remove_desc: '팬레터를 삭제하시겠어요?',
      remove_ok: '삭제하기',
      remove_cancel: '취소',
    },
    toast: {
      close: '닫기',
      goto_cart: '장바구니 보기',
      goto_product: '보러가기',
    },
    creator_shop: {
      sub_title1: '당신의 취향을 저격할',
      sub_title2: '크리에이터를 응원하는 한 마디',
      sub_title3: '팬들의 이야기가 궁금할 때',
    },
    settings: {
      style_editor: {
        file_txt1: '가로 최대 320px 세로 20px ~ 80px | PNG 가능 | 최대 1MB',
        file_txt2: '2560px X 300px | JPG, JPEG, PNG 가능 | 최대 3MB',
        file_txt3: '3:2 비율 | 가로 750px 이상 | JPG, JPEG, PNG 가능 | 최대 1MB',
        file_txt4: '1:1 정방형 | 400px 이상 | JPG, JPEG, PNG 가능 | 최대 1MB',
        banner_help_txt1:
          '배너 이미지는 중앙 기준 1440px을 벗어날 경우 일부 디바이스에서 잘려보일 수 있습니다.',
      },
      product_editor: {
        sample_order: '샘플 주문하기',
      },
    },
    gnb: {
      creator_ranking: '크리에이터 랭킹',
      creator_ranking_weekly: '주간 인기 크리에이터',
      creator_ranking_monthly: '월간 인기 크리에이터',
      plus: '마플샵 플러스',
      plus_all: '마플샵 플러스 전체보기',
      creator_view: '크리에이터 뷰',
      creator_all: '크리에이터 전체',
      creator_new: '마플샵에 찾아온 뉴 페이스',
      monthly_top_one: '{{month}}월의 마플샵 크리에이터 TOP 1',
      more: '더보기',
      menu: {
        home: '홈',
        creator: '크리에이터',
        popup: '팝업',
        shopping: '쇼핑',
        mypage: '마이페이지',
        real_ranking: '실시간/랭킹',
        real_ranking_bottom: '실시간/랭킹',
        recommend: '추천',
        explore: '탐색',
        goods: '굿즈',
        handmade: '핸드메이드',
        brand_deal: '브랜드딜',
        ebook: '전자책',
      },
    },
    creator_filter: {
      all: '전체',
    },
    price: {
      price_all: '총 상품 금액',
    },
    customer_order: {
      inquire: '문의하기',
    },
    error: {
      404: {
        title: '원하시는 페이지를 찾을 수 없습니다.',
        description:
          '찾으려는 페이지의 주소가 잘못 입력되었거나,<br/>주소의 변경 혹은 삭제로 인해 접속할 수 없습니다.<br/>입력하신 페이지의 주소가 정확한지 다시 확인해 주세요.',
      },
      500: {
        title: '잠시 후 다시 확인해 주세요!',
        description:
          '서비스 이용에 불편을 드려 죄송합니다.<br/>일시적으로 서버에서 문제가 발생하였습니다.<br/>잠시 후 다시 시도해 주시기 바랍니다.',
      },
      suspend_store: {
        title: '현재 운영되지 않는 샵입니다.',
        description: '마플샵 홈에서 새로운 크리에이터를 발견해보세요.',
      },
    },
    adult: {
      need_verify: '성인 인증 안내',
      go_verify: '인증하기',
      go_main: '메인으로 가기',
      verify_cancel: '인증 취소',
      verify_cancel_description: '인증이 취소되었습니다.<br/>인증을 다시 시도해 주세요.',
    },
    creator_studio: {
      confirm_title1: '정말로 해제하시겠어요?',
      confirm_body_txt1: '유튜브와 마플샵 연결을 해제하지 않고,<br />노출된 상품을 숨길 수 있어요!',
      confirm_btn_ok: '해제하기',
      confirm_btn_cancel: '돌아가기',
      store_delivery_company_title: '배송 정책',
      store_delivery_company_desc:
        '상품별로 배송비, 출고지 등이 다를 경우 배송 정책을 다르게 설정할 수 있습니다.',
      external_services: {
        tab1: '구글 애널리틱스 설정',
        tab2: 'API Key 발급',
      },
      terms: {
        welcome: '마플샵 스튜디오에 오신 걸 환영합니다!',
        guide: '샵을 꾸미고 상품을 만들어보세요.<br/>판매 승인 심사는 평일 영업일 기준 2~5일 소요됩니다.',
        start_service: '동의하고 스튜디오 시작하기',
        all_check: '전체 동의',
        service_check: '마플샵 스튜디오 이용약관 동의',
        privacy_check: '개인정보처리방침 동의',
        age_check: '만 14세 이상입니다.',
        not_yet: '진행 불가',
        not_yet_message:
          '크리에이터 스튜디오 이용약관 및 개인정보처리방침 및<br/>만 14세 이상에 모두 동의해 주세요.',
      },
      printable_product_alert:
        '제작 시안이 생성되어 수정이 어렵습니다.<br>디자인 변경은 상품 복제를 이용해 주세요.',
    },
    product_detail: {
      ebook_illustrator: '그림',
      ebook_translator: '번역',
      ebook_publisher: '출판사',
      ebook_publication_date: '출간일',
      재고부족: '재고 부족',
      quantity_exceeded: '구매 가능한 수량을 초과했습니다.',
      remaining_stock_quantity:
        '현재 선택하신 옵션의 <span style="font-weight: 700; color: #1C75FF;">남은 재고는 {{remaining_stock_quantity}}개</span>입니다.<br/>옵션을 확인해 주세요.',
      option_not_selected: '상품 옵션 미선택',
      option_not_selected_desc: '옵션을 선택하지 않았습니다.<br />상품의 옵션을 선택해 주세요.',
      out_of_stock: {
        title1: '상품 재고 안내',
        title2: '상품 재입고 예정',
        title3: '상품 등록 안내',
        description1: '본 상품은 일시 품절 상태입니다.<br />재고가 준비된 후 노출 및 판매가 시작됩니다.',
        description2: '아래의 옵션은 일시 품절로<br />재고가 준비된 후 판매가 시작됩니다.',
        description3:
          '본 상품의 {{ len }}개의 옵션은 바로 판매 가능하며<br />아래의 옵션은 재고가 준비된 후 판매가 시작됩니다.',
        submit: {
          ok: '상품 등록하기',
          cancel: '옵션 재선택',
        },
      },
      required_bank: {
        title: '계좌 등록 안내',
        description:
          '상품을 만들기 전, 정산 정보 등록이 필요합니다.<br /> 상품이 판매되면 등록해 주신 계좌로<br />수익을 정산해 드려요.',
        ok: '계좌 등록하기',
        cancel: '다음에 하기',
      },
      duplicated_option: '중복 선택 옵션',
      duplicated_option_desc: '이미 선택되어 있는 옵션입니다.<br />선택한 옵션 수량을 조절해 보세요.',
      no_select_option: '상품 옵션 미선택',
      no_select_option_desc: '옵션이 선택된 상품이 없습니다.<br />상품의 옵션을 선택해 주세요!',
      over_quantity: '구매 가능 수량 초과',
      over_quantity_desc:
        '구매 가능한 수량을 모두 선택하였습니다.<br />추가를 원한다면 선택된 상품을 삭제한 후<br />다시 선택해 주세요.',
      duplicated_option_desc2: '이미 선택되어 있는 옵션입니다.<br />선택한 옵션을 확인해 주세요.',
      select_phonecase: '기종을 선택해 주세요.',
    },
    funding: {
      modal: {
        title: '참여한 팬',
        tabs: {
          ranking: '랭킹순',
          created_at: '최신순',
        },
        item: {
          label: '{{nickname}}님이 펀딩했어요.',
        },
      },
      section: {
        ranking_title: '참여한 팬 랭킹',
      },
      cta: {
        support: '펀딩 참여하기',
        sold_out: '펀딩이 종료되었어요!',
      },
      card: {
        coming_soon: '{{date}} 출시 예정',
        status: {
          success: '프로젝트 성공',
          failed: '프로젝트 종료',
          ing_day: '종료까지 {{day}}일',
          ing_hour: '종료까지 {{hours}}시간',
          ing_minute: '종료까지 {{minutes}}분',
          ing_second: '종료까지 {{seconds}}초',
        },
        share: '소문내기',
        toast: {
          success: '주소가 복사되었습니다.',
        },
      },
      form: {
        percentage: {
          label: '달성률',
          status: {
            ing: '목표까지 단 {{goal}}원',
            breakthrough: '{{goal}}원 돌파',
            success: '프로젝트 성공',
          },
        },
        supporters: {
          label: '참여자 수',
          count: '<strong class="{{font}}">{{count}}</strong><i>명</i>',
        },
        end: {
          label: '종료까지',
          remain_day: '<strong class="{{font}}">{{remain}}</strong><i>일 남음</i>',
          remain_time: '<strong class="{{font}}">{{remain}}</strong><i>남음</i>',
        },
      },
      guide: {
        goal: '목표 금액',
        participation: '참여 기간',
      },
      creator: {
        menu: {
          name: '펀딩',
        },
        list: {
          title: '총 {{count}}개의 펀딩',
        },
      },
    },
    question: {
      commission: {
        title: '커미션 신청 정보',
        name: '커미션 이름',
        number: '신청 번호',
        check: '신청서 확인',
        button: '커미션 상세 보기',
        button_studio: '커미션 신청서 보기',
      },
      문의하기: '문의하기',
      nickname: '닉네임',
      kind: '유형',
      qna: '상품 문의하기',
      qna_membership: '멤버십 문의하기',
      qna_support: '후원 문의하기',
      qna_commission: '커미션 문의하기',
      plan_name: '플랜명',
      add_answer: '문의 내용을 확인한 후, 고객이 이해하기 쉽게 답변해 주세요.',
      ' 문의와 관련된 파일을 첨부해 주세요.': '문의와 관련된 파일을 첨부해 주세요.',
      '개인정보수집 ・ 이용 동의': '개인 정보 수집 및 이용 동의',
      '사용자 정보': '사용자 정보',
      '필수 입력사항': '필수 입력사항',
      이름: '이름',
      '이름을 입력해 주세요.': '이름을 입력해 주세요.',
      error: '에러',
      연락처: '연락처',
      '없이 연락처를 입력해 주세요.': '- 없이 01000000000',
      이메일: '이메일',
      '문의 내용': '문의 내용',
      '문의 내용을 자세하게 작성해 주세요.':
        '문의 내용을 자세하게 작성해 주세요. \n동일 내용 반복 문의, 욕설, 폭언 등은 지양해 주세요.',
      '문의 내용을 입력해 주세요.': '문의 내용을 입력해주세요.',
      '문의 내용은 최대 2000bytes까지 입력 가능합니다.<br>(한글 1000자, 영문 2000자)':
        '문의 내용은 최대 2000bytes까지 입력 가능합니다.<br>(한글 1000자, 영문 2000자)',
      '파일 첨부': '파일 첨부',
      'jpg, png, zip, pdf 확장자만 첨부 가능하며, 10MB까지 가능합니다.<br />(여러 사진을 첨부해야 한다면 zip 파일로 첨부해 주세요.)':
        'jpg, png, zip, pdf 확장자만 첨부 가능하며, 10MB까지 가능합니다.<br />(여러 사진을 첨부해야 한다면 zip 파일로 첨부해 주세요.)',
      보기: '보기',
      취소: '취소',
      '문의 접수': '문의 접수',
      '답변 받으실 이메일 주소를 입력해 주세요.': '답변 받으실 이메일 주소를 입력해 주세요.',
      제목: '제목',
      '제목을 입력해 주세요.': '제목을 입력해 주세요.',
      file_modal_title: '파일 첨부 불가능',
      file_modal_content: '선택한 파일은 첨부가 불가능한 파일입니다.\n확장자를 다시 확인해 주세요.',
      file_modal_content_desc: '(첨부 가능 파일 : jpg, png, zip, pdf)',
      '문의 정보': '문의 정보',
      upload: '업로드',
      submit: '문의 접수하기',
      '필수 입력 사항입니다.': '필수 입력 사항입니다.',
      '정확한 연락처를 입력해주세요.': '정확한 연락처를 입력해주세요.',
      '정확한 이메일을 입력해 주세요.': '정확한 이메일을 입력해 주세요.',
      '100자 이하로 입력해주세요.': '100자 이하로 입력해주세요.',
      '250자 이하로 입력해주세요.': '250자 이하로 입력해주세요.',
      '300자 이하로 입력해주세요.': '300자 이하로 입력해주세요.',
      '2000bytes 이하로 입력해주세요.': '2000bytes 이하로 입력해주세요.',
      '특수문자를 제외하고 입력해주세요.': '특수문자를 제외하고 입력해주세요.',
      '숫자만 입력해 주세요.': '숫자만 입력해 주세요.',
      '개인 정보 수집 및 이용 동의후 접수해주세요.': '개인 정보 수집 및 이용 동의후 접수해주세요.',
    },
    landing: {
      file: {
        helper_message: 'PDF, PPTX, JPG, PNG 등 20MB 이하의 파일을 업로드해 주세요.',
        not_available_file: '업로드가 불가한 파일입니다. 다시 시도해 주세요.',
        file_size_error: '업로드 가능 용량을 초과하였습니다.',
      },
      popup_store: {
        submit: '온라인 팝업스토어 신청하기',
        motion_description: '크리에이터 커머스 플랫폼, 마플샵과 함께하는',
        motion_title: '온라인에서 만드는 특별한 경험,<br />마플샵 팝업스토어',
        ad_title_1:
          '오프라인 팝업스토어 <br/>장소 대관, 상품 제작, 운영 인건비 ...<br/>비용이 부담스러우신가요?',
        mo_ad_title_1: '팝업스토어 비용이<br/>부담스러우신가요?',
        ad_description_1:
          '걱정하지 마세요! 마플샵 팝업스토어는 크리에이터 커머스 플랫폼,<br/>마플샵에 노출되는 온라인 팝업스토어로 별도의 대관비용이 발생하지 않습니다.<br/>또한, 상품 제작부터 온라인 판매, 배송까지 마플샵이 모두 도와드려요!',
        mo_ad_description_1:
          '마플샵 팝업스토어는 크리에이터 커머스 플랫폼,<br/>마플샵에 노출되는 온라인 팝업스토어로 별도의 대관<br/>비용이 발생하지 않습니다. 또한, 상품 제작부터 온라<br/>인 판매, 배송까지 마플샵이 모두 도와드려요!',
        ad_title_2:
          '신규 제품 출시, 컴백, 이벤트 등 <br/>팬들이 깜짝 놀랄만 한<br/>이벤트를 생각하고 계신가요?',
        mo_ad_title_2: '팬들이 깜짝 놀랄만 한<br/>이벤트를 구상중이신가요?',
        ad_description_2:
          '이미 많은 기업 브랜드, 크리에이터들이 팬들에게<br/>특별한 상품과 콘텐츠를 선보이고 싶을때<br/>마플샵 팝업스토어를 활용하고 있어요!',
        mo_ad_description_2:
          '이미 많은 기업 브랜드, 크리에이터들이 팬들에게<br/> 특별한 상품과 콘텐츠를 선보이고 싶을때 <br/>마플샵 팝업스토어를 활용하고 있어요!',
        ad_title_3: '오프라인 팝업스토어<br/>재고가 남을까봐 <br/>걱정이신가요?',
        mo_ad_title_3: '재고가 남을까봐<br/>걱정이신가요?',
        ad_description_3:
          '걱정하지 마세요! <br/>마플샵 팝업스토어는 POD기반의 상품 제작으로 <br/>재고없이 단 1개의 팝업스토어 상품도 판매할 수 있어요!',
        mo_ad_description_3:
          '걱정하지 마세요! 마플샵 팝업스토어는 POD기반의 <br/>상품 제작으로 재고없이 단 1개의 팝업스토어 <br/>상품도 판매할 수 있어요!',
        ad_title_4: '오프라인 팝업스토어<br/>종료 후, 남은 재고 <br/>어떻게 하고 계세요?',
        mo_ad_title_4: '오프라인 팝업스토어<br/>이후, 남은 재고는?',
        ad_description_4:
          '혹시 팝업스토어 판매 재고 상품을 중고마켓이나 <br/>오픈마켓에서 판매하실 예정이신가요? <br/>미처 오프라인 팝업스토어에 방문하지 못했던 고객들에게 <br/>마플샵 팝업스토어로 특별한 경험을 선사하세요!',
        mo_ad_description_4:
          '혹시 팝업스토어 판매 재고 상품을 중고마켓이나 <br/>오픈마켓에서 판매하실 예정이신가요? 미처 오프라인 팝업스토어에 방문하지 못했던 고객들에게 마플샵 팝업스토어로 특별한 경험을 선사하세요!',
        statistics_title:
          '마플샵은 제작 노하우를 기반으로<br/>지속적으로 성장하고 있는 <br/>크리에이터 커머스 플랫폼입니다!',
        statistics_date: '2024년 1월 기준',
        statistics_creator_count: '마플샵 활동 크리에이터',
        statistics_member_count: '마플샵 회원수',
        statistics_product_category_count: '바로 제작가능한 상품 카테고리',
        statistics_marpple_product_count: '마플샵에서 제작한 상품',
        statistics_brand_count: '마플샵 플러스 기업 / 브랜드',
        statistics_popupstore_count: '마플샵에서 그동안 런칭한 팝업스토어',
        mo_statistics_title:
          '마플샵은 제작 노하우를<br/> 기반으로 지속적으로<br/> 성장하고 있는 크리에이터<br/> 커머스 플랫폼입니다!',
        mo_statistics_date: '2024년 1월 기준',
        mo_statistics_creator_count: '마플샵 활동 크리에이터',
        mo_statistics_member_count: '마플샵 회원수',
        mo_statistics_product_category_count: '제작가능 상품 카테고리',
        mo_statistics_marpple_product_count: '마플샵에서 제작한 상품',
        mo_statistics_brand_count: '플러스 기업 / 브랜드',
        mo_statistics_popupstore_count: '런칭한 팝업스토어',
        exhibition_title: '마플샵과 크리에이터가<br/>함께 만들어가는<br/>마플샵 팝업스토어',
        exhibition_description:
          '마플샵 팝업스토어는 마플샵과 크리에이터가 함께 상품을 만들고 판매할 수 있는 서비스로 상품 기획, 제작, 판매, 배송까지 모두 마플샵이 도와드립니다.',
        exhibition_plan: '팝업스토어 기획',
        exhibition_plan_description: '크리에이터와 함께 팝업스토어<br/>판매 상품과 콘텐츠를 기획합니다.',
        exhibition_produce: '기획 상품 제작',
        exhibition_produce_description:
          '한정판 상품, 특별 상품 등<br/>POD가 아닌, 기획 상품도 제작해 드려요!',
        exhibition_sale: '팝업스토어 판매',
        exhibition_sale_description: '제작된 상품을 마플샵<br/>팝업스토어를 통해 판매합니다.',
        exhibition_delivery: '배송 및 재고 관리',
        exhibition_delivery_description: '배송과 재고 관리 뿐만 아니라<br/>CS까지 마플샵이 모두 해드려요.',
        case_title:
          '이미 다수의 브랜드 / 크리에이터들이<br/>마플샵 팝업스토어를 통해<br/>성공적인 결과를 도출했어요!',
        case_transaction: '거래액',
        case_ordered: '주문량',
        case_duration: '판매기간',
        case_transaction_a: '24억 8천만 원',
        case_ordered_a: '약 77,000개',
        case_duration_a: '18일',
        case_transaction_b: '14억 9천만 원',
        case_ordered_b: '약 89,000개',
        case_duration_b: '15일',
        case_transaction_c: '약 10억',
        case_ordered_c: '약 56,000개',
        case_duration_c: '15일',
        case_transaction_d: '약 16.5억',
        case_ordered_d: '약 54,000개',
        case_duration_d: '15일',
        case_transaction_e: '약 9.2억',
        case_ordered_e: '약 51,000개',
        case_duration_e: '11일',
        portfolio_title: '마플샵 X 크리에이터<br/> 팝업스토어 상품 포트폴리오',
        portfolio_description:
          '마플샵이 제공하는 디자인 상품 외에도 특별하게 기획하고 싶은 <br/>팝업스토어 상품이 있다면, 마플샵이 기획부터 제작까지 모두 도와드려요!',
        mo_portfolio_description:
          '마플샵이 제공하는 디자인 상품 외에도 특별하게 기획하고<br/> 싶은 팝업스토어 상품이 있다면, 마플샵이 기획부터 제작까<br/>지 모두 도와드려요!',
        popup_store_title: '마플샵과 함께한<br/>다채로운 팝업스토어',
        popup_store_button: '마플샵 팝업스토어 더보기',
        bottom_title: '꿈의 온라인 팝업스토어,<br/>마플샵과 함께 만들어 보세요!',
        mo_bottom_title: '온라인 팝업스토어,<br/>마플샵과 함께 <br/>만들어 보세요!',
        bottom_button: '온라인 팝업스토어 신청하기',
        submit_form_title: '마플샵 온라인 팝업스토어 신청하기',
        submit_form_description: '특별한 온라인 팝업스토어를 런칭해 볼까요?',
        submit_form_creator: '크리에이터 / 브랜드 명을 입력해 주세요 (필수)',
        submit_form_is_creator: '이미 마플샵 크리에이터이신가요?',
        submit_form_is_creator_yes: '네',
        submit_form_is_creator_no: '아니오',
        submit_form_domain: '도메인',
        submit_form_company: '회사 명을 입력해 주세요 (선택)',
        submit_form_manager: '담당자 성함 (필수)',
        submit_form_manager_email: '담당자 이메일 주소 (필수)',
        submit_form_manager_phone: '담당자 연락처 (숫자만 입력) (필수)',
        submit_form_sns:
          'Youtube, Instagram, X(구 Twitter) 등 운영하고 계신 SNS 채널 주소를 입력해 주세요 (선택)',
        submit_form_file: '크리에이터 / 브랜드 소개서가 있다면 첨부해 주세요 (선택)',
        submit_form_other: '마플샵 팝업스토어에서 판매하고 싶은 상품이나, 제안 내용을 기재해 주세요 (선택)',
        submit_form_guide: '담당 파트너가 확인 후, 영업일 기준 약 5일 이내로 회신드립니다.',
        submit_form_agree: '개인정보 제공동의',
        submit_form_agree_content:
          '<strong>개인정보 수집/이용 목적 :</strong> 마플샵 팝업스토어 서비스 신청을 위해 본인 확인<br/>수집하는 개인정보의 항목 : 회사명, 성명, 이메일, 연락처<br/>개인정보의 보유 및 이용 기간 : 이용 목적 종료 시점까지',
        submit_form_button: '온라인 팝업스토어 신청서 제출하기',
        submit_form_creator_error: '존재하지 않는 도메인입니다. 확인 후 다시 입력해 주세요.',
        submit_form_email_error: '올바른 형식의 이메일 주소를 입력해 주세요.',
        submit_form_phone_error: '올바른 형식의 연락처를 입력해 주세요.',
        mo_submit_form_creator: '크리에이터 / 브랜드 명 (필수)',
        mo_submit_form_is_creator: '마플샵 크리에이터이신가요?',
        mo_submit_form_domain: '도메인',
        mo_submit_form_company: '회사명 (선택)',
        mo_submit_form_manager: '담당자 성함 (필수)',
        mo_submit_form_manager_email: '담당자 이메일 주소 (필수)',
        mo_submit_form_manager_phone: '담당자 연락처 (숫자만 입력) (필수)',
        mo_submit_form_sns: '운영하고 계신 SNS 채널 주소 (선택)',
        mo_submit_form_file: '크리에이터 / 브랜드 소개서 (선택)',
        mo_submit_form_other:
          '마플샵 팝업스토어에서 판매하고 싶은 상품이나, 제안 내용을 기재해 주세요 (선택)',
        mo_submit_form_button: '신청서 제출하기',
        submit_success_modal_title: '신청서 제출 완료',
        submit_fail_modal_title: '제출 실패',
        submit_success_modal:
          '온라인 팝업스토어 신청서가<br/>정상적으로 제출되었습니다.<br/>빠르게 검토하여 연락드리겠습니다.',
        submit_fail_modal:
          '시스템 오류로 인해<br>신청이 제출되지 않았습니다.<br>partner@marppleshop.com으로 문의해 주세요.',
      },
      plus: {
        submit: '마플샵 플러스 신청하기',
        motion_title: 'IP 커머스를 시작하는<br/>가장 빠르고 쉬운 방법,<br/>마플샵 플러스',
        motion_description:
          'IP 커머스 플랫폼 구축부터 상품 제작, 주문, 배송, CS까지<br/>기업의 이커머스에 필요한 모든 인프라를 제공하는 원스톱 솔루션',
        mo_motion_description: '기업의 이커머스에 필요한<br/>모든 인프라를 제공하는 원스톱 솔루션',
        statistics_title: 'IP 시장은 콘텐츠에서<br/>비즈니스로 변화하고 있습니다',
        mo_statistics_title: 'IP 시장은<br/> 콘텐츠에서 비즈니스로<br/>변화하고 있습니다',
        statistics_description:
          '콘텐츠 IP (Intellectual Property : 지식 재산권)는<br/>다양한 채널에 걸쳐 소비되고 화제성과 트렌드가 만들어지고 있습니다',
        statistics_chart_title: 'IP 커머스는 매년 30%<br/>성장하고 있습니다',
        mo_statistics_chart_title: 'IP 커머스는 <br/>매년 30% 성장하고 있습니다',
        statistics_chart_description:
          "IP 커머스를 포괄하는 '캐릭터 라이선스 부문'의 <br/>글로벌 시장 규모 3300억 달러(443조 원)로 성장",
        statistics_chart_source: '한국콘텐츠진흥원 (2022)',
        statistics_circle_title: '국내 팬덤 경제 규모는<br/>약 7조 9천억 원!',
        statistics_circle_description: '다수의 엔터테인먼트 기업들이<br/>잇달아 IP 커머스 사업에 진출',
        statistics_circle_source: '2022년 기준',
        case_title: '하지만, 갈수록 장벽이 높아지는 IP 커머스<br/>어떻게 대응하고 계신가요?',
        mo_case_title: '갈수록 장벽이 높아지는<br/>IP 커머스 어떻게<br/>대응하고 계신가요?',
        case_mcn_title: 'MCN 기업<br/>커머스 MD',
        case_mcn_description:
          '콘텐츠 소비 속도가 너무 빨라요!<br/>콘텐츠 생산과 소비 사이클에 맞춰서 상품을 <br/>빨리 제작해야 하는데 MOQ 부담, 재고 부담도 있고, 만들 수 있는 상품도 한정적이에요!',
        mo_case_mcn_description:
          '콘텐츠 소비 속도가 너무 빨라요!<br/>콘텐츠 생산과 소비 사이클에 맞춰서 상품을 빨리 제작<br/>해야 하는데 MOQ 부담, 재고 부담도 있고, 만들 수 있<br/>는 상품도 한정적이에요!',
        case_game_title: '게임사<br/>신규 사업개발 팀장',
        case_game_description:
          '자사 게임 캐릭터를 활용해 굿즈를 <br/>테스트베드로 만들어 봤는데, 절차가 너무 <br/>복잡하고 어려웠어요. MOQ도 상당했고요. <br/>공장에 제작을 의뢰하고 만들어 배송받기까지 <br/>이 모든 과정은 전쟁 그 자체였어요!',
        mo_case_game_description:
          '자사 게임 캐릭터를 활용해 굿즈를 <br/>테스트베드로 만들어 봤는데, 절차가 너무 복잡하고 어<br/>려웠어요. MOQ도 상당했고요. 공장에 제작을 의뢰하<br/>고 만들어 배송받기까지 이 모든 과정은 전쟁 그 자체였<br/>어요!',
        case_webtoon_title: '웹툰 서비스<br/>IP 비즈니스 팀장',
        case_webtoon_description:
          '인기 웹툰 티셔츠는 출시 즉시 매진될 정도로 팬들의 지속적인 요청이 있는데요, 하지만 200명이 넘는 작가들과 그에 따른 엄청난 양의 콘텐츠를 소재로 굿즈를 만들기는 쉬운 일이 아니에요.',
        mo_case_webtoon_description:
          '인기 웹툰 티셔츠는 출시 즉시 매진될 정도로 팬들의 지<br/>속적인 요청이 있는데요, 하지만 200명이 넘는 작가들<br/>과 그에 따른 엄청난 양의 콘텐츠를 소재로 굿즈를 만들<br/>기는 쉬운 일이 아니에요.',
        case_entertain_title: '엔터테인먼트<br/>대표',
        case_entertain_description:
          '소속 아티스트들의 굿즈 커머스 사이트를 <br/>만들어 볼 생각인데요, 도메인부터 디자인, 개발까지.. 하나부터 열 까지 플랫폼 구축을 위해 해야 할 일이 너무 많아서 시작할 엄두가 나지 않아요.',
        mo_case_entertain_description:
          '소속 아티스트들의 굿즈 커머스 사이트를 만들어 볼 생<br/>각인데요, 도메인부터 디자인, 개발까지.. 하나부터 열<br/>까지 플랫폼 구축을 위해 해야 할 일이 너무 많아서 시<br/>작할 엄두가 나지 않아요.',
        case_creator_title: '크리에이터 기업<br/>CS 담당',
        case_creator_description:
          '회사 소속 크리에이터에 따라 판매하는 상품이 다양한 만큼 고객님들의 니즈도 다양하고 요구사항이 복잡한데 각 해결과정까지 번거로우니, 대응하기 너무 어려워요.',
        mo_case_creator_description:
          '회사 소속 크리에이터에 따라 판매하는 상품이 다양한<br/> 만큼 고객님들의 니즈도 다양하고 요구사항이 복잡한<br/>데 각 해결과정까지 번거로우니, 대응하기 너무 어려워<br/>요.',
        commerce_title: 'IP 커머스, 더 이상<br/>걱정하지 마세요!',
        commerce_description:
          '마플샵 플러스를 통해 상품 개발부터 생산과 품질 관리, <br/>재고 및 물류 관리, 플랫폼 구축부터 운영까지 — <br/>브랜드 커머스에 필요한 많은 시간과 비용을 절약할 수 있습니다.',
        mo_commerce_description:
          '마플샵이 제공하는 디자인 상품 외에도 <br/>특별하게 기획하고 싶은 팝업스토어 상품이 있다면, <br/>마플샵이 기획부터 제작까지 모두 도와드려요!',
        commerce_product: '상품 개발',
        commerce_quality: '품질 관리',
        commerce_platform: '플랫폼 구축 및 운영',
        commerce_sale: '상품 판매',
        commerce_inventory: '재고 및 물류관리',
        commerce_delivery: '배송 및 운영, CS',
        exhibition_title: '마플샵 플러스와 함께라면,<br/>1200여 종류의 상품 제작을 손쉽게!',
        exhibition_description:
          '국내 최초로 온라인 IP 커머스 솔루션을 개발하고,<br/>상품 제작부터 주문, 배송, CS까지 — 원스톱 솔루션을 보유한<br/>마플샵 플러스와 함께 새로운 비즈니스를 시작해 보세요.',
        mo_exhibition_title: '마플샵 플러스와 함께라면,<br/>1200여 종류의<br/>상품 제작을 손쉽게!',
        mo_exhibition_description:
          '국내 최초로 온라인 IP 커머스 솔루션을 개발하고,<br/>상품 제작부터 주문, 배송, CS까지 —<br/>원스톱 솔루션을 보유한 마플샵 플러스와 함께<br/>새로운 비즈니스를 시작해 보세요.',
        ad_title_1: '놀라운 상품 퀄리티와<br/>드랍 쉬핑 서비스!',
        ad_description_1:
          '마플샵 플러스는 국내 최고의 수준 퀄리티의 상품 제작과<br/>Drop Shipping Service<span>*</span>를 통해 간편한 재고관리, <br/>배송까지 모두 약속드립니다.',
        ad_guide_1:
          'Drop Shipping Service는 판매자가 상품 재고를 전혀 관리하지 않고,<br/>업체를 통해 고객들에게 판매 및 배송하는 주문 처리 방법입니다.',
        ad_title_2: '기업 브랜드 커머스 <br/>플랫폼 구축도<br/>간편하게!',
        ad_description_2:
          '이커머스 플랫폼을 기업 맞춤형으로 <br/>커스텀이 가능하며, 개별 소속셀러 스토어를 <br/>한 번에 만들고 간편하게 관리할 수 있습니다.',
        ad_title_3: '직접 제작한 3P 상품<br/>이커머스 솔루션도<br/>가능해요!',
        ad_description_3:
          '직접 제작한 3P 상품도 손쉽게 상품을 등록하고<br/>판매 및 배송을 할 수 있는 프로세스를 제공합니다.',
        ad_title_4: '커머스 운영과<br/>CS까지 <br/>모두 제공해 드려요',
        ad_description_4:
          '마플샵 플러스는 복잡하고 어려웠던 온라인 커머스<br/>고객 상담 및 상품문의, 반품, 교환 안내 등<br/>모든 운영 프로세스를 제공합니다.',
        mo_ad_title_1: '놀라운 상품 퀄리티와<br/>드랍 쉬핑 서비스!',
        mo_ad_title_2: '기업 브랜드 커머스 <br/>플랫폼 구축도 간편하게!',
        mo_ad_title_3: '직접 제작한 3P상품<br/>이커머스 솔루션도 가능!',
        mo_ad_title_4: '커머스 운영과<br/>CS까지 모두 제공!',
        solution_title: '마플샵 플러스는<br/>기업 맞춤형 관리 솔루션도<br/>제공해 드려요',
        solution_description:
          '관리 페이지를 통해 간편하게 데이터 분석부터,<br/>관리자 권한설정, 정산, 상품 관리 등 <br/>커머스 운영에 필요한 모든 기능이 제공됩니다.',
        solution_report: '데이터 분석 및<br/>리포트',
        solution_store: '스토어 및<br/>상품 관리',
        solution_creator: '크리에이터<br/>관리',
        solution_ecommerce: '3P 이커머스<br/>관리',
        solution_site: '사이트 및 <br/>페이지 관리',
        solution_manage: '관리자 및 <br/>매니저 권한 관리',
        portfolio_title:
          '이미 다수의 기업 / 브랜드들이<br/>마플샵 플러스를 활용하여<br/>IP 비즈니스를 실현하고 있습니다',
        portfolio_description:
          '다수의 크리에이터를 보유한 MCN 기업부터, 다양한 IP를 보유한 <br/>콘텐츠 기업, 다양한 프로젝트를 전개하는 기업까지 —<br/>마플샵 플러스를 활용해 손쉽게 IP 비즈니스를 실현하고 있습니다.',
        mo_portfolio_title: '다수의 기업 / 브랜드들이<br/>마플샵 플러스로 IP<br/>비즈니스를 실현하고 있어요',
        mo_portfolio_description:
          '다수의 크리에이터를 보유한 MCN 기업부터, <br/>다양한 IP를 보유한 콘텐츠 기업, 다양한 프로젝트를 <br/>전개하는 기업까지 — 마플샵 플러스를 활용해 <br/>손쉽게 IP 비즈니스를 실현하고 있습니다.',
        portfolio_button: '마플샵 플러스 포트폴리오',
        bottom_title: '기업만의 IP 콘텐츠만 있다면,<br/>IP 비즈니스 시작해 보세요!',
        mo_bottom_title: '기업만의<br/> IP 콘텐츠만 있다면,<br/>IP 비즈니스 시작해 보세요!',
        plus_apply: '마플샵 플러스 신청하기',
        submit_form_title: '마플샵 플러스 신청하기',
        submit_form_description:
          '다양한 IP 콘텐츠를 보유하신 기업/브랜드 라면 마플샵 플러스를 신청해 보세요.',
        submit_form_company: '회사 명',
        submit_form_company_category: '기업 형태',
        submit_form_manager: '담당자 성함',
        submit_form_manager_email: '담당자 이메일 주소',
        submit_form_manager_phone: '담당자 연락처 (숫자만 입력)',
        submit_form_file: '회사소개서 (선택)',
        submit_form_other:
          '귀사가 보유하고 계신 IP 콘텐츠 소개와 마플샵 플러스와 함께하고 싶은 사업 제안 내용을 기재해 주세요. (선택)',
        submit_form_agree: '개인정보 제공동의',
        submit_form_agree_content:
          '<strong>개인정보 수집/이용 목적 :</strong> 마플샵 플러스 서비스 신청을 위해 본인 확인<br/>수집하는 개인정보의 항목 : 회사명, 성명, 이메일, 연락처<br/>개인정보의 보유 및 이용 기간 : 이용 목적 종료 시점까지',
        submit_form_marketing: '홍보 마케팅 활용 동의 (선택)',
        submit_form_marketing_content: '마플샵에 등록된 에셋은 홍보 마케팅 목적으로 활용될 수 있습니다.',
        submit_form_button: '마플샵 플러스 신청서 제출하기',
        submit_form_email_error: '올바른 형식의 이메일 주소를 입력해 주세요.',
        submit_form_phone_error: '올바른 형식의 연락처를 입력해 주세요.',
        submit_form_guide: '담당 파트너가 확인 후, 영업일 기준 약 5일 이내로 회신드립니다.',
        mo_submit_form_company: '회사 명',
        mo_submit_form_manager: '담당자 성함',
        mo_submit_form_manager_email: '담당자 이메일 주소',
        mo_submit_form_manager_phone: '담당자 연락처 (숫자만 입력)',
        mo_submit_form_file: '회사소개서 (선택)',
        mo_submit_form_other:
          '귀사가 보유하고 계신 IP 콘텐츠 소개와 마플샵 플러스와 함께하고 싶은 사업 제안 내용을 기재해 주세요. (선택)',
        mo_submit_form_button: '신청서 제출하기',
        submit_success_modal_title: '신청서 제출 완료',
        submit_fail_modal_title: '제출 실패',
        submit_success_modal:
          '마플샵 플러스 신청서가<br/>정상적으로 제출되었습니다.<br/>빠르게 검토하여 연락드리겠습니다.',
        submit_fail_modal:
          '시스템 오류로 인해<br>신청이 제출되지 않았습니다.<br>partner@marppleshop.com으로 문의해 주세요.',
        enterprise_category: '기업 형태',
        private_enterprise: '개인기업',
        corporate_enterprise: '법인기업',
        public_enterprise: '공기업',
        social_enterprise: '사회적기업',
        etc_enterprise: '기타',
      },
      handmade: {
        scale_title: '뜨거운 열정을 지닌 <br /> 핸드메이드 크리에이터, 당신도',
        mo_scale_title: '뜨거운 열정을 지닌 <br /> 핸드메이드 크리에이터 <br /> 당신도',
        scale_description: '이제는 마플샵에서',
        craft_title_1: 'HOME DECO AND LIVING <br /> HANDMADE CREATOR',
        craft_title_2: 'JEWELRY AND ACCESSORIES <br /> HANDMADE CREATOR',
        craft_title_3: 'EMBROIDERY AND KNITTING <br /> HANDMADE CREATOR',
        craft_description_1: '부드럽고 포근한 <br /> 열정을 지닌 당신도',
        craft_description_2: '열기 가득한 뜨거운 <br/> 열정을 지닌 당신도',
        craft_description_3: '한 땀 한 땀 끈기있는 <br /> 열정을 지닌 당신도',
        video_card_title_1: '마플샵에서 상상할 수 있는 모든 것을 <br /> 현실로 만들어 보세요',
        mo_video_card_title_1: '마플샵에서 <br /> 상상할 수 있는 모든 것을 <br /> 현실로 만들어 보세요',
        video_card_title_2: '크리에이터님의 소중한 취미가 작품이 되고 <br /> 세상에 빛을 발하게 되는 순간',
        mo_video_card_title_2:
          '크리에이터님의 <br /> 소중한 취미가 작품이 되고 <br /> 세상에 빛을 발하게 되는 순간',
        video_card_title_3: '당신의 꿈이 현실이 되는 그 순간, <br /> 마플샵이 늘 함께합니다',
        mo_video_card_title_3: '당신의 꿈이 <br /> 현실이 되는 그 순간, <br /> 마플샵이 늘 함께합니다',
        links_title: '핸드메이드 크리에이터 <br />왜 마플샵일까요?',
        links_card_title_1: '나만의 브랜드 샵, <br /> 진짜 손쉽게 만들 수 있어요',
        links_card_description_1:
          '내가 만든 핸드메이드 작품이 더 돋보일 수 있도록 <br />\n           마플샵에서 나만의 브랜드 샵을 만들어 보세요. <br />\n           간단한 설정만으로도 나만의 샵을 손쉽게 오픈하고 <br />\n           핸드메이드 상품을 진열하여 판매할 수 있어요. <br />\n           로고, 배너 이미지, 상세 페이지 등을 자유롭게 설정하여 <br />\n           나만의 창작 세계를 더욱 돋보이게 만들어 보세요!',
        mo_links_card_description_1:
          '내가 만든 핸드메이드 작품이 더 돋보일 수 있도록 <br />\n         마플샵에서 나만의 브랜드 샵을 만들어 보세요. <br />\n         간단한 설정만으로도 나만의 샵을 손쉽게 오픈하고 <br />\n         핸드메이드 상품을 진열하여 판매할 수 있어요.',
        mo_links_card_sub_description_1:
          '브랜드 로고, 배너 이미지, 상세 페이지 등을 자유롭게 <br />\n         설정하여 나만의 창작 세계를 더욱 돋보이게 만들어 보세요!',
        links_cta_button_text_1: '핸드메이드/DIY 상품 보기',
        links_card_title_2: '마플샵제작배송 상품과 함께 <br />판매 수익을 높여보세요.',
        links_card_description_2:
          '디자인만 있으면 제작부터 포장, 배송, 고객응대, 재고 관리까지 <br /> 전 과정을 모두 지원하는 마플샵제작배송 상품을 판매할 수 있어요. <br /> 복잡한 물류 관리나 제작 과정에 신경 쓰지 않아도 내가 디자인한 상품을 간편하게 판매할 수 있습니다. <br /> 크리에이터님이 창작 활동에만 집중할 수 있도록 도와드릴게요.',
        mo_links_card_description_2:
          '디자인만 있으면 제작부터 포장, 배송, 고객응대, <br /> 재고 관리까지 전 과정을 모두 지원하는 <br /> 마플샵제작배송 상품을 판매할 수 있어요.',
        mo_links_card_sub_description_2:
          '복잡한 물류 관리나 제작 과정에 신경 쓰지 않아도 <br /> 내가 디자인한 상품을 간편하게 판매할 수 있습니다. <br /> 크리에이터님이 창작 활동에만 집중할 수 있도록 도와드릴게요.',
        links_cta_button_text_2: '굿즈 상품 보기',
        links_card_title_3: '마플샵은 국내 최초<br />유튜브 쇼핑 공식 파트너예요',
        links_card_description_3:
          '마플샵은 국내 최초 유튜브 쇼핑 공식 파트너입니다. <br /> 유튜브, 인스타그램 등 다양한 SNS 채널과 나의 브랜드 샵 연동을 통해 <br /> 팬들은 어디서든지 내가 만든 상품을 만날 수 있어요. <br /> 유튜브 쇼핑 기능을 활용해 영상 콘텐츠와 <br /> 상품 구매를 연결해 보다 생동감있는 고객 경험을 선사해 보세요.',
        mo_links_card_description_3:
          '마플샵은 국내 최초 유튜브 쇼핑 공식 파트너입니다. <br /> 유튜브, 인스타그램 등 다양한 SNS 채널과 <br /> 나의 브랜드 샵 연동을 통해 팬들은 어디서든지 <br /> 내가 만든 상품을 만날 수 있어요.',
        mo_links_card_sub_description_3:
          '유튜브 쇼핑 기능을 활용해 영상 콘텐츠와 상품 구매를 <br /> 연결해 보다 생동감있는 고객 경험을 선사해 보세요.',
        links_cta_button_text_3: '마플샵 X Youtube 쇼핑이란?',
        links_card_title_4: '나만의 노하우가 담긴 <br /> 도안 판매부터 전자책 판매까지',
        links_card_description_4:
          '마플샵에선 실물 상품 외에도 나만의 노하우가 가득 담긴 <br /> 디지털 도안이나 전자책까지 판매할 수 있어요. <br /> 나만의 창작 노하우를 담은 디지털 콘텐츠를 판매하면서 <br /> 핸드메이드를 통한 디지털/전자책 수익 창출이 가능해요.',
        mo_links_card_description_4:
          '마플샵에선 실물 상품 외에도 나만의 노하우가 가득 담긴 디지 <br /> 털 도안이나 전자책까지 판매할 수 있어요. <br /> 나만의 창작 노하우를 담은 디지털 콘텐츠를 판매하면서 핸드 <br /> 메이드를 통한 디지털/전자책 수익 창출이 가능해요.',
        links_cta_button_text_4: '전자책/디지털 보기',
        links_card_title_5: '내 소중한 작품으로 <br /> 유니크한 팝업스토어를 열어보세요',
        links_card_description_5:
          '마플샵은 팝업스토어의 성지, 성수동에서 <br /> 오프라인 팝업스토어 공간을 운영하고 있습니다. <br /> 마플샵 팝업스토어는 크리에이터가 오직 창작과 <br /> 상품 판매에만 집중할 수 있도록 <br /> 세련된 집기와 쉽고 간편한 판매 시스템을 갖추고 있습니다.',
        mo_links_card_description_5:
          '마플샵은 팝업스토어의 성지, 성수동에서 <br /> 오프라인 팝업스토어 공간을 운영하고 있습니다.',
        mo_links_card_sub_description_5:
          '마플샵 팝업스토어는 크리에이터가 <br /> 오직 상품 창작과 판매에만 집중할 수 있도록 <br /> 세련된 집기와 쉽고 간편한 판매 시스템을 갖추고 있습니다.',
        links_cta_button_text_5: '마플샵 팝업스토어란?',
        statistics_date: "24' 10월 기준 데이터",
        statistics_title_1: '마플샵 활동 크리에이터',
        statistics_title_2: '상위 15% 월 평균 수입',
        statistics_title_3: '마플샵 누적 거래액',
        statistics_title_4: '마플샵 회원 수',
        statistics_title_5: '마플샵 재구매율',
        statistics_title: '마플샵은 <br /> 지속적으로 성장하고 있는 <br /> 크리에이터 커머스 플랫폼입니다',
        statistics_description:
          '나만의 브랜드를 만들고 아이디어를 마플샵에서 실현해 보세요. <br /> 마플샵에서는 내가 만든 핸드메이드 상품부터 굿즈, 디지털/전자책까지 모두 판매할 수 있어요.',
        mo_statistics_description:
          '나만의 브랜드를 만들고 아이디어를 <br /> 마플샵에서 실현해 보세요. <br /> 마플샵에서는 내가 만든 핸드메이드 상품부터 <br /> 굿즈, 디지털/전자책까지 모두 판매할 수 있어요.',
        statistics_button: '만들어봐 현실로, 마플샵',
        portfolio_banner_title: '당신처럼 열정적인<br/> 핸드메이드 크리에이터들의 마플샵 스토리',
        mo_portfolio_banner_title: '당신처럼 열정적인<br/> 핸드메이드 크리에이터들의<br/> 마플샵 스토리',
        interview_title: '마플샵 덕분에 <br />제 작품을 고객들에게 <br />보다 빨리 선보일 수 있었어요',
        interview_sub_title:
          '마플샵이 크리에이터들에게 어떤 변화를 가져다주었는지<br />그들의 이야기를 직접 들어보세요.',
        interview_description:
          '마플샵을 통해 나만의 브랜드를 어떻게 성장시켰는지,<br /> 핸드메이드 작품을 세상과 나누면서 어떤 경험을 했는지,<br /> 크리에이터들의 이야기를 통해 확인해 보세요. <br /> 마플샵이 여러분에게도 특별한 기회를 제공합니다.',
        interview_creator_1: '레진 아트 브랜드<br /> 쪼만한 마을',
        interview_sub_description_1:
          '요즘 사람들은 다양한 미디어를 접하면서 특별한 취미를<br/> 가지기 어렵습니다. 저는 레진 공예 초보자도 쉽게 만들 수 있는 다양한 키트를 구성해 판매하고 싶습니다.',
        interview_description_1:
          '유튜브에서도 주문이 가능해 고객들이 편리하게 구매할 수 있었는데, 공예에 관심 있는 시청자들이 영상을 보고 필요한 재료를 바로 구입할 수 있는 시스템이 큰 장점입니다.<br/> 더 나아가 해외배송도 시작하고 싶어요. K-문화가 유행하면서 저희 유튜브 채널에도 외국인 시청자가 늘어났어요.<br/> 마플샵에서 해외배송이 가능하다면 큰 도움이 될 것 같아요.',
        interview_creator_2: '라이프스타일 브랜드<br/>뚜까따',
        interview_sub_description_2:
          "마플샵을 통해 브랜드 '뚜까따'를 알리고 다양한 작업으로 새로운 경험을 전달하고 싶습니다. 또한 마플샵을 통해<br/> 다른 분야의 크리에이터와의 협업이나 콜라보레이션,<br/> 새로운 실험적인 도전의 기회가 생겨났으면 좋겠습니다.",
        interview_description_2:
          '성수동 팝업스토어와 온라인 샵 운영이 편리했고, 마플샵의 여러 지원 덕분에 수월하게 진행되었습니다.<br/> 상품 제작부터 마케팅, 팝업까지 원스톱으로 지원되는 경험이 좋았고 재고 부담 없이 상품을 쉽게 제작하고<br/> 판매할 수 있는 마플샵제작배송 상품이 있어서 시간과 비용을<br/> 절약할 수 있었어요.',
        interview_creator_3: '텍스타일 크래프트 브랜드<br/>쿤스트호이테',
        interview_sub_description_3:
          '공예품과 굿즈를 연결하였을 때 무엇을 원하고<br/> 어떻게 사는지에 대한 고객의 다양한 생각을 파악할 수 있는<br/> 좋은 기회가 될 것 같습니다.<br/> 쿤스트호이테의 자연의 색과 염색 기법들이 담긴<br/> 다양한 작업으로 공예의 특성을 살려 마플샵 고객의 니즈를<br/> 파악하고 기획하여 제작된 상품을 선보이고자 합니다.',
        interview_description_3:
          '특히, 마플샵은 고객과의 협업 형태로 발전 가능성이 높아<br/> 세상에 하나뿐인 나만의 물건을 만드는 데 최적화되어<br/> 있다고 생각합니다. 쿤스트호이테가 추구하는 방향성과<br/> 잘 맞으며 새로운 시너지로 이어질 거라고 기대합니다.',
        benefit_title: '마플샵, 지금이 기회예요',
        benefit_description:
          '마플샵이 핸드메이드 크리에이터분들을 위해 특별한 혜택을 준비했습니다. <br />마플샵을 통해 크리에이터님의 작품을 보다 많은 팬들에게 선보이세요!',
        mo_benefit_description:
          '마플샵이 핸드메이드 크리에이터분들을 위해 <br /> 특별한 혜택을 준비했습니다.',
        benefit_card_title_1: '입점 판매 수수료 0%',
        mo_benefit_card_title_1: '입점 판매 수수료 5% → 0%',
        benefit_card_sub_description_pc_1: '※ PG사 수수료 (3.52%)는 별도입니다.',
        benefit_card_sub_description_pc_2: '※ 마플샵 수수료 정책은 수시 변경될 수 있습니다.',
        benefit_card_sub_description_1: '※ PG/카드사 수수료 제외',
        benefit_card_title_2: '오프라인 팝업스토어 지원',
        mo_benefit_card_title_2: '오프라인 팝업스토어 지원',
        benefit_card_description_2:
          '<span>마플샵 오프라인 팝업스토어</span>에서 작가님만의 팝업을 열어보세요. <br /> 핸드메이드 상품뿐만 아니라 굿즈 상품까지 확장하여 매출을 늘려보세요.<br /> 마플샵이 <span>상품 기획부터 팝업 기획, VMD</span>까지 성공적인 진행을 도와드립니다.',
        mo_benefit_card_description_2:
          '<span>마플샵 오프라인 팝업스토어</span>에서<br /> 작가님만의 팝업을 열어보세요.<br /> 핸드메이드 상품뿐만 아니라 굿즈 상품까지<br /> 확장하여 매출을 늘려보세요.<br /> 마플샵이 <span>상품 기획부터 팝업 기획, VMD</span>까지<br /> 성공적인 진행을 도와드립니다.',
        benefit_card_sub_description_2: '오프라인 팝업스토어 사례보기',
        benefit_card_title_3: '광고 및 홍보 지원',
        mo_benefit_card_title_3: '광고 및 홍보 지원',
        benefit_card_description_3:
          '캠페인 기간 동안 입점하신 핸드메이드 크리에이터 대상으로<br /> <span>마플샵 온라인 팝업스토어</span> 참여 기회를 제공합니다.<br /> 핸드메이드에 맞는 스토리텔링을 기반으로 한 온라인 팝업스토어를 진행하여<br /> 효과적으로 브랜드와 상품을 노출해 보세요.<br /> <span>마플샵의 온사이트와 SNS 채널</span>을 통해 적극적인 홍보를 지원합니다.',
        mo_benefit_card_description_3:
          '캠페인 기간 동안 입점하신 핸드메이드 크리에이터 대상으로 <span>마플샵 온라인 팝업스토어</span> 참여 기회를 제공합니다.<br /> 핸드메이드에 맞는 스토리텔링을 기반으로 한<br /> 온라인 팝업스토어를 진행하여 효과적으로<br /> 브랜드와 상품을 노출해 보세요.<br /> <span>마플샵의 온사이트와 SNS 채널</span>을 통해<br /> 적극적인 홍보를 지원합니다.',
        benefit_card_sub_description_3: '온라인 팝업스토어 사례보기',
        benefit_card_title_4: '유튜브 쇼핑 지원',
        mo_benefit_card_title_4: '유튜브 쇼핑 지원',
        benefit_card_description_4:
          '유튜브 채널도 운영하고 계시나요? <br /> 유튜브 수익 창출 조건에 부합된 크리에이터의 경우, <br /> <span>마플샵과 연동하여 유튜브 쇼핑 기능</span>을 활용할 수 있습니다. <br /> 나만의 콘텐츠에 상품을 연결하여 고객들에게 특별한 쇼핑경험을 선사하세요.',
        mo_benefit_card_description_4:
          '유튜브 채널도 운영하고 계시나요?<br /> 유튜브 수익 창출 조건에 부합된 크리에이터의 경우,<br /> <span>마플샵과 연동하여 유튜브 쇼핑 기능</span>을<br /> 활용할 수 있습니다.<br /> 나만의 콘텐츠에 상품을 연결하여 고객들에게<br /> 특별한 쇼핑경험을 선사하세요.',
        benefit_card_sub_description_4: '마플샵 X 유튜브 쇼핑이란?',
        benefit_info_title: '혜택 참고사항',
        benefit_info_desc_1:
          '온라인/오프라인 팝업스토어는 공간 대관 일정과 마플샵 심사에 따라 진행 가능 여부가 결정됩니다.',
        benefit_info_desc_2:
          '유튜브 쇼핑의 경우, 유튜브 수익창출 조건과 마플샵 크리에이터 승인 과정을 거친 후 활용이 가능합니다.',
        story_nav_1: '1. 손끝에서 시작',
        story_nav_2: '2. 정성과 사랑으로',
        story_nav_3: '3. 같은 꿈',
        story_nav_4: '4. 누군가의 일상',
        story_nav_5: '5. 마플샵과 함께',
        story_title: '마플샵과 함께, <br /> 나의 작품이 전하는 특별한 이야기',
        mo_story_title: '마플샵과 함께, <br /> 나의 작품이 전하는 <br /> 특별한 이야기',
        story_content_title_1: '나의 손끝에서 시작되는 이야기',
        story_content_description_1:
          '내가 만들어낸 작품 하나하나가 누군가의 마음을 따뜻하게 만듭니다. <br /> 세상에 단 하나뿐인 그 특별한 물건을 직접 만든 당신, 그 정성과 이야기를 더 많은 사람들과 나눠보세요. <br /> 마플샵은 당신의 작은 창작의 순간들이 더 큰 기쁨이 되도록, <br /> 더 많은 사람들과 만나도록 도와드립니다.',
        mo_story_content_description_1:
          '내가 만들어낸 작품 하나하나가 누군가의 마음을<br /> 따뜻하게 만듭니다.<br /> 세상에 단 하나뿐인 그 특별한 물건을 직접 만든 당신,<br /> 그 정성과 이야기를 더 많은 사람들과 나눠보세요.<br /> 마플샵은 당신의 작은 창작의 순간들이 더 큰 기쁨이 되도록,<br /> 더 많은 사람들과 만나도록 도와드립니다.',
        story_content_link_1: '핸드메이드/DIY 상품 보기',
        story_content_title_2: '정성과 사랑으로 완성된 작품',
        story_content_description_2:
          '손끝에서 하나하나 정성 들여 만든 작품들, 그 속에는 창작자의 사랑과 열정이 고스란히 담겨 있습니다. <br /> 마플샵은 크리에이터의 작품이 더욱 빛날 수 있도록 최선을 다해 지원합니다. <br /> 당신의 작품이 더 많은 이들의 일상 속에 스며들어, 소중한 순간을 만들어 나가도록 함께 할게요.',
        mo_story_content_description_2:
          '손끝에서 하나하나 정성 들여 만든 작품들, <br /> 그 속에는 창작자의 사랑과 열정이 고스란히 담겨 있습니다. <br /> 마플샵은 크리에이터의 작품이 더욱 빛날 수 있도록 <br /> 최선을 다해 지원합니다. <br /> 당신의 작품이 더 많은 이들의 일상 속에 스며들어, <br /> 소중한 순간을 만들어 나가도록 함께 할게요.',
        story_content_link_2: '핸드메이드/DIY 큐레이션',
        story_content_title_3: '같은 꿈을 가진 사람들과의 만남',
        story_content_description_3:
          '마플샵에는 같은 꿈을 꾸는 크리에이터들이 있습니다. <br /> 서로의 열정을 응원하고 영감을 주고받으며 성장하는 마플샵에서 <br /> 우리는 하나의 커뮤니티가 됩니다. <br /> 창작 이야기를 우리와 함께 나누고 더 나은 세상을 만들어 보세요.',
        mo_story_content_description_3:
          '마플샵에는 같은 꿈을 꾸는 크리에이터들이 있습니다. <br /> 서로의 열정을 응원하고 영감을 주고받으며 성장하는 마플샵에서 <br /> 우리는 하나의 커뮤니티가 됩니다. <br /> 창작 이야기를 우리와 함께 나누고 더 나은 세상을 만들어 보세요.',
        story_content_link_3: '크리에이터 커뮤니티',
        story_content_title_4: '당신의 작품이 누군가의 일상에 특별함을',
        story_content_description_4:
          '손끝에서 탄생한 그 특별한 작품이 누군가에게는 매일의 작은 행복이 될 수 있습니다. <br /> 마플샵은 그 순간을 함께 만들어 가는 여정을 응원합니다. <br /> 창작의 모든 과정에서, 당신의 노력이 아름다운 결실로 이어지도록 함께 할게요.',
        mo_story_content_description_4:
          '손끝에서 탄생한 그 특별한 작품이 누군가에게는 <br /> 매일의 작은 행복이 될 수 있습니다. <br /> 마플샵은 그 순간을 함께 만들어 가는 여정을 응원합니다. <br /> 창작의 모든 과정에서, 당신의 노력이 아름다운 결실로 <br /> 이어지도록 함께 할게요.',
        story_content_link_4: '핸드메이드 리뷰',
        story_content_title_5: '마플샵과 함께, 더 많은 기회를',
        story_content_description_5:
          '나의 이야기를 마플샵에서 시작해 보세요. <br /> \n          입점 시 다양한 혜택과 지원을 통해 더 많은 팬을 만나고 더 많은 가능성을 실현할 수 있습니다. <br /> \n          크리에이터의 꿈을 펼칠 무대인 마플샵에서 새로운 도전을 시작해보세요.',
        mo_story_content_description_5:
          '나의 이야기를 마플샵에서 시작해 보세요. <br /> \n          입점 시 다양한 혜택과 지원을 통해 더 많은 팬을 만나고 <br /> \n          더 많은 가능성을 실현할 수 있습니다. <br /> \n          크리에이터의 꿈을 펼칠 무대인 마플샵에서 <br /> \n          새로운 도전을 시작해보세요.',
        story_content_link_5: '크리에이터 신청하기',
        bottom_title: '크리에이터님 덕분에 <br /> 세상은 더 따듯하고 행복해질 거예요',
        mo_bottom_title: '크리에이터님 덕분에 <br /> 세상은 더 따듯하고 <br /> 행복해질 거예요',
        bottom_description:
          '사랑하는 사람을 위한 소소한 선물부터 이벤트, 특별한 기념일까지 - <br />\n            마플샵은 핸드메이드가 전달하는 가치를 존중하며 <br />\n            핸드메이드 크리에이터 여러분들의 성장을 위해 꾸준히 노력하겠습니다.',
        mo_bottom_description:
          '사랑하는 사람을 위한 소소한 선물부터 <br /> 이벤트, 특별한 기념일까지 - <br />\n            마플샵은 핸드메이드가 전달하는 가치를 존중하며 <br /> 핸드메이드 크리에이터 여러분들의 성장을 위해 <br /> 꾸준히 노력하겠습니다.',
      },
    },
    studio: {
      editor: {
        max_length_10_txt: '상품 상세 이미지는 10개까지 올릴 수 있습니다.',
        instagram_error_title: '인스타그램 연결 불가',
        instagram_error_description:
          '현재 URL은 지원되지 않는 형식입니다.\n공개 상태인 게시물의 URL을 입력해 주세요.',
      },
      welcome_title: '마플샵 스튜디오에<br/>오신 걸 환영합니다!',
      welcome_guide:
        '마플샵 스튜디오와 함께 언제 어디서든<br/>PC와 스마트폰으로 나만의 굿즈를 만들어 볼까요?',
      page: {
        products: '마플샵제작배송 상품 만들기',
        products_guide: '디자인만 있다면 단 3분이면 가능한 마플샵제작배송 상품을 만들어 보세요.',
        products_order: '주문 내역',
        products_order_guide: '한 주간의 주문 내역을 확인할 수 있습니다.',
        products_creator: '크리에이터배송 상품 등록',
        products_creator_guide: '내가 재고를 가지고 있거나 직접 만든 상품을 판매해 보세요.',
        products_creator_inventory: '재고 관리',
        products_creator_inventory_guide: '등록되어 있는 상품들을 확인하고 관리해 보세요.',
        products_creator_order: '주문 관리',
        products_creator_order_guide: '신규 주문 정보를 확인하고 관리해 보세요.',
        products_creator_shipment: '배송 관리',
        products_creator_shipment_guide: '상품의 발송 처리와 배송 정보를 관리해 보세요.',
        products_creator_refund: '환불 관리',
        products_creator_refund_guide: '환불 사항을 확인하고 관리해 보세요.',
        products_digital: '디지털/전자책 등록',
        products_digital_guide: '다양한 디지털/전자책을 쉽고 빠르게 판매해 보세요.',
        products_digital_order: '디지털/전자책 주문 내역',
        products_digital_order_guide: '디지털/전자책의 주문 내역을 확인할 수 있습니다.',
        question: '고객 문의',
        question_guide: '고객의 문의 내용을 확인하고 소통해 보세요.',
        store_style: '샵 디자인',
        store_style_guide: '프로필·로고·배너 등을 변경하여 샵을 디자인해 보세요.',
        store_product_arrangement: '상품 정렬',
        store_product_arrangement_guide:
          '내 샵에서 판매 중인 상품을 드래그하여 원하는 대로 상품 정렬을 변경해 보세요.',
        store_info: '샵 정보',
        store_info_guide: '내 샵의 기본 정보들을 관리하는 페이지입니다.',
        store_ecommerce_info: '크리에이터 정보',
        store_ecommerce_info_guide: '크리에이터배송 상품 판매를 위한 정보를 입력하는 페이지입니다.',
        youtube_connection: '유튜브 채널에서 마플샵 상품을 판매해 보세요!',
        youtube_connection_guide:
          '마플샵은 국내 최초 유튜브 상품 판매 플랫폼 공식 파트너사로 믿을 수 있어요.',
        open_api: '외부서비스 연동 (API)',
        open_api_guide: '외부 서비스와의 연동을 관리하는 페이지 입니다.',
        adjustments: '정산 관리 - {{date}}',
        adjustments_guide:
          '정산 관리에서는 각 상품 및 서비스의 정산 기준으로 월별 정산 내역을 확인할 수 있습니다.',
        withdraws: '빠른 출금 신청',
        withdraws_guide: '한 달간 발생한 판매 수익을 출금하실 수 있습니다.',
        bank_account: '정산 정보',
        bank_account_guide: '입력하신 계좌 정보로 수익을 정산 받으실 수 있습니다.',
        products_analytics: '상품별 판매 분석',
        products_analytics_guide: '내가 만든 상품들의 판매 순위를 확인해 보세요.',
        faq: 'FAQ',
        faq_guide: '크리에이터들이 자주 묻는 질문을 확인해 보세요.',
        solution: '신고 접수',
        solution_guide: '내 샵 또는 상품 등에 접수된 신고를 확인할 수 있습니다.',
      },
      tooltip: {
        adjustments:
          '<h4>마플샵 상품 정산</h4><div>출고 날짜 기준으로 월별 산정됩니다.</div><br/><h4>상품 정산{{tpl_adjustments}} & 디지털/전자책 정산</h4><div>구매확정일을 기준으로 월별 산정됩니다.</div><br/><h4>멤버십 정산</h4><div>고객 결제일의 9일 후를 기준으로 월별 산정됩니다.</div><br/><h4>후원 정산</h4><div>고객 결제일의 익일을 기준으로 월별 산정됩니다.</div><br/><h4>커미션 정산</h4><div>구매확정일을 기준으로 월별 산정됩니다.</div><br/><h4>크리에이터 디자인</h4><div>구매확정일을 기준으로 월별 산정됩니다.</div>',
        withdraw_amount:
          '<div>마플샵 상품 계산 금액 + 상품 정산 금액 = 출금 예정 금액</div><br/><h4>마플샵 상품 계산 금액이란?</h4><br/><div>- 개인 크리에이터<div>마플샵 상품 정산 금액 - 부가세(10%) - 원천징수세(3.3%)<br />= 굿즈 계산 금액</div><br/>- 사업자 크리에이터<div>마플샵 상품 정산 금액 = 마플샵 상품 계산 금액<br/>※사업자의 경우 세금계산서 발행 후에 출금 가능합니다.</div></div>',
        pg_commission_title: 'PG사 수수료',
        pg_commission_desc: 'PG사 수수료 3.2%에 10% 부가가치세를 더한 가격입니다.',
      },
    },
    share: {
      marppleshop_description: '상상하는 모든 것을 현실로 만들 수 있는<br/>크리에이터 커머스 플랫폼, 마플샵',
      store_main_description: '마플샵에서 {{creator_name}}만의 굿즈를 만나보세요.',
      plus_main_description: '{{plus_name}}에서 공식 굿즈를 만나볼 수 있는 기회!',
      creator_view_description: '마플샵에서 전하는 [{{creator_name}}]의 이야기를 들어보세요.',
      marppleshop_app_download: '마플샵 앱 다운로드',
    },
    order: {
      country: '국가',
    },
    ad_res: {
      terms_modal: {
        title: '개인 정보 수집 및 이용 동의',
        content_title_1: '수집・이용기관명',
        content_title_2: '수집 항목',
        content_title_3: '수집・이용목적',
        content_title_4: '보유 및 이용기간',
        content_description_1: '(주)마플코퍼레이션',
        content_description_2: '(필수) 성명, 연락처, 이메일',
        content_description_3: '마플샵 크리에이터 신청 및 서비스 제공',
        content_description_4: '크리에이터 신청일로부터 1년',
        tip: '개인정보 제공자는 개인정보의 수집 및 이용에 관한 동의를 거부할 권리가 있으며, <br />\n        이 경우 크리에이터 신청 및 안내가 불가능 합니다.',
        submit: '확인',
      },
      title: '마플샵 크리에이터 신청하기',
      description_1: '마플샵에서 상상하는 모든 것을 현실로 만들어 보세요.',
      description_2:
        '개인 또는 기업 누구나 신청할 수 있으며 본인이 직접 디자인 및 제작하거나 <br />\n      저작권을 보유한 상품과 콘텐츠만 있다면 입점할 수 있습니다.',
      mo_description_2:
        '개인 또는 기업 누구나 신청할 수 있으며<br />\n        본인이 직접 디자인 및 제작하거나 저작권을 보유한 상품과<br />\n        콘텐츠만 있다면 입점할 수 있습니다.',
      required: '필수 입력',
      required_one: '1개 이상 필수 입력',
      required_one_optional: '1개 이상 선택 입력',
      basic_info: '기본 정보',
      brand_name: '샵 이름',
      brand_placeholder: '샵 이름을 입력해 주세요.',
      brand_validation: '2자 이상 20자 이내로 입력해 주세요.',
      domain_name: '도메인명',
      domain_placeholder: 'your_domain',
      domain_validation: '영문, 숫자, 언더바(_)를 사용하여 2-20자 이내로 입력해 주세요.',
      domain_validation_error: '2-20자의 영문, 숫자, 언더바(_)만 사용 가능합니다.',
      domain_duplicate: '이미 사용 중인 도메인입니다. 다른 도메인을 입력해 주세요.',
      creator_cate: '크리에이터 카테고리',
      introduce: '소개',
      introduce_placeholder: '크리에이터 또는 샵 소개를 남겨 주세요',
      introduce_error: '본인 또는 브랜드를 소개하는 내용을 200자 이내로 입력해 주세요.',
      letter_count: '자',
      contact_info: '연락처 정보',
      email_name: '이메일',
      email_placeholder: '이메일을 입력해 주세요.',
      email_error: '올바른 이메일 형식으로 입력해 주세요.',
      email_duplicate: '심사중이거나 중복된 이메일입니다',
      phone: '연락처',
      phone_placeholder: '하이픈(-) 없이 숫자만 입력해 주세요.',
      phone_error: '하이픈(-)을 제외한 올바른 연락처 형식으로 입력해 주세요.',
      portfolio: 'SNS / 포트폴리오',
      portfolio_sub: '본인을 잘 소개할 수 있는 SNS 혹은 포트폴리오 중 하나 이상 입력해 주세요.',
      sns: '대표 SNS',
      sns_placeholder: '운영하고 계신 SNS 채널 주소를 입력해 주세요.',
      url_error: '올바른 URL 형식으로 입력해 주세요.',
      portfolio_file: '포트폴리오 파일',
      portfolio_file_validation:
        'JPG, PNG, PPT, KEYNOTE, PDF 형식의 50MB 이하의 파일만 업로드 할 수 있습니다. (최대 3개 업로드 가능)',
      file_upload: '파일 업로드',
      delete: '삭제',
      website: '포트폴리오 사이트',
      website_placeholder: '개인 웹사이트, 노트폴리오, 비핸스 URL 등 참고할 사이트 주소를 입력해 주세요.',
      mo_website_placeholder: '개인 웹사이트, 노트폴리오, 비핸스 URL 등',
      agreement: '개인정보 수집・이용 동의',
      agree_all: '전체 항목에 동의합니다.',
      necessary: '[필수]',
      agree_privacy: '개인 정보 수집 및 이용에 관한 내용을 모두 확인하였으며 동의합니다.',
      mo_agree_privacy: '개인 정보 수집 및 이용에 관한<br />내용을 모두 확인하였으며 동의합니다.',
      view: '보기',
      agree_terms: '만 14세 이상입니다.',
      notification: '꼭 읽어주세요!',
      notification_1:
        '판매하는 콘텐츠의 저작권은 판매 주체인 크리에이터에게 있으며 사전 접수 신청시 저작권 소유자 확인을 <br /> 인증한 것으로 간주합니다.',
      notification_2:
        '저작권 등 타인의 권리를 침해하거나 명예를 훼손하는 이미지, 디자인등의 게시에 대한 책임은 크리에이터에게 있습니다.',
      notification_3:
        '제공된 개인정보는 개인정보 제공자가 동의한 내용 외의 다른 목적으로 활용하지 않으며, 보유 기간 내에 제공된 개인정보의 이용을 거부하고자 할 때에 자유롭게 개인정보 관리 책임자(partner@marppleshop.com), 고객센터(1566-5496)을 통해 열람, 정정, 삭제를 요구할 수 있습니다.',
      apply: '신청하기',
      finish_title: '샵 생성 링크를 보냈으니 이메일을 확인해보세요!',
      finish_title_mo: '샵 생성 링크를 보냈으니<br/> 이메일을 확인해보세요!',
      finish_description_1: '샵을 개설하고 상품을 등록해보세요!',
      finish_description_2:
        '메일이 보이지 않는다면 스팸함을 확인하거나 <br /> <a href="mailto:cs@marppleshop.com">cs@marppleshop.com</a>으로 문의해 주세요.',
      finish_info_desc: '심사 자료가 부족하거나 부적절한 내용이 포함된 경우, 신청이 거절될 수 있습니다.',
      finish_info_desc_mo:
        '심사 자료가 부족하거나 부적절한 내용이 포함된 경우,<br/> 신청이 거절될 수 있습니다.',
      file_upload_count_error_title: '업로드 개수 초과',
      file_upload_count_error_desc: '최대 3개까지 등록할 수 있습니다. <br /> 3개 이하로 업로드해 주세요.',
      file_upload_confirm: '확인',
      file_upload_size_error_title: '업로드 용량 초과',
      file_upload_size_error_desc: '최대 50MB까지 등록할 수 있습니다. <br /> 50MB 이하로 업로드해 주세요.',
      file_upload_error_title: '파일업로드가 실패했습니다.',
      file_upload_error_desc:
        '다시 시도해주시거나<br><a href="mailto:partner@marppleshop.com">partner@marppleshop.com</a>에 문의해 주세요.',
      creator_apply: '크리에이터 신청하기',
      apply_desc:
        '잘못된 전화번호와 이메일인 경우 <br /> 마플샵 생성 링크가 도착하지 않습니다. <br/> 올바른 정보인지 확인해 주세요.',
      apply_cancel: '취소',
      agree_personal: '개인정보 수집 이용에 동의해 주세요.',
      agree_age: '만 14세 이상 동의해 주세요.',
      file_uploading: '파일 업로드 중입니다. 업로드 후에 다시 시도해 주세요.',
      brand_validation_error: '영문/한글/숫자 조합하여 2자 이상 20자 이내로 입력해주세요.',
      fail_same_email:
        "같은 이메일로 이미 신청되었습니다. 메일이 안오셨다면 스팸함을 확인해봐주세요.<br/>그래도 없다면 <a href='mailto:partner@marppleshop.com'>partner@marppleshop.com</a> 으로 문의해주세요.",
      fail_apply:
        "크리에이터 신청이 완료되지 않았습니다.<br>다시 시도해주시거나 <a href='mailto:partner@marppleshop.com'>partner@marppleshop.com</a>으로 문의해 주세요.",
    },
    membership: {
      common: {
        membership: '멤버십',
      },
      main: {
        title: '멤버십',
        sub_title: 'Membership',
        description: '우리의 인연이 더 특별해지는 순간',
      },
      commission: {
        title: '커미션',
        sub_title: 'Commission',
        description: '나만을 위한 특별한 작품',
        state_pending: '수락 대기',
        state_end: '구매 확정',
        state_accepted: '작업 중',
        state_on_refund: '환불 예정',
        state_refunded: '취소/환불',
        state_task_done: '작업 완료',
      },
      support: {
        title: '후원',
        sub_title: 'Support',
        description: '창작을 이어가는 힘, 크리에이터 캠페인에 함께하세요!',
        go_support_button_label: '후원하기',
      },
      paymethod: '결제 수단',
      join: '멤버십 가입',
      join_success: '멤버십 가입 완료',
      product: '멤버십 상품',
      plan: '플랜',
      error: {
        token_expired_title: '멤버십 인증 만료',
        token_expired_description:
          '장시간 사용하지 않아 멤버십 인증이 만료되었습니다.<br/> 멤버십 인증을 위해 페이지가 다시 새로고침됩니다.',
        widget_activate_title: '멤버십 위젯 오류',
        widget_activate_description:
          '멤버십 위젯을 보여드리기 전 잠시 오류가 생겼어요<br/> 위젯을 다시 불러오기 위해 페이지가 다시 새로고침됩니다.',
      },
      payment: '멤버십 결제하기',
      go_join_button_label: '멤버십 가입',
      go_join_button_label_already: '멤버십 가입 중',
      starter_modal: {
        sub_title: '크리에이터와 팬을 더 단단하게 이어줄 —',
        title: '마플샵 크리에이터 멤버십 스타터 모집!',
        desc: '2025년 3월 정식 출시 예정인 마플샵 크리에이터 멤버십 기능을<br/>먼저 체험해 보실 스타터 크리에이터를 모집합니다.<br/>소중한 팬들에게 특별한 혜택과 경험을 제공하고,<br/>새로운 수익을 창출할 수 있는 마플샵 멤버십 스타터가 되어보세요!',
        desc_mobile:
          '2025년 3월 정식 출시 예정인<br/>마플샵 크리에이터 멤버십 기능을<br/>먼저 체험해 보실 스타터 크리에이터를 모집합니다.<br/>소중한 팬들에게 특별한 혜택과 경험을 제공하고,<br/>새로운 수익을 창출할 수 있는<br/>마플샵 멤버십 스타터가 되어보세요!',
        guide: '멤버십 서비스 소개',
        apply: '멤버십 스타터 신청하기',
        not_today: '오늘 보지 않기',
      },
      membership_detail: '멤버십 상세',
      support_detail: '후원 상세',
      commission_detail: '커미션 상세',
    },
    popup: {
      close_today: '오늘 보지 않기',
      close: '닫기',
    },
    creator_ranking: {
      title_main: '{{tab}} 크리에이터 랭킹',
      sub_title: '다양한 크리에이터의 매력 폭발!',
      realtime: '실시간',
      weekly: '주간',
      monthly: '월간',
      list_title: '{{tab}} 크리에이터 랭킹 Top 100',
    },
    collaboration: {
      title: '협업 제안하기',
      creator_name: '크리에이터명',
      collaboration_type: '제안 종류',
      collaboration_type_description: '다중 선택 가능',
      collaboration_category: '협업 카테고리',
      collaboration_category_placeholder: '카테고리 선택',
      collaboration_category_etc_placeholder: '협업 카테고리를 직접 입력해 주세요.',
      proposal_content: '제안 내용',
      proposal_content_placeholder:
        '크리에이터에게 제안할 협업 내용을 입력해 주세요.\n1. 제안 사유와 요약 내용\n2. 공동 구매 : 상품명/공구 구매 판매가/판매 수수료(%)\n3. 광고 : 상품명/광고 유형(브랜디드, 유튜브 쇼츠, 틱톡 등)/광고 비용\n4. 라이브 방송 : 상품명/판매가/인센티브 구조(출연료 혹은 판매 수수료)',
      proposal_content_description: '문의 내용은 최대 2000bytes까지 입력 가능합니다.',
      brand_name: '회사/브랜드명',
      brand_name_placeholder: '회사/브랜드명을 입력해 주세요.',
      brand_url: '자사몰 홈페이지 URL',
      brand_url_placeholder: '자사몰 홈페이지 URL를 입력해 주세요.',
      manager_name: '담당자 성함',
      manager_name_placeholder: '담당자 성함을 입력해 주세요.',
      manager_tel: '담당자 연락처',
      manager_tel_placeholder: '담당자 연락처를 입력해 주세요.',
      manager_email: '담당자 이메일',
      manager_email_placeholder: '담당자 이메일 주소를 입력해 주세요.',
      announcement: {
        explanation:
          "'협업 제안하기'는 브랜드가 협업을 희망하는 크리에이터를 선택하고 <strong>브랜드 커머스 협업을 제안하기 위한 페이지</strong> 입니다.",
        response:
          '협업 제안하기를 통해 제안 내용을 작성해 주시면 <strong>마플샵 담당자가 검토 후 5영업일 이내</strong> 기재해주신 연락처로 답변드리겠습니다.',
        rejection: '크리에이터의 의사에 따라 제안하신 내용은 반려될 수 있습니다.',
        apply:
          '마플샵 크리에이터 입점을 희망하시면, <a href="{{href}}">마플샵 크리에이터 신청하기</a>를 이용해주세요.',
      },
      type: {
        group_buy: '공동 구매',
        ads: '광고',
        live: '라이브 방송',
        tiktok: '해외 틱톡샵',
        youtube: '해외 유튜브 쇼핑',
      },
      category: {
        food: '푸드',
        beauty: '뷰티',
        fashion_accessory: '패션/악세사리',
        electronics: '가전/전자기기',
        home_living: '홈/리빙',
        pets: '반려동물',
        sports: '스포츠',
        travel: '여행',
        etc: '기타',
      },
      alert: {
        success_title: '협업 제안 완료',
        success_description:
          '5영업일 이내 입력하신 연락처로 답변드릴 예정입니다.\n크리에이터의 의사 등에 따라 반려될 수 있는 점\n참고해주세요.',
      },
      cancel: '취소',
      proposal_collaboration: '협업 제안하기',
    },
    section_title: {
      plugin: {
        soldout_label: '품절 상품 제외',
        see_more: '더보기',
      },
      section_tabs: {
        popup_store: '팝업',
        curation: '큐레이션',
        creator_view: '크리에이터 뷰',
        creator_ranking: '크리에이터 랭킹',
        plus_shop: '플러스샵',
        creator_search: '크리에이터',
        photo_review: '포토 리뷰',
        partners: '파트너스',
      },
      sub_title: {
        popup_store: '오직 마플샵에서만 만날 수 있는',
        creator_ranking: '다양한 크리에이터의 매력 폭발!',
        creator_search: '내 취향의 크리에이터 발견!',
        plus_shop: '마플샵에서 만나는 공식 굿즈',
        latest_curation: '최신 큐레이션',
        latest_creator_view: '최신 크리에이터 뷰',
        latest_contents: '최신 콘텐츠',
        creator_product: '크리에이터 상품',
        partners: '마플샵의 공식 크리에이터',
      },
    },
    partners: {
      apply_button: '파트너스 지원하기',
      apply_sub_title: '마플샵 굿즈 파트너스',
      apply_sub_title_mo: '굿즈로 연결되는 창작의 세계',
      apply_title: '마플샵의 공식 파트너<br />크리에이터를 소개합니다!',
      apply_title_mo: '마플샵의 공식<br />파트너 크리에이터',
      apply_description:
        '크리에이터는 콘텐츠 제작에만 몰입하고,<br />마플샵이 기획부터 판매까지 모든 과정을 지원합니다.',
      footer_apply_title: '나도 파트너스에 도전해볼까?',
      footer_apply_description: '지금 바로 마플샵과 함께 당신의 세계를 굿즈로 펼쳐보세요.',
    },
    creator_summary: {
      compact:
        '<div><span>팬</span></div><div><b data-user-count class="{{bold}}">{{cart_user_count}}</b><span>명이 장바구니에</span></div><div><b data-product-count class="{{bold}}">{{cart_product_count}}</b><span>개를 담는 중!</span></div>',
      normal:
        '<div><b data-user-count class="{{bold}}">{{cart_user_count}}</b><span>명이</span></div><div><b class="{{bold}}">{{name}}</b><span>의 상품</span></div><div><b data-product-count class="{{bold}}">{{cart_product_count}}</b><span>개를 담는 중!</span></div>',
      fan: '팬',
      fan_letter: '팬레터',
      like_count: '명',
      fan_letter_count: '<span>{{fan_letter_count}}</span><span>개</span>',
      category_none: '미분류',
      not_cart_summary:
        '<div><b class="{{bold}}">{{name}}</b><span>의 상품을 장바구니에 담아주세요!</span></div>',
    },
    creator_search: {
      search_result: '에 대한 <span class="{{klass}}">{{search_count}}개</span>의 검색 결과',
      search_module: {
        title: '마플샵 크리에이터에 대한 모든 것',
        sub_title: '명의<br />크리에이터를 만나보세요!',
        sub_title_mo: '명의 크리에이터를<br />만나보세요!',
        place_holder: '크리에이터 이름을 입력해 주세요.',
        recent_search: '최근 검색어',
        delete_auto_completes: '전체 삭제',
      },
      card: {
        fan: '팬',
        fan_letter: '팬레터',
        ranking: '마플샵 랭킹',
        shop_button_label: '샵 바로가기',
        proposal_button_label: '협업 제안하기',
      },
    },
  },
  콘텐츠: '콘텐츠',
  의류: '의류',
  스포츠: '스포츠',
  굿즈: '굿즈',
  스티커: '스티커',
  패션잡화: '패션잡화',
  '토이/취미': '토이/취미',
  '쿠션/패브릭': '쿠션/패브릭',
  '폰 악세서리': '폰 악세서리',
  '문구/오피스': '문구/오피스',
  키즈: '키즈',
  애견: '애견',
  리빙: '리빙',
  '디지털/전자책': '디지털/전자책',
  액자: '액자',
  '도서/음반': '도서/음반',
  핸드메이드: '핸드메이드',
  식품: '식품',
  withdrawal: {
    title: '회원 탈퇴',
    '고객님 마플샵을 정말 탈퇴하시나요?': '고객님 마플 ・ 마플샵을 정말 탈퇴하시나요? 😢',
    '회원 탈퇴 전 아래 사항을 숙지해 주세요.': '회원 탈퇴 전 아래 사항을 숙지해 주세요.',
    description_1:
      '일반 회원인 경우, 회원 탈퇴 후 재가입이 가능하지만 구매하신 컨텐츠 / 주문 내역 / 정기결제 중인 멤버십 / 보유 포인트 등 회원 정보가 모두 삭제됩니다.',
    description_2:
      '마플샵 크리에이터인 경우, <b>진행 중인 거래 0건, 잔여 수익 금액 0원</b>이어야 하며, 판매 상품의 배송 출고 / CS / 수익 정산이 모두 완료됐고, <b>판매 중인 멤버십이 없는 경우</b>에<br/>탈퇴가 가능합니다. 탈퇴 후에는 크리에이터샵과 상품 판매 / 정산 내역 등 회원 정보가 모두 삭제되며 복구할 수 없습니다.',
    description_3:
      '탈퇴하시더라도 이미 구매하신 상품은 정상 배송 처리되며, 고객님의 개인 정보는 회원 탈퇴 후에도 상품 반품 및 A/S를 위해 「전자상거래 등에서의 소비자 보호에 관한 법률」에 의거한 마플・마플샵 고객 정보 보호 정책에 따라 관리됩니다.',
    description_4:
      '탈퇴 진행이 어려우신 경우, 고객 센터(<a href="tel:{{tel}}">{{tel}}</a> 또는\n<a href="mailto:{{email}}">{{email}}</a>)로 문의해 주시면 안내해 드리겠습니다.',
    '진행 중인 거래': '진행 중인 거래',
    몇건: '{{count}}건',
    '잔여 수익 금액': '잔여 수익 금액',
    몇원: '{{amount}}원',
    '보유 포인트': '보유 포인트',
    몇포인트: '{{point}}P',
    그동안:
      '그동안 MCO를 이용해 주셔서 감사합니다.<br/>보다 나은 서비스로 고객님을 다시 뵐 수 있도록 노력하겠습니다.',
    취소: '취소',
    탈퇴하기: '탈퇴하기',
    '정말 탈퇴하시겠어요?': '정말 탈퇴하시겠어요?',
    '모든 회원 정보는 즉시 삭제':
      '모든 회원 정보는 즉시 삭제되며, 복구가 불가합니다.<br/>계속해서 탈퇴를 진행하시겠습니까?',
    네: '네',
    실패: '실패',
    '회원 탈퇴 완료': '회원 탈퇴 완료',
    '회원 탈퇴 불가': '회원 탈퇴 불가',
    '진행 중인 거래 0건':
      '진행 중인 거래 \'0건\', 판매 중인 멤버십 \'0개\', 잔여 수익 금액 \'0원\'이어야만 회원 탈퇴가 가능합니다. 자세한 사항은 마플샵 스튜디오에서 확인 부탁드리며 진행이 어려우신 경우,<br/><a href="tel:{{tel}}" style="color: #1C75FF;">{{tel}}</a> 또는\n<a href="mailto:{{email}}" style="color: #1C75FF;">{{email}}</a>로<br/>문의해 주시면 안내해 드리겠습니다.',
    alert_content:
      '그동안 MCO를 이용해 주셔서 감사합니다.<br/>보다 나은 서비스로 다시 뵐 수 있도록 노력하겠습니다.',
    membership: '판매 중인 멤버십',
    몇개: '{{count}}개',
  },
  maker: {
    icon: {
      custom_asset: 'Custom Asset',
      status_txt1: '사용중인 테마',
      custom_user_asset: 'Custom User Asset',
    },
  },
  labs: {
    setting: {
      info: '캐릭터 설정값이 상품에 반영되기까지 시간이 지연될 수 있습니다.',
    },
    my_characters: {
      desc: '캐릭터 선택창 액자와 함께 구매할 내 캐릭터를 선택해주세요. (최대 10개까지 선택 가능)',
      desc_mo: '캐릭터 선택창 액자와 함께 구매할 내 캐릭터를<br /> 선택해주세요. (최대 10개까지 선택 가능)',
      alert: {
        alert_1: '캐릭터는 최대 10개까지선택 할 수 있어요.',
        alert_1_mo: '캐릭터는 최대 10개까지 <br />선택 할 수 있어요.',
      },
    },
    main: {
      login_1: '나만의 메이플스토리 제품을 구매하기 위해서는',
      login_2: '로그인이 필요해요!',
      login_3: '로그인하러가기 →',
      no_chracter_1: '고객님의 메이플스토리 캐릭터가 존재하지 않아요!',
      no_chracter_1_1: '고객님의 메이플스토리 캐릭터 정보를 확인할 수 없어요!',
      no_chracter_2: '넥슨 계정 확인 후 다시 시도해 주세요.',
      change_button: '캐릭터 감정 / 모션 바꾸기',
    },
    error: {
      collabo_1:
        '콜라보 아이템 착용으로 캐릭터가 로드되지 않았습니다.<br/>상품을 구매하기 위해 콜라보 아이템 해제 후 아래의 버튼을 눌러주세요!',
      reload: '캐릭터 리로드',
      title: '아이템 로드 불가',
      message:
        '제휴 및 계약상 실물 제작이 불가능한 아이템을 <br/>장착한 캐릭터는 불러올 수 없어요.</br>게임에 접속하시어 아래 아이템을 해제한 후</br>다시 시도해주세요.',
      item_name: '아이템명',
      notice:
        '지속적으로 동일한 문제 발생 시 1566-7960 혹은<br/><span style="text-decoration: underline; text-decoration-skip-ink : none; text-underline-position :from-font ">nexon@marpple.com</span>으로 문의 바랍니다.',
      special_world: {
        title: '스페셜 월드 캐릭터 로드 불가',
        message: '스페셜 월드의 캐릭터는 불러올 수 없어요.',
        name: '캐릭터명',
      },
      character_load: {
        title: '캐릭터 로드 실패',
        message_1: '고객님의 메이플스토리 캐릭터 정보를<br>불러 올 수 없습니다.',
        message_2: '캐릭터 정보 확인 후 재시도 해주세요.',
      },
    },
    reload: {
      message: '최근 접속 기준 최대 50개의 캐릭터가 노출됩니다.',
      button: '캐릭터 리로드',
    },
    can_not_load: {
      title: '캐릭터 로드 불가',
      message:
        '마지막 접속일이 23년 12월 21일 이후인 캐릭터만 불러올 수 있습니다.<br />캐릭터를 로드하시려면 게임에 접속해주세요',
      last_date: '마지막 접속일',
    },
    character_not_selected: {
      message: '캐릭터 선택을 위해<br/>LABS 홈으로 이동합니다.',
    },
  },
  admin: {
    in_review_title: '크리에이터 심사',
    in_review_desc: '심사 대기 중인 신청자를 검토하고, 합격/불합격 처리를 할 수 있는 심사 페이지입니다.',
  },
  creator_shop: {
    home: {
      title: '샵홈',
    },
    common: {
      all_count: '총 {{-count_text}}개',
    },
    section_title: {
      products: '굿즈 상품',
      reviews: '리뷰',
      fundings: '펀딩 상품',
      goods_products: '굿즈 상품',
      handmade_products: '핸드메이드 상품',
      brand_deal_products: '브랜드딜 상품',
      ebook_products: '전자책 상품',
    },
    fan_letters: {
      title: '팬레터',
      placeholder_pc_login: '좋아하는 크리에이터에게&#13;&#10;마음을 담은 팬레터를 보내보세요!',
      placeholder_pc_logout:
        '팬레터는 로그인 후 작성할 수 있어요.&#13;&#10;로그인하고 마음을 전하러 가볼까요?',
      placeholder_mo_login: '마음을 담은 팬레터를 보내보세요!',
      placeholder_mo_logout: '로그인하고 마음을 담은 팬레터를 보내보세요!',
      pd_title:
        '현재&nbsp;<span class="pd-contents__fan-letter-preview-blue">{{like_count}}</span>명의 팬들이 응원 중!</span>',
      pd_title_zero: '팬들이 크리에이터를 응원 중!',
      pd_title_02: ' 에게 보내는 팬레터',
      replies: '댓글 {{comment_count}}개',
      write: '응원 남기기',
      fake: {
        nickname1: '반짝이는 마럽이',
        body1: '감동을 주는 나의 크리에이터!<br />덕분에 매일이 반짝반짝 빛나요!',
        nickname2: '응원하는 마럽이',
        body2: '최애 덕분에 세상이 아름다워요!<br />언제나 응원할게요. 사랑해요!',
        nickname3: '설레는 마럽이',
        body3: '너무 좋아서 계속 보게 돼요!<br />언제나 설레는 작품 감사합니다!',
      },
      hidden_user: '비활성화된 계정',
    },
    creator_notes: {
      title: '크리에이터 한마디',
    },
    profile: {
      fan: '팬',
      become: '팬 맺기',
      became: '응원 중',
      expand_more: '더보기',
      expand_less: '간략히 보기',
      popular_title: '마플샵 인기 랭킹',
      popular_title_mo: '인기 랭킹',
      rank: '{{- rank}}<span class="{{klass}}">위</span>',
    },
    sns_icon: {
      youtube: '유튜브',
      instagram: '인스타그램',
      grafolio: '그라폴리오',
      facebook: '페이스북',
      twitch: '트위치',
      twitter: '트위터',
      x: '엑스',
      comic_naver: '네이버 웹툰',
      kakao_page: '카카오페이지',
      daum_webtoon: '다음 웹툰',
      blog: '네이버 블로그',
      ticktok: '틱톡',
      behance: '비핸스',
      brunch: '브런치',
      spooncast: '스푼캐스트',
      daum_cafe: '다음 카페',
      chzzk: '치지직',
      afreecatv: '아프리카TV',
      ciety: '사이어티',
      website: '웹사이트',
    },
    creator_main_banner: {
      ranking_unit: '위',
      see_more: '더보기',
      the_other_links: '외 링크 {{count}}개',
      profile_edit: '프로필 편집',
      monthly_ranking: '{{month}}월 랭킹 {{ranking}}위',
      weekly_ranking: '{{month}}월 {{week}}주 랭킹 {{ranking}}위',
      realtime_ranking: '실시간 랭킹 {{ranking}}위',
    },
    home_modal: {
      monthly_ranking: '월간 랭킹 {{ranking}}위',
      weekly_ranking: '주간 랭킹 {{ranking}}위',
      realtime_ranking: '실시간 랭킹 {{ranking}}위',
      monthly_recorded_at: '{{year}}년 {{month}}월',
      weekly_recorded_at: '{{year}}년 {{month}}월 {{week}}주차',
      realtime_recorded_at: '{{minute}}분 전 업데이트',
    },
    fan_service: '팬서비스',
    lnb_creator_shop: {
      shophome: '샵홈',
      funding: '펀딩',
      goods: '굿즈',
      handmade: '핸드메이드',
      branddeal: '브랜드딜',
      ebook: '전자책',
      membership: '멤버십',
      commission: '커미션',
      support: '후원',
      fanletter: '팬레터',
      review: '리뷰',
    },
    banner_and_profile_edit_modal: {
      banner_and_profile_edit: '배너 및 프로필 변경',
      mo_banner_image_upload_description: '3:2 비율 | 가로 750px 이상 | JPG, JPEG, PNG 가능 | 최대 1MB',
    },
    realtime_ranking: '실시간 랭킹',
  },
  브랜드딜: '브랜드딜',
  cast_on_air: {
    creator_on_air: '크리에이터 온에어',
  },
  settings_arrangement: {
    goods: '굿즈',
    handmade: '핸드메이드',
    brand_deal: '브랜드딜',
    ebook: '전자책',
    page_title: '정렬 순서',
    description: '드래그 앤 드롭으로 순서를 변경해 보세요.',
  },
  curation: {
    gnb: {
      menu_title: '큐레이션',
    },
    curation_list: {
      sub_copy_text: '마플샵이 주목하는 트렌드',
      main_copy_text: '큐레이션',
    },
    main_page_curation_list_view: {
      section_title_text: '마플샵 큐레이션',
      see_more: '더보기',
    },
    curation_detail_page: {
      related_products: '관련 상품',
      section_title: '최신 큐레이션',
      section_control_text: '더보기',
      button_text: '더보기',
    },
    latest_curation_feed_page: {
      detached_tab_text: '더 많은 큐레이션',
      curation_products_text: '관련 상품',
      section_title: '최신 큐레이션',
      button_text: '더보기',
    },
  },
  card_product: {
    badge_main: {
      trend: '급상승',
      popular: '인기',
      stock_left: '{{count}}개 남음',
      time_left_until_end: '종료까지',
      time_left_seconds: '{{seconds}}초',
      time_left_minutes: '<span>{{minutes}}</span><span>분 후 종료</span>',
      time_left_hours: '<span>{{hours}}</span><span>시간 후 종료</span>',
      days_left: '{{days}}일 남음',
      limited: '{{quantity}}개 한정',
      free_shipping: '무료배송',
      just_sold_seconds: '{{seconds}}초',
      just_sold_minutes: '{{minutes}}분',
      just_sold_hours: '{{hours}}시간',
      just_sold_ago: '전 판매',
    },
    badge_sub: {
      free_shipping: '무료배송',
      time_left_until_end: '종료까지',
      time_left_seconds: '{{seconds}}초',
      time_left_minutes: '<span>{{minutes}}</span><span>분 후 종료</span>',
      time_left_hours: '<span>{{hours}}</span><span>시간 후 종료</span>',
      time_left_days: '<span>{{days}}</span><span>일 후 종료</span>',
      stock_left: '{{count}}개 남음',
      popular: '인기',
      limited: '{{quantity}}개 한정',
      trend: '급상승',
    },
    count_view: {
      watching: '{{watcher_count}}명이 보는 중',
    },
    realtime: {
      seconds: '{{seconds}}초',
      minutes: '{{minutes}}분',
      hours: '{{hours}}시간',
      days: '{{days}}일',
      sold_ago: '전에 판매됐어요!',
    },
    review: {
      review: '리뷰',
    },
    shop: {
      watching: '{{watcher_count}}명이 보는 중',
    },
  },
  studio_kakao: {
    studio_usage_inquiry: '스튜디오 사용 문의',
    operation_know_how: '마플샵 운영 노하우',
  },
  studio_quick_guide: {
    studio_first_banner: {
      title: '4주 100만원 챌린지 메이트',
      description: '챌린지 메이트 신청하면</br>내 샵 마케팅 A-Z 지원해 드려요',
    },
    offline_popup_store: {
      title: '오프라인 팝업스토어',
      description: '팝업스토어 성지, 성수동에서<br />특별한 공간을 운영해 보세요!',
    },
    youtube_shopping: {
      title: '유튜브 쇼핑 연동',
      description: '유튜브 채널에서 마플샵 상품을<br />판매해 보세요!',
    },
    additional_fee_closed: {
      title: '마플샵제작배송 상품<br />추가 수익 종료',
      description: '11월 3일 판매건부터 적용됩니다.',
    },
    additional_fee_change: {
      title: '운영 정책 변경 안내',
      description: '마플샵제작배송 상품의 추가 수익 제공이<br/> 종료됩니다(11월 3일 판매건부터 적용)',
    },
  },
  ad_res_finish_page: {
    kakao_guide: {
      description:
        '카카오 채널을 추가하시면 크리에이터 활동에 필요한<br />서비스 소식, 신규 기능, 상품 정보, 성장 노하우를 가장 빠르게 알 수 있어요.',
      button_40_text: '마플샵 크리에이터 추가하기',
      description_mo: '카카오 채널에서 크리에이터 소식과<br />성장 노하우를 가장 먼저 만나보세요.',
      button_40_text_mo: '추가하기',
    },
  },
  creator_view: {
    related_products: '관련 상품',
    latest_creator_view: '최신 크리에이터 뷰',
    see_more: '더보기',
  },
  preorder: {
    notable_pre_order_challenges: '주목할 만한 프리오더 챌린지',
    challenge: '챌린지',
    section_title_pre_order_challenge: '프리오더 챌린지',
    lnb_pre_order_challenge: '프리오더 챌린지',
    gnb_pre_order_challenge: '프리오더 챌린지',
    cta_participate_in_the_challenge: '챌린지 참여하기',
    cta_challenge_end: '챌린지가 종료되었어요!',
    participated: '{{nickname}}님이 참여했어요.',
    challenge_success: '챌린지 성공',
    challenge_failed: '챌린지 종료',
  },
  digital_product_payment_completed: {
    receipt: {
      marppleshop_home: '마플샵 홈',
      order_list: '구매 내역',
      order_completed: '주문 완료',
      payment_completed: '결제가 완료되었습니다.',
      please_deposit_money: '{{month}}월 {{day}}일 {{hour}}시 {{minute}}분까지 입금해 주세요.',
      share_it: '구매 인증 카드를 다운로드해서 친구들과 공유해 보세요!',
      download_now: '지금 바로 파일을 다운로드해 보세요.',
      description_text_imp: '입금 완료 후 마이페이지의 구매내역에서 다운로드해 주세요.',
      description_text:
        '결제를 완료한 디지털·전자책 상품은 마이페이지의 구매 내역에서 기한 내 다운로드 받을 수 있습니다.',
      download: '다운로드',
    },
  },
  delivery_lead_time: {
    delivery_policy: {
      shipping_departure_date: '배송 출발일',
      select_departure_date: '출발일 선택',
      same_day_shipping: '당일 배송',
      within_business_days: '{{business_day}} 영업일 이내',
      hour: '{{cutoff_time}}시',
      upon_completion_of_payment: '결제 완료 후',
    },
    product_detail: {
      ship_date_title: '배송 출발',
      ship_date_specific_date: '부터 주문순으로 출발 예정',
      ship_date_same_day: '오늘({{day}}) 출발 예정',
      ship_date_same_day_cutoff_time: '{{cutoff_time}} 이내 결제 시',
      ship_date_same_day_after: '출발 예정',
      sales_period_title: '판매 기간',
      sales_period_from: '부터 판매',
      sales_period_end: '까지 판매',
    },
  },
};
